/// <reference path="core.ts"/>

namespace ts {
    export const 内置英汉键值映射: Map<string> = createMapFromTemplate({
        'string': '文字',
        'number': '数字',
        'symbol': '符号',
        'function': '函数',
        'boolean': '真假',
        'null': '空',
        'true': '真',
        'false': '假',
        'void': '无值',
        'never': '不可及',
        'object': '基对象',
        '__type': '__类型',
        'unknown': '未知的',
        'untyped': `类型化`,
        '__resolving__': '__解决中__',
        'any': '通用型',
        'arguments': '增强参数集',
        '__computed': '__计算',
        '__object': '__基对象',
        '__function': '__函数',
        '__jsxAttributes': '__jsx属性',
        'arg': '参数',
        'export=': '导出=',
        '__export': '__导出',
        '__index': '__索引',
        '__new': '__新建',
        '__call': '__调用',
        '__constructor': '__构造器',
        '__global': '__全局',
        '__class': '__类',
        '__missing': '__失踪节点',
        'default': '默认',
        'prototype': '原型',
        'exports': '导出集',
        'ThisType': '本对象类型类',
        'Array': '数组类',
        'Object': '基对象类',
        'Function': '函数类',
        'String': '文字类',
        'Number': '数字类',
        'Boolean': '真假类',
        'RegExp': '正则表达式类',
        'abstract': '抽象',
        'as': '转为',
        'break': '跳出',
        'case': '为',
        'catch': '捕获',
        'class': '类',
        'continue': '继续',
        'const': '常量',
        'constructor': '构造器',
        'debugger': '调试',
        'declare': '声明',
        'delete': '删除',
        'do': '开始',
        'else': '否则',
        'enum': '枚举',
        'export': '导出',
        'extends': '扩展',
        'finally': '最后',
        'for': '循环',
        'from': '从',
        'get': '取',
        'if': '如果',
        'implements': '实现',
        'import': '引入',
        'in': '在',
        'instanceof': '类为',
        'interface': '接口',
        'is': '是',
        'keyof': '键为',
        'let': '变量',
        'module': '模块',
        'namespace': '名称空间',
        'new': '新建',
        'package': '包',
        'private': '私有',
        'protected': '保护',
        'public': '公开',
        'readonly': '只读',
        'require': '需要',
        'global': '全局',
        'return': '返回',
        'set': '置',
        'static': '静态',
        'super': '父构造器',
        'switch': '假如',
        'this': '本对象',
        'throw': '抛出',
        'try': '尝试',
        'type': '类型',
        'typeof': '类型为',
        'var': '自由变量',
        'while': '判断循环',
        'with': '外扩',
        'yield': '获得',
        'async': '异步',
        'await': '等待',
        'of': '属于',
        'IArguments': '所有参数接口',
        'ReadonlyArray': '只读数组类',
    })

    export const 内置JSDoc标签名 = createMapFromTemplate({
        "@type": "@类型",
        "@typedef": "@自定义类型",
        "@prop": "@属性",
        "@property": "@属性",
        "@arg": "@参数",
        "@param": "@参数",
        "@augments": "@增强参数集",
        "@augment": "@增强参数",
        "@return": "@返回",
        "@returns": "@返回",
        "@class": "@类",
        "@constructor": "@构造函数",
        "@template": "@模板",
    })

    export const 内置汉英词典键值映射: Map<string> = createMapFromTemplate({
        "__计算": "__computed",
        "__基对象": "__object",
        "__函数": "__function",
        "__jsx属性": "__jsxAttributes",
        "参数": "arg",
        "导出=": "export=",
        "__导出": "__export",
        "__索引": "__index",
        "__新建": "__new",
        "__调用": "__call",
        "__构造器": "__constructor",
        "__全局": "__global",
        "__类": "__class",
        "__失踪节点": "__missing",
        "默认": "default",
        "__类型": "__type",
        "原型": "prototype",
        "文字": "string",
        "数字": "number",
        "符号": "symbol",
        "函数": "function",
        "真假": "boolean",
        "空": "null",
        "真": "true",
        "假": "false",
        "无值": "void",
        "不可及": "never",
        "基对象": "object",
        "未知的": "unknown",
        "类型化": "untyped",
        "__解决中__": "__resolving__",
        "通用型": "any",
        "增强参数集": "arguments",
        "抽象": "abstract",
        "转为": "as",
        "跳出": "break",
        "为": "case",
        "捕获": "catch",
        "类": "class",
        "继续": "continue",
        "常量": "const",
        "构造器": "constructor",
        "调试": "debugger",
        "声明": "declare",
        "删除": "delete",
        "开始": "do",
        "否则": "else",
        "枚举": "enum",
        "导出": "export",
        "扩展": "extends",
        "最后": "finally",
        "循环": "for",
        "从": "from",
        "取": "get",
        "如果": "if",
        "实现": "implements",
        "引入": "import",
        "在": "in",
        "类为": "instanceof",
        "接口": "interface",
        "是": "is",
        "键为": "keyof",
        "变量": "let",
        "模块": "module",
        "名称空间": "namespace",
        "新建": "new",
        "包": "package",
        "私有": "private",
        "保护": "protected",
        "公开": "public",
        "只读": "readonly",
        "需要": "require",
        "全局": "global",
        "返回": "return",
        "置": "set",
        "静态": "static",
        "父构造器": "super",
        "假如": "switch",
        "本对象": "this",
        "抛出": "throw",
        "尝试": "try",
        "类型": "type",
        "类型为": "typeof",
        "自由变量": "var",
        "判断循环": "while",
        "外扩": "with",
        "获得": "yield",
        "异步": "async",
        "等待": "await",
        "属于": "of",
        "数组类": "Array",
        "基对象类": "Object",
        "函数类": "Function",
        "文字类": "String",
        "数字类": "Number",
        "真假类": "Boolean",
        "正则表达式类": "RegExp",
        "只读数组类": "ReadonlyArray",
        "所有参数接口": "IArguments",
        "IArguments": "所有参数接口",
        "ReadonlyArray": "只读数组类",
        "本对象类型类": "ThisType",
        "导出集": "exports",
        "非数字": "NaN",
        "无穷大": "Infinity",
        "执行": "eval",
        "编译整数": "parseInt",
        "编译浮点数": "parseFloat",
        "是非数字": "isNaN",
        "是有限": "isFinite",
        "解码URI": "decodeURI",
        "编码出URI": "encodedURI",
        "解码出URI组件": "decodeURIComponent",
        "编码出URI组件": "encodedURIComponent",
        "编码URI": "encodeURI",
        "编码URI组件": "encodeURIComponent",
        "URI组件": "uriComponent",
        "属性描述": "PropertyDescriptor",
        "可配置": "configurable",
        "可枚举": "enumerable",
        "值": "value",
        "可写": "writable",
        "属性描述映射": "PropertyDescriptorMap",
        "删除线": "s",
        "转成文字": "toString",
        "转成本地文字": "toLocaleString",
        "值的": "valueOf",
        "有本身属性": "hasOwnProperty",
        "是原型": "isPrototypeOf",
        "属性是可枚举": "propertyIsEnumerable",
        "基对象类构造器": "ObjectConstructor",
        "取属性": "getPrototypeOf",
        "取本身属性描述": "getOwnPropertyDescriptor",
        "段落": "p",
        "取本身属性名称集": "getOwnPropertyNames",
        "创建": "create",
        "属性集": "properties",
        "本对象类类型": "ThisType",
        "定义属性": "defineProperty",
        "特性集": "attributes",
        "定义属性集": "defineProperties",
        "密封": "seal",
        "冻结": "freeze",
        "锚": "a",
        "只读数组": "ReadonlyArray",
        "只读类": "Readonly",
        "防止扩展": "preventExtensions",
        "是密封": "isSealed",
        "是冻结": "isFrozen",
        "是可扩展": "isExtensible",
        "键集": "keys",
        "应用": "apply",
        "本对象参数": "thisArg",
        "参数数组": "argArray",
        "调用": "call",
        "绑定": "bind",
        "长度": "length",
        "调用者": "caller",
        "函数类构造器": "FunctionConstructor",
        "参数值集": "args",
        "索引": "index",
        "被调用者": "callee",
        "字符在": "charAt",
        "首": "pos",
        "字符编码在": "charCodeAt",
        "合并": "concat",
        "文字集": "strings",
        "索引的": "indexOf",
        "搜索文字": "searchString",
        "位置点": "position",
        "最后索引": "lastIndexOf",
        "本地比较": "localeCompare",
        "那": "that",
        "匹配": "match",
        "正则表达式": "regexp",
        "正则表达式匹配数组": "RegExpMatchArray",
        "替换": "replace",
        "搜索值": "searchValue",
        "替换值": "replaceValue",
        "替换者": "replacer",
        "搜索": "search",
        "分割": "slice",
        "始位": "start",
        "结尾": "end",
        "分组": "split",
        "分组符": "separator",
        "限制": "limit",
        "子文字": "substring",
        "转成小写": "toLowerCase",
        "转成本地小写": "toLocaleLowerCase",
        "转成大写": "toUpperCase",
        "转成本地大写": "toLocaleUpperCase",
        "修剪": "trim",
        "子字符": "substr",
        "文字类构造器": "StringConstructor",
        "从字符编码": "fromCharCode",
        "代码集": "codes",
        "真假类构造器": "BooleanConstructor",
        "基数": "radix",
        "转成指定位小数": "toFixed",
        "小数位数": "fractionDigits",
        "转成科学计数法": "toExponential",
        "转成科学计数法按精度指数": "toPrecision",
        "精度指数": "precision",
        "数字构造器": "NumberConstructor",
        "最_大_值": "MAX_VALUE",
        "最_小_值": "MIN_VALUE",
        "负_无穷大": "NEGATIVE_INFINITY",
        "正_无穷大": "POSITIVE_INFINITY",
        "模板文字数组类": "TemplateStringsArray",
        "原始值": "raw",
        "数学类": "Math",
        "自然对数底数": "E",
        "自然对数_10": "LN10",
        "自然对数_2": "LN2",
        "长底数_2E": "LOG2E",
        "长底数_10E": "LOG10E",
        "圆周率_": "PI",
        "平方根1_2": "SQRT1_2",
        "平方根_2": "SQRT2",
        "绝对值": "abs",
        "反余弦值": "acos",
        "反正弦值": "asin",
        "反正切值": "atan",
        "角度": "atan2",
        "上舍入": "ceil",
        "余弦": "cos",
        "次冥": "exp",
        "下舍入": "floor",
        "日志": "log",
        "最大": "max",
        "值集": "values",
        "最小": "min",
        "指数幂": "pow",
        "随机数": "random",
        "四舍五入": "round",
        "正弦": "sin",
        "平方根": "sqrt",
        "正切": "tan",
        "时间日期类": "Date",
        "转成时间日期文字": "toDateString",
        "转成时间文字": "toTimeString",
        "转成本地时间日期文字": "toLocaleDateString",
        "转成本地时间文字": "toLocaleTimeString",
        "取时间": "getTime",
        "取全部年": "getFullYear",
        "取UTC全年": "getUTCFullYear",
        "取月份": "getMonth",
        "取UTC月份": "getUTCMonth",
        "取时间日期": "getDate",
        "取UTC时间日期": "getUTCDate",
        "取天": "getDay",
        "取UTC天": "getUTCDay",
        "取小时": "getHours",
        "取UTC小时": "getUTCHours",
        "取分钟": "getMinutes",
        "取UTC分钟": "getUTCMinutes",
        "取秒": "getSeconds",
        "取UTC秒": "getUTCSeconds",
        "取毫秒": "getMilliseconds",
        "取UTC毫秒": "getUTCMilliseconds",
        "取时区偏移量": "getTimezoneOffset",
        "置时间": "setTime",
        "时间": "time",
        "置毫秒": "setMilliseconds",
        "毫秒数": "ms",
        "置UTC毫秒": "setUTCMilliseconds",
        "置秒": "setSeconds",
        "秒数": "sec",
        "置UTC秒": "setUTCSeconds",
        "置分": "setMinutes",
        "置UTC分": "setUTCMinutes",
        "置小时": "setHours",
        "小时数": "hours",
        "置UTC小时": "setUTCHours",
        "置时间日期": "setDate",
        "时日": "date",
        "置UTC时间日期": "setUTCDate",
        "置月": "setMonth",
        "月数": "month",
        "置UTC月": "setUTCMonth",
        "置全年": "setFullYear",
        "年数": "year",
        "置UTC全年": "setUTCFullYear",
        "转成UTC文字": "toUTCString",
        "转成ISO文字": "toISOString",
        "JSON数据类": "JSON",
        "转成JSON": "toJSON",
        "键": "key",
        "时间日期构造器": "DateConstructor",
        "分钟数": "minutes",
        "秒钟数": "seconds",
        "编译": "parse",
        "现在": "now",
        "输入": "input",
        "正则表达式执行数组": "RegExpExecArray",
        "实行": "exec",
        "测试": "test",
        "源头": "source",
        "指标": "ignoreCase",
        "多行": "multiline",
        "最后一个索引": "lastIndex",
        "解析": "compile",
        "正则表达式构造器": "RegExpConstructor",
        "模式": "pattern",
        "标志集": "flags",
        "最后匹配": "lastMatch",
        "错误类": "Error",
        "名字": "name",
        "消息": "message",
        "堆栈": "stack",
        "错误类构造器": "ErrorConstructor",
        "检查错误": "EvalError",
        "检查错误构造器": "EvalErrorConstructor",
        "范围错误": "RangeError",
        "范围错误构造器": "RangeErrorConstructor",
        "引用错误类": "ReferenceError",
        "引用错误构造器": "ReferenceErrorConstructor",
        "语法错误": "SyntaxError",
        "语法错误构造器": "SyntaxErrorConstructor",
        "类型错误": "TypeError",
        "类型错误构造器": "TypeErrorConstructor",
        "URI错误": "URIError",
        "URI错误构造器": "URIErrorConstructor",
        "文本": "text",
        "编辑函数": "reviver",
        "序列化": "stringify",
        "空间": "space",
        "项目集": "items",
        "连接字符": "join",
        "搜索元素": "searchElement",
        "从索引": "fromIndex",
        "测试成员": "every",
        "回调函数": "callbackfn",
        "数组": "array",
        "筛选": "some",
        "循环执行": "forEach",
        "映射": "map",
        "过滤": "filter",
        "累计": "reduce",
        "以前值": "previousValue",
        "当前值": "currentValue",
        "当前索引": "currentIndex",
        "初始值": "initialValue",
        "降序累计": "reduceRight",
        "压入": "push",
        "返回删除最后一个": "pop",
        "反转": "reverse",
        "转移首元素": "shift",
        "排序": "sort",
        "比较回调": "compareFn",
        "粗体": "b",
        "更改": "splice",
        "删除数量": "deleteCount",
        "添加首元素": "unshift",
        "数组构造器": "ArrayConstructor",
        "数组长度": "arrayLength",
        "是数组": "isArray",
        "_参数": "arg",
        "类型属性描述符": "TypedPropertyDescriptor",
        "类描述符": "ClassDecorator",
        "T函数类": "TFunction",
        "目标": "target",
        "属性描述符": "PropertyDecorator",
        "属性键": "propertyKey",
        "方法描述符": "MethodDecorator",
        "描述符": "descriptor",
        "参数描述符": "ParameterDecorator",
        "参数索引": "parameterIndex",
        "预期类构造器描述": "PromiseConstructorLike",
        "执行者": "executor",
        "成功": "resolve",
        "预期类描述": "PromiseLike",
        "拒绝": "reject",
        "原因": "reason",
        "然后": "then",
        "T结果1": "TResult1",
        "T结果2": "TResult2",
        "引发完成了": "onfulfilled",
        "引发拒绝了": "onrejected",
        "预期类": "Promise",
        "T结果": "TResult",
        "数组类描述": "ArrayLike",
        "部分": "Partial",
        "挑选": "Pick",
        "记录": "Record",
        "数组缓冲区类": "ArrayBuffer",
        "字节长": "byteLength",
        "首位": "begin",
        "数组缓冲区类构造器": "ArrayBufferConstructor",
        "是视图": "isView",
        "数组缓冲区视图": "ArrayBufferView",
        "缓冲区": "buffer",
        "字节偏移": "byteOffset",
        "数据类视图": "DataView",
        "取浮点数32": "getFloat32",
        "从小到大排列": "littleEndian",
        "取浮点数64": "getFloat64",
        "取整数8": "getInt8",
        "取整数16": "getInt16",
        "取整数32": "getInt32",
        "取正整数8": "getUint8",
        "取正整数16": "getUint16",
        "取正整数32": "getUint32",
        "置浮点数32": "setFloat32",
        "置浮点数64": "setFloat64",
        "置整数8": "setInt8",
        "置整数16": "setInt16",
        "置整数32": "setInt32",
        "置正整数8": "setUint8",
        "置正整数16": "setUint16",
        "置正整数32": "setUint32",
        "数据类视图构造器": "DataViewConstructor",
        "整数8数组": "Int8Array",
        "每个_元素_大小": "BYTES_PER_ELEMENT",
        "复制范围": "copyWithin",
        "填充": "fill",
        "查找": "find",
        "判断回调": "predicate",
        "对象值": "obj",
        "查找索引": "findIndex",
        "偏移": "offset",
        "子数组": "subarray",
        "整数8数组构造器": "Int8ArrayConstructor",
        "数组描述": "arrayLike",
        "映射回调": "mapfn",
        "正整数8数组": "Uint8Array",
        "正整数8数组构造器": "Uint8ArrayConstructor",
        "正整数8钳位数组": "Uint8ClampedArray",
        "正整数8钳位数组构造器": "Uint8ClampedArrayConstructor",
        "整数16数组": "Int16Array",
        "整数16数组构造器": "Int16ArrayConstructor",
        "正整数16数组": "Uint16Array",
        "正整数16数组构造器": "Uint16ArrayConstructor",
        "整数32数组": "Int32Array",
        "整数32数组构造器": "Int32ArrayConstructor",
        "正整数32数组": "Uint32Array",
        "正整数32数组构造器": "Uint32ArrayConstructor",
        "浮点数32数组": "Float32Array",
        "浮点数32数组构造器": "Float32ArrayConstructor",
        "浮点数64数组": "Float64Array",
        "浮点数64数组构造器": "Float64ArrayConstructor",
        "国际": "Intl",
        "校对选项集": "CollatorOptions",
        "使用惯例": "usage",
        "地区匹配": "localeMatcher",
        "数值化": "numeric",
        "为第一个": "caseFirst",
        "敏感": "sensitivity",
        "忽略标点符号": "ignorePunctuation",
        "解析排序选项集": "ResolvedCollatorOptions",
        "本地区域": "locale",
        "核对": "collation",
        "校对类": "Collator",
        "比较": "compare",
        "解析选项集": "resolvedOptions",
        "本地集": "locales",
        "选项集": "options",
        "支持语言环境": "supportedLocalesOf",
        "数字格式选项集": "NumberFormatOptions",
        "样式": "style",
        "货币": "currency",
        "货币显示": "currencyDisplay",
        "使用分组": "useGrouping",
        "最小整数位数": "minimumIntegerDigits",
        "最近分数位数": "minimumFractionDigits",
        "最大分数位数": "maximumFractionDigits",
        "最小有效位数": "minimumSignificantDigits",
        "最大有效位数": "maximumSignificantDigits",
        "解析数字格式化选项集": "ResolvedNumberFormatOptions",
        "编号系统": "numberingSystem",
        "数字类格式化": "NumberFormat",
        "格式化": "format",
        "时间日期格式化选项集": "DateTimeFormatOptions",
        "周日": "weekday",
        "纪元": "era",
        "天数": "day",
        "小时": "hour",
        "分钟": "minute",
        "秒": "second",
        "时区名称": "timeZoneName",
        "格式化匹配": "formatMatcher",
        "时制12": "hour12",
        "时区": "timeZone",
        "解析时间日期格式化选项集": "ResolvedDateTimeFormatOptions",
        "日历": "calendar",
        "时间日期格式化": "DateTimeFormat",
        "帐户类": "Account",
        "反相显示名称": "rpDisplayName",
        "显示名称": "displayName",
        "图像URL": "imageURL",
        "算法类": "Algorithm",
        "动画事件类初始化": "AnimationEventInit",
        "事件类初始化": "EventInit",
        "动画名称": "animationName",
        "过程时间": "elapsedTime",
        "断言选项集": "AssertionOptions",
        "超时秒数": "timeoutSeconds",
        "反相Id": "rpId",
        "USV文字类": "USVString",
        "允许列表": "allowList",
        "作用域凭据描述符": "ScopedCredentialDescriptor",
        "扩展集": "extensions",
        "WEB认证扩展": "WebAuthnExtensions",
        "缓存查询选项集": "CacheQueryOptions",
        "忽略搜索": "ignoreSearch",
        "忽略方法": "ignoreMethod",
        "忽略不同": "ignoreVary",
        "缓存名称": "cacheName",
        "客户类数据": "ClientData",
        "口令": "challenge",
        "根源": "origin",
        "哈希算法": "hashAlg",
        "令牌绑定": "tokenBinding",
        "关闭事件初始化": "CloseEventInit",
        "清理过": "wasClean",
        "代码": "code",
        "复合事件初始化": "CompositionEventInit",
        "UI事件初始化": "UIEventInit",
        "数据": "data",
        "确认站点特定异常信息": "ConfirmSiteSpecificExceptionsInformation",
        "异常信息": "ExceptionInformation",
        "结构文字数组": "arrayOfDomainStrings",
        "参数集真假约束": "ConstrainBooleanParameters",
        "准确": "exact",
        "理想": "ideal",
        "DOM文字参数集约束": "ConstrainDOMStringParameters",
        "双精度范围约束": "ConstrainDoubleRange",
        "双精度范围": "DoubleRange",
        "长范围约束": "ConstrainLongRange",
        "长范围": "LongRange",
        "视频面向模式约束参数集": "ConstrainVideoFacingModeParameters",
        "自定义事件初始化": "CustomEventInit",
        "细节": "detail",
        "DOM矩形初始化": "DOMRectInit",
        "宽度": "width",
        "高度": "height",
        "失败假设代码": "DeviceAccelerationDict",
        "设备环境光事件初始化": "DeviceLightEventInit",
        "设备动作事件初始化": "DeviceMotionEventInit",
        "加速": "acceleration",
        "包括重力加速度": "accelerationIncludingGravity",
        "旋转速度": "rotationRate",
        "设备选择速度代码": "DeviceRotationRateDict",
        "间隔": "interval",
        "设备定位事件初始化": "DeviceOrientationEventInit",
        "透明通道": "alpha",
        "上": "beta",
        "东": "gamma",
        "是绝对值": "absolute",
        "错误类事件初始化": "ErrorEventInit",
        "文件名": "filename",
        "无行": "lineno",
        "无列": "colno",
        "错误": "error",
        "作用域": "scoped",
        "冒泡": "bubbles",
        "可撤销": "cancelable",
        "事件修饰符初始化": "EventModifierInit",
        "CTRL键": "ctrlKey",
        "SHIFT键": "shiftKey",
        "ALT键": "altKey",
        "META键": "metaKey",
        "修饰符ALTGR键": "modifierAltGraph",
        "修饰符大写锁定": "modifierCapsLock",
        "修饰符FN键": "modifierFn",
        "修饰符FN键锁定": "modifierFnLock",
        "修饰符超级": "modifierHyper",
        "修饰符数字锁定": "modifierNumLock",
        "修饰符OS": "modifierOS",
        "修饰符滚动锁定": "modifierScrollLock",
        "修饰符微调": "modifierSuper",
        "修饰符符号": "modifierSymbol",
        "修饰符符号锁定": "modifierSymbolLock",
        "域": "domain",
        "焦点事件初始化": "FocusEventInit",
        "相关目标": "relatedTarget",
        "事件目标": "EventTarget",
        "焦点导航事件初始化": "FocusNavigationEventInit",
        "导航原因": "navigationReason",
        "原始左": "originLeft",
        "原始顶": "originTop",
        "原始宽": "originWidth",
        "原始高": "originHeight",
        "焦点导航起始": "FocusNavigationOrigin",
        "手柄事件初始化": "GamepadEventInit",
        "手柄": "gamepad",
        "手柄类": "Gamepad",
        "取导航选项集": "GetNotificationOptions",
        "标签": "tag",
        "哈希改变事件初始化": "HashChangeEventInit",
        "新URL": "newURL",
        "老URL": "oldURL",
        "IDB索引参数集": "IDBIndexParameters",
        "多入口": "multiEntry",
        "独特": "unique",
        "IDB对象储存参数集": "IDBObjectStoreParameters",
        "自动增加": "autoIncrement",
        "键路径": "keyPath",
        "IDB键路径": "IDBKeyPath",
        "交叉观察员入口初始化": "IntersectionObserverEntryInit",
        "根矩形界限集": "rootBounds",
        "包围显示矩形": "boundingClientRect",
        "相交矩形": "intersectionRect",
        "元素类": "Element",
        "交叉观察员初始化": "IntersectionObserverInit",
        "根": "root",
        "根范围": "rootMargin",
        "门槛": "threshold",
        "键算法": "KeyAlgorithm",
        "键盘事件初始化": "KeyboardEventInit",
        "位置": "location",
        "重复": "repeat",
        "MS帐户信息": "MSAccountInfo",
        "用户显示名称": "userDisplayName",
        "帐户名称": "accountName",
        "用户ID": "userId",
        "帐户图像URI": "accountImageUri",
        "MS音频客户端事件类": "MSAudioLocalClientEvent",
        "MS本地客户端事件基类": "MSLocalClientEventBase",
        "网络发送优质事件比": "networkSendQualityEventRatio",
        "网络延迟事件比": "networkDelayEventRatio",
        "CPU不足事件比": "cpuInsufficientEventRatio",
        "设备半双工AEC事件比": "deviceHalfDuplexAECEventRatio",
        "设备渲染不活动比": "deviceRenderNotFunctioningEventRatio",
        "设备捕获不到功能事件比": "deviceCaptureNotFunctioningEventRatio",
        "设备故障事件比": "deviceGlitchesEventRatio",
        "设备低噪音事件比": "deviceLowSNREventRatio",
        "设备低语音电平事件比": "deviceLowSpeechLevelEventRatio",
        "设备剪辑事件比": "deviceClippingEventRatio",
        "设备回声事件比": "deviceEchoEventRatio",
        "设备近端回声事件比事件比": "deviceNearEndToEchoRatioEventRatio",
        "设备渲染无体积事件比": "deviceRenderZeroVolumeEventRatio",
        "设备渲染静音事件比": "deviceRenderMuteEventRatio",
        "设备多端点事件比": "deviceMultipleEndpointsEventCount",
        "设备咆哮事件数量": "deviceHowlingEventCount",
        "MS音频接收有效载荷": "MSAudioRecvPayload",
        "MS有效载荷基": "MSPayloadBase",
        "采样率": "samplingRate",
        "信号": "signal",
        "MS音频接收信号": "MSAudioRecvSignal",
        "包排序比": "packetReorderRatio",
        "包重排序景深": "packetReorderDepthAvg",
        "包重排序景深最大值": "packetReorderDepthMax",
        "突发损失长度1": "burstLossLength1",
        "突发损失长度2": "burstLossLength2",
        "突发损失长度3": "burstLossLength3",
        "突发损失长度4": "burstLossLength4",
        "突发损失长度5": "burstLossLength5",
        "突发损失长度6": "burstLossLength6",
        "突发损失长度7": "burstLossLength7",
        "突发丢失长度8或更高": "burstLossLength8OrHigher",
        "FEC接收距离": "fecRecvDistance1",
        "FEC接收距离2": "fecRecvDistance2",
        "FEC接收距离3": "fecRecvDistance3",
        "隐藏比样本平均值": "ratioConcealedSamplesAvg",
        "拉伸比样本": "ratioStretchedSamplesAvg",
        "压缩比均值": "ratioCompressedSamplesAvg",
        "初始信号等级RMS": "initialSignalLevelRMS",
        "接收信号等级CH1": "recvSignalLevelCh1",
        "接收噪音等级Ch1": "recvNoiseLevelCh1",
        "接收信号等级": "renderSignalLevel",
        "接收噪音等级": "renderNoiseLevel",
        "提供返回信号等级": "renderLoopbackSignalLevel",
        "MS音频发送有效载荷": "MSAudioSendPayload",
        "MS音频信号发送": "MSAudioSendSignal",
        "使用音频纠错": "audioFECUsed",
        "发送静音百分比": "sendMutePercent",
        "噪音等级": "noiseLevel",
        "发送信号等级Ch1": "sendSignalLevelCh1",
        "发送噪音等级CH1": "sendNoiseLevelCh1",
        "MS连接": "MSConnectivity",
        "信令类型": "iceType",
        "信令警告标志": "iceWarningFlags",
        "MS信令警告标志": "MSIceWarningFlags",
        "中继地址": "relayAddress",
        "MS中继地址": "MSRelayAddress",
        "MS凭据滤波器": "MSCredentialFilter",
        "接受": "accept",
        "MS凭据规格": "MSCredentialSpec",
        "MS凭证参数": "MSCredentialParameters",
        "MS延迟": "MSDelay",
        "往返出行": "roundTrip",
        "往返出行最大值": "roundTripMax",
        "MS描述": "MSDescription",
        "RTC统计": "RTCStats",
        "连通": "connectivity",
        "传输": "transport",
        "网络连通性": "networkconnectivity",
        "MS网络连通信息": "MSNetworkConnectivityInfo",
        "本地地址": "localAddr",
        "MS_IP地址信息": "MSIPAddressInfo",
        "远程地址": "remoteAddr",
        "设备开发名称": "deviceDevName",
        "反射本地IP地址": "reflexiveLocalIPAddr",
        "MS_FIDO凭证参数集": "MSFIDOCredentialParameters",
        "算法": "algorithm",
        "鉴定人": "authenticators",
        "IP地址": "ipAddr",
        "端口": "port",
        "制造商MAC地址掩码": "manufacturerMacAddrMask",
        "中继TCP超时": "turnTcpTimedOut",
        "中继UDP分配失败": "turnUdpAllocateFailed",
        "中继UDP发送失败": "turnUdpSendFailed",
        "中继TCP分配失败": "turnTcpAllocateFailed",
        "中继TCP发送失败": "turnTcpSendFailed",
        "UDP本地连接失败": "udpLocalConnectivityFailed",
        "UDP地址转换连接失败": "udpNatConnectivityFailed",
        "UDP中继连接失败": "udpRelayConnectivityFailed",
        "TCP地址转换连接失败": "tcpNatConnectivityFailed",
        "TCP中继连接失败": "tcpRelayConnectivityFailed",
        "连接检查消息完整性失败": "connCheckMessageIntegrityFailed",
        "分配消息完整性失败": "allocationMessageIntegrityFailed",
        "连接检查其他错误": "connCheckOtherError",
        "转发授权未知用户名错误": "turnAuthUnknownUsernameError",
        "无中继服务器配置": "noRelayServersConfigured",
        "多中继服务器尝试": "multipleRelayServersAttempted",
        "端口范围枯竭": "portRangeExhausted",
        "备用服务器接收": "alternateServerReceived",
        "虚拟TLS失败": "pseudoTLSFailure",
        "转发转发TCP连接失败": "turnTurnTcpConnectivityFailed",
        "使用候选检查失败": "useCandidateChecksFailed",
        "FIPS分配失败": "fipsAllocationFailure",
        "MS抖动": "MSJitter",
        "国际到达": "interArrival",
        "国际到达最大值": "interArrivalMax",
        "国际到达LSD": "interArrivalSD",
        "网络接收优质事件比": "networkReceiveQualityEventRatio",
        "网络带宽低事件比": "networkBandwidthLowEventRatio",
        "MS网络": "MSNetwork",
        "抖动": "jitter",
        "延迟": "delay",
        "数据包丢失集": "packetLoss",
        "MS数据包丢失": "MSPacketLoss",
        "利用率": "utilization",
        "MS利用率": "MSUtilization",
        "代理": "vpn",
        "链接速度": "linkspeed",
        "网络连接详细信息": "networkConnectionDetails",
        "MS网络接口类型": "MSNetworkInterfaceType",
        "以太网接口类型": "interfaceTypeEthernet",
        "无线接口类型": "interfaceTypeWireless",
        "接口类型PPP": "interfaceTypePPP",
        "接口类型通道": "interfaceTypeTunnel",
        "WWAN接口类型": "interfaceTypeWWAN",
        "MS确保出口网络": "MSOutboundNetwork",
        "应用带宽限制": "appliedBandwidthLimit",
        "损失率": "lossRate",
        "最大损失率": "lossRateMax",
        "有效载荷描述": "payloadDescription",
        "MS端口范围": "MSPortRange",
        "MS签名参数集": "MSSignatureParameters",
        "用户提示": "userPrompt",
        "MS传输诊断统计": "MSTransportDiagnosticsStats",
        "基地址": "baseAddress",
        "本地地址集": "localAddress",
        "本地站点": "localSite",
        "网络名称": "networkName",
        "远程地址集": "remoteAddress",
        "远程站点": "remoteSite",
        "局部MR": "localMR",
        "远程MR": "remoteMR",
        "最小端口范围": "portRangeMin",
        "最大端口范围": "portRangeMax",
        "本地M控制协议端口": "localMRTCPPort",
        "远程M控制协议端口": "remoteMRTCPPort",
        "穿越版本": "stunVer",
        "同意请求发送数": "numConsentReqSent",
        "同意请求接收数": "numConsentReqReceived",
        "同意分别发送数": "numConsentRespSent",
        "同意或接受数": "numConsentRespReceived",
        "接口集": "interfaces",
        "基类接口": "baseInterface",
        "协议": "protocol",
        "本地接口": "localInterface",
        "本地地址类型": "localAddrType",
        "远程地址类型": "remoteAddrType",
        "信令角色": "iceRole",
        "实时传输控制协议复用器": "rtpRtcpMux",
        "时间分配系统": "allocationTimeInMs",
        "MS引擎版本": "msRtcEngineVersion",
        "信息包集": "packets",
        "带宽估计": "bandwidthEstimation",
        "最小带宽估计": "bandwidthEstimationMin",
        "最大带宽估计": "bandwidthEstimationMax",
        "开发带宽估计": "bandwidthEstimationStdDev",
        "平均带宽估计": "bandwidthEstimationAvg",
        "MS视频负载": "MSVideoPayload",
        "分辨率": "resolution",
        "视频平均比特率": "videoBitRateAvg",
        "最大视频比特率": "videoBitRateMax",
        "平均视频帧速率": "videoFrameRateAvg",
        "视频包丢失率": "videoPacketLossRate",
        "持续时间秒": "durationSeconds",
        "MS视频接收有效载荷": "MSVideoRecvPayload",
        "视频帧丢失率": "videoFrameLossRate",
        "接收编码类型": "recvCodecType",
        "接收分辨率宽度": "recvResolutionWidth",
        "接收分辨率高度": "recvResolutionHeight",
        "视频分辨率": "videoResolutions",
        "MS视频分辨率分布": "MSVideoResolutionDistribution",
        "接收平均帧速率": "recvFrameRateAverage",
        "最大接收比特率": "recvBitRateMaximum",
        "平均接收比特率": "recvBitRateAverage",
        "接收最大视频流": "recvVideoStreamsMax",
        "接收最下视频流": "recvVideoStreamsMin",
        "接收视频流模式": "recvVideoStreamsMode",
        "视频丢包后FEC": "videoPostFECPLR",
        "低比特率调用百分比": "lowBitRateCallPercent",
        "低帧速率调用百分比": "lowFrameRateCallPercent",
        "重新排序缓冲区总数据包": "reorderBufferTotalPackets",
        "接收重新排序缓冲区重新排序包": "recvReorderBufferReorderedPackets",
        "接收重排序缓冲丢包由于缓冲枯竭": "recvReorderBufferPacketsDroppedDueToBufferExhaustion",
        "接收最大重排序缓冲区成功有序程度": "recvReorderBufferMaxSuccessfullyOrderedExtent",
        "接收最大重排序缓冲区成功订购延迟时间": "recvReorderBufferMaxSuccessfullyOrderedLateTime",
        "接收由于超时而重新排列缓冲区数据包": "recvReorderBufferPacketsDroppedDueToTimeout",
        "接收FPS调和平均值": "recvFpsHarmonicAverage",
        "接收数量改变开关": "recvNumResSwitches",
        "CIF质量": "cifQuality",
        "VGA质量": "vgaQuality",
        "H720质量": "h720Quality",
        "H1080质量": "h1080Quality",
        "H1440质量": "h1440Quality",
        "H2160质量": "h2160Quality",
        "MS视频发送有效载荷": "MSVideoSendPayload",
        "发送帧速率平均值": "sendFrameRateAverage",
        "最大发送比特率": "sendBitRateMaximum",
        "发送比特率平均值": "sendBitRateAverage",
        "发送视频流最大值": "sendVideoStreamsMax",
        "发送分辨率宽度": "sendResolutionWidth",
        "发送分辨率高度": "sendResolutionHeight",
        "媒体加密事件初始化": "MediaEncryptedEventInit",
        "初始化数据类型": "initDataType",
        "初始化数据": "initData",
        "媒体密钥消息事件初始化": "MediaKeyMessageEventInit",
        "消息类型": "messageType",
        "媒体密钥系统配置": "MediaKeySystemConfiguration",
        "初始化数据类型集": "initDataTypes",
        "音频功能": "audioCapabilities",
        "媒体键系统媒体能力": "MediaKeySystemMediaCapability",
        "视频功能": "videoCapabilities",
        "独特标识符": "distinctiveIdentifier",
        "持续状态": "persistentState",
        "内容类型": "contentType",
        "稳健性": "robustness",
        "流媒体限制": "MediaStreamConstraints",
        "视频": "video",
        "媒体轨道约束": "MediaTrackConstraints",
        "音频": "audio",
        "媒体流错误事件初始化": "MediaStreamErrorEventInit",
        "媒体流错误": "MediaStreamError",
        "媒体流事件初始化": "MediaStreamEventInit",
        "媒体流": "MediaStream",
        "媒体流轨道事件初始化": "MediaStreamTrackEventInit",
        "轨道": "track",
        "流媒体轨道": "MediaStreamTrack",
        "媒体追踪能力": "MediaTrackCapabilities",
        "长宽比": "aspectRatio",
        "帧速率": "frameRate",
        "面对模式": "facingMode",
        "体积": "volume",
        "采样比例": "sampleRate",
        "样本大小": "sampleSize",
        "回声消除": "echoCancellation",
        "设备ID": "deviceId",
        "组ID": "groupId",
        "媒体轨道约束集": "MediaTrackConstraintSet",
        "回声抵消": "echoCancelation",
        "高级": "advanced",
        "媒体轨道设置": "MediaTrackSettings",
        "媒体轨道支持约束": "MediaTrackSupportedConstraints",
        "消息事件初始化": "MessageEventInit",
        "最后一个事件ID": "lastEventId",
        "通道": "channel",
        "窗口类": "Window",
        "端口集": "ports",
        "消息端口": "MessagePort",
        "鼠标事件初始化": "MouseEventInit",
        "相对屏幕X": "screenX",
        "相对屏幕Y": "screenY",
        "相对页面X": "clientX",
        "相对页面Y": "clientY",
        "按钮": "button",
        "按钮集": "buttons",
        "MS缩放选项": "MsZoomToOptions",
        "内容X": "contentX",
        "内容Y": "contentY",
        "视图位置X": "viewportX",
        "视图位置Y": "viewportY",
        "比例因子": "scaleFactor",
        "动画": "animate",
        "突变观察初始化": "MutationObserverInit",
        "子列表": "childList",
        "字符数据": "characterData",
        "子树": "subtree",
        "特性旧值": "attributeOldValue",
        "字符数据旧值": "characterDataOldValue",
        "特性过滤": "attributeFilter",
        "通知选项": "NotificationOptions",
        "目录": "dir",
        "语言": "lang",
        "体": "body",
        "图标": "icon",
        "基对象URL选项集": "ObjectURLOptions",
        "只有一个时间": "oneTimeOnly",
        "支付货币金额": "PaymentCurrencyAmount",
        "货币系统": "currencySystem",
        "付款细节": "PaymentDetails",
        "总额": "total",
        "支付项目": "PaymentItem",
        "显示项目集": "displayItems",
        "发货选项": "shippingOptions",
        "支付运费选项集": "PaymentShippingOption",
        "修饰符集": "modifiers",
        "付款细节修饰符": "PaymentDetailsModifier",
        "支持方法集": "supportedMethods",
        "额外显示项目集": "additionalDisplayItems",
        "HEML标签": "label",
        "数量": "amount",
        "待定": "pending",
        "数据支付方法": "PaymentMethodData",
        "支付方式选项集": "PaymentOptions",
        "请求付款人名称": "requestPayerName",
        "请求人电子邮件": "requestPayerEmail",
        "请求人电话": "requestPayerPhone",
        "请求传送": "requestShipping",
        "传送类型": "shippingType",
        "付款请求更新事件初始化": "PaymentRequestUpdateEventInit",
        "经过选择": "selected",
        "周期波约束": "PeriodicWaveConstraints",
        "禁用规范": "disableNormalization",
        "指针事件初始化": "PointerEventInit",
        "指针ID": "pointerId",
        "压力": "pressure",
        "倾斜X": "tiltX",
        "倾斜Y": "tiltY",
        "指针类型": "pointerType",
        "是首要": "isPrimary",
        "弹出状态事件初始化": "PopStateEventInit",
        "状态": "state",
        "位置选项集": "PositionOptions",
        "启用高精度": "enableHighAccuracy",
        "超时": "timeout",
        "最大时间参数": "maximumAge",
        "进展事件初始化": "ProgressEventInit",
        "长度计算": "lengthComputable",
        "加载": "loaded",
        "初始化订阅选项": "PushSubscriptionOptionsInit",
        "只有用户可见": "userVisibleOnly",
        "应用服务器键": "applicationServerKey",
        "RTC配置": "RTCConfiguration",
        "信令服务器集": "iceServers",
        "RTC信令服务器": "RTCIceServer",
        "信令传输策略": "iceTransportPolicy",
        "捆绑策略": "bundlePolicy",
        "对等标识符": "peerIdentity",
        "RTC_DTMF音调变化事件初始化": "RTCDTMFToneChangeEventInit",
        "音调": "tone",
        "RTC_DTL指纹": "RTCDtlsFingerprint",
        "RTC_DTL参数集": "RTCDtlsParameters",
        "角色role": "role",
        "指纹": "fingerprints",
        "RTC信令候选特性集": "RTCIceCandidateAttributes",
        "ip地址": "ipAddress",
        "端口号": "portNumber",
        "候选类型": "candidateType",
        "优先权": "priority",
        "源URL地址": "addressSourceUrl",
        "RTC信令候选完成": "RTCIceCandidateComplete",
        "RTC信令候选字典": "RTCIceCandidateDictionary",
        "基础": "foundation",
        "TCP类型": "tcpType",
        "相关地址": "relatedAddress",
        "相关端口": "relatedPort",
        "MS中继回话id": "msMTurnSessionId",
        "RTC信令候选初始化": "RTCIceCandidateInit",
        "候选": "candidate",
        "SDP中间": "sdpMid",
        "SDP多行指数": "sdpMLineIndex",
        "RTC信令候选对": "RTCIceCandidatePair",
        "局部": "local",
        "远程": "remote",
        "RTC信令候选对统计数据": "RTCIceCandidatePairStats",
        "传输ID": "transportId",
        "本地候选ID": "localCandidateId",
        "远程候选ID": "remoteCandidateId",
        "指定": "nominated",
        "可读": "readable",
        "发送字节数": "bytesSent",
        "接收字节数": "bytesReceived",
        "往返时间": "roundTripTime",
        "可用输出码率": "availableOutgoingBitrate",
        "可用输入比特率": "availableIncomingBitrate",
        "RTC信令收集选项集": "RTCIceGatherOptions",
        "收集政策": "gatherPolicy",
        "信令服务器": "iceservers",
        "端口范围": "portRange",
        "RTC信令参数集": "RTCIceParameters",
        "用户名子片段": "usernameFragment",
        "密码": "password",
        "信令精简版": "iceLite",
        "URL集": "urls",
        "用户名字": "username",
        "凭据": "credential",
        "RTC入站实时传输流统计": "RTCInboundRTPStreamStats",
        "RTC实时传输流统计": "RTCRTPStreamStats",
        "收到包": "packetsReceived",
        "数据包丢失": "packetsLost",
        "丢包率": "fractionLost",
        "RTC媒体流轨道统计": "RTCMediaStreamTrackStats",
        "轨道标识符": "trackIdentifier",
        "远程数据源": "remoteSource",
        "框架宽度": "frameWidth",
        "框架高度": "frameHeight",
        "每秒帧数": "framesPerSecond",
        "发送帧": "framesSent",
        "接收到帧": "framesReceived",
        "帧解码": "framesDecoded",
        "帧下降": "framesDropped",
        "帧损坏": "framesCorrupted",
        "音频等级": "audioLevel",
        "回声返回损耗": "echoReturnLoss",
        "回声返回损失增强": "echoReturnLossEnhancement",
        "RTC提供选项集": "RTCOfferOptions",
        "提供接收视频": "offerToReceiveVideo",
        "提供接收音频": "offerToReceiveAudio",
        "语音活动检测": "voiceActivityDetection",
        "信令重新启动": "iceRestart",
        "RTC出站实时传输数据流": "RTCOutboundRTPStreamStats",
        "发送数据包": "packetsSent",
        "目标比特率": "targetBitrate",
        "RTC对等连接信令事件初始化": "RTCPeerConnectionIceEventInit",
        "RTC信令候选": "RTCIceCandidate",
        "同步源": "ssrc",
        "关联属性ID": "associateStatsId",
        "是远程": "isRemote",
        "媒体轨道ID": "mediaTrackId",
        "编解码器ID": "codecId",
        "FIR计数": "firCount",
        "PLT计数": "pliCount",
        "NACK计数": "nackCount",
        "SLI计数": "sliCount",
        "RTC控制协议反馈": "RTCRtcpFeedback",
        "参数化": "parameter",
        "RTC控制协议参数集": "RTCRtcpParameters",
        "规范名称": "cname",
        "缩小尺寸": "reducedSize",
        "多路复用器": "mux",
        "RTC实时传输协议能力": "RTCRtpCapabilities",
        "解码器": "codecs",
        "实时传输编解码能力": "RTCRtpCodecCapability",
        "头扩展集": "headerExtensions",
        "RTC实时传输头扩展集": "RTCRtpHeaderExtension",
        "前向纠错机制": "fecMechanisms",
        "种类": "kind",
        "时钟速率": "clockRate",
        "优先有效载荷类型": "preferredPayloadType",
        "最大时间": "maxptime",
        "多项时间": "ptime",
        "渠道集数": "numChannels",
        "控制协议反馈": "rtcpFeedback",
        "参数化集": "parameters",
        "最大时间层": "maxTemporalLayers",
        "最大空间层": "maxSpatialLayers",
        "SVC多流支持": "svcMultiStreamSupport",
        "RTC实时传输实时编解码器参数": "RTCRtpCodecParameters",
        "有效载荷类型": "payloadType",
        "RTC实时传输贡献源": "RTCRtpContributingSource",
        "时间印记": "timestamp",
        "RTC实时传输编码参数集": "RTCRtpEncodingParameters",
        "解码器有效载荷类型": "codecPayloadType",
        "RTC实时传输FEC参数集": "RTCRtpFecParameters",
        "RTC实时传输RTX参数集": "RTCRtpRtxParameters",
        "最大比特率": "maxBitrate",
        "最小品质": "minQuality",
        "分辨率尺度": "resolutionScale",
        "帧率尺度": "framerateScale",
        "最大帧率": "maxFramerate",
        "活跃": "active",
        "编码ID": "encodingId",
        "依赖编码ID": "dependencyEncodingIds",
        "同步源范围": "ssrcRange",
        "RTC同步源范围": "RTCSsrcRange",
        "机制": "mechanism",
        "优选ID": "preferredId",
        "优先译成密码": "preferredEncrypt",
        "RTC实时传输报头扩展参数集": "RTCRtpHeaderExtensionParameters",
        "译成密码": "encrypt",
        "RTC实时传输实时参数": "RTCRtpParameters",
        "多路复用器ID": "muxId",
        "编码集": "encodings",
        "降解优先": "degradationPreference",
        "RTC实时传输协议处理": "RTCRtpUnhandled",
        "RTC会话描述初始化": "RTCSessionDescriptionInit",
        "RTC安全实时传输键参数": "RTCSrtpKeyParam",
        "键方法": "keyMethod",
        "键盐": "keySalt",
        "生命时间": "lifetime",
        "MKI值": "mkiValue",
        "MKI长度": "mkiLength",
        "RTC安全实时传输随机微分方程参数集": "RTCSrtpSdesParameters",
        "密码套件": "cryptoSuite",
        "键参数集": "keyParams",
        "会话参数集": "sessionParams",
        "MS类型": "msType",
        "RTC统计报告": "RTCStatsReport",
        "RTC传输统计": "RTCTransportStats",
        "控制协议传输属性ID": "rtcpTransportStatsId",
        "活动连接": "activeConnection",
        "选择候选对ID": "selectedCandidatePairId",
        "本地证书编号": "localCertificateId",
        "远程认证ID": "remoteCertificateId",
        "注册选项集": "RegistrationOptions",
        "领域": "scope",
        "请求初始化": "RequestInit",
        "方法": "method",
        "题头": "headers",
        "推荐人": "referrer",
        "推荐策略": "referrerPolicy",
        "模型": "mode",
        "资格证书": "credentials",
        "高速缓存": "cache",
        "重定向": "redirect",
        "完整性": "integrity",
        "保持活力": "keepalive",
        "视窗": "window",
        "响应初始化": "ResponseInit",
        "状态集": "status",
        "状态文本": "statusText",
        "运输": "transports",
        "作用域凭据选项集": "ScopedCredentialOptions",
        "排除列表": "excludeList",
        "凭证参数集范围": "ScopedCredentialParameters",
        "服务平台消息时间初始化": "ServiceWorkerMessageEventInit",
        "服务平台类": "ServiceWorker",
        "语音合成事件初始化": "SpeechSynthesisEventInit",
        "发音": "utterance",
        "语音合成发音": "SpeechSynthesisUtterance",
        "字符索引": "charIndex",
        "存储异常信息": "StoreExceptionsInformation",
        "网站名称": "siteName",
        "解释字文字": "explanationString",
        "详细URI": "detailURI",
        "存储站点特定异常信息": "StoreSiteSpecificExceptionsInformation",
        "轨道事件初始化": "TrackEventInit",
        "视频轨道": "VideoTrack",
        "音频轨道": "AudioTrack",
        "文本轨道类": "TextTrack",
        "转换事件初始化": "TransitionEventInit",
        "属性名称": "propertyName",
        "视图": "view",
        "WEBGL语境特性": "WebGLContextAttributes",
        "如果没有主要性能问题": "failIfMajorPerformanceCaveat",
        "景深": "depth",
        "模板": "stencil",
        "抗锯齿": "antialias",
        "进行透明通道": "premultipliedAlpha",
        "保存图形缓冲区": "preserveDrawingBuffer",
        "WEBGL事件语境事件初始化": "WebGLContextEventInit",
        "状态消息": "statusMessage",
        "滚轮事件初始化": "WheelEventInit",
        "滚动X": "deltaX",
        "滚动Y": "deltaY",
        "滚动Z": "deltaZ",
        "滚动模块": "deltaMode",
        "事件监听器": "EventListener",
        "事": "evt",
        "事件类": "Event",
        "WEB工具包条目回调": "WebKitEntriesCallback",
        "WEB工具包错误回调": "WebKitErrorCallback",
        "WEB工具包文件回调": "WebKitFileCallback",
        "ANGLE_关联_数组": "ANGLE_instanced_arrays",
        "绘制阵列实例ANGLE": "drawArraysInstancedANGLE",
        "第一": "first",
        "计数": "count",
        "最初计数": "primcount",
        "画元素副本ANGLE": "drawElementsInstancedANGLE",
        "顶点特性因子ANGLE": "vertexAttribDivisorANGLE",
        "除数": "divisor",
        "顶点_特性数组因子_角度": "VERTEX_ATTRIB_ARRAY_DIVISOR_ANGLE",
        "分析节点": "AnalyserNode",
        "音频节点": "AudioNode",
        "FFT大小": "fftSize",
        "频率二进制计数": "frequencyBinCount",
        "最大分贝": "maxDecibels",
        "最小分贝": "minDecibels",
        "滤波时间常数": "smoothingTimeConstant",
        "取字节频率数据": "getByteFrequencyData",
        "取字节时域数据": "getByteTimeDomainData",
        "取浮点数频率数据": "getFloatFrequencyData",
        "取浮点数时间域数据": "getFloatTimeDomainData",
        "动画事件类": "AnimationEvent",
        "初始化动画事件类": "initAnimationEvent",
        "类型参数": "typeArg",
        "不可冒泡参数": "canBubbleArg",
        "不可撤销参数": "cancelableArg",
        "动画名称参数": "animationNameArg",
        "经过时间参数": "elapsedTimeArg",
        "事件初始化字典": "eventInitDict",
        "应用程序缓存事件映射": "ApplicationCacheEventMap",
        "进展事件": "ProgressEvent",
        "应用程序缓存类": "ApplicationCache",
        "引发缓存": "oncached",
        "事件名": "ev",
        "引发检查中": "onchecking",
        "引发下载中": "ondownloading",
        "引发错误": "onerror",
        "引发没有更新": "onnoupdate",
        "引发过时": "onobsolete",
        "引发前进": "onprogress",
        "引发更新准备": "onupdateready",
        "中止": "abort",
        "交换缓存": "swapCache",
        "更新数据": "update",
        "检_查_中": "CHECKING",
        "下_载_中": "DOWNLOADING",
        "闲_置": "IDLE",
        "过_时": "OBSOLETE",
        "高_速_缓_存": "UNCACHED",
        "日_期_准_备": "UPDATEREADY",
        "添加事件侦听器": "addEventListener",
        "侦听器": "listener",
        "使用捕获": "useCapture",
        "事件侦听器或事件侦听器对象": "EventListenerOrEventListenerObject",
        "_特性": "Attr",
        "节点类": "Node",
        "主元素": "ownerElement",
        "前缀": "prefix",
        "明确规定": "specified",
        "音频缓冲区": "AudioBuffer",
        "持续时间": "duration",
        "通道集数量": "numberOfChannels",
        "复制通道": "copyFromChannel",
        "目地": "destination",
        "通道数": "channelNumber",
        "开始在通道": "startInChannel",
        "复制到通道": "copyToChannel",
        "得到信道数据": "getChannelData",
        "音频缓冲源节点事件映射": "AudioBufferSourceNodeEventMap",
        "媒体流错误事件类": "MediaStreamErrorEvent",
        "音频缓冲源节点": "AudioBufferSourceNode",
        "失谐": "detune",
        "音频参数": "AudioParam",
        "环路": "loop",
        "环路结束": "loopEnd",
        "环路开始": "loopStart",
        "引发结束了": "onended",
        "播放速率": "playbackRate",
        "什么时候": "when",
        "停止": "stop",
        "音频语境事件映射": "AudioContextEventMap",
        "音频语境基类": "AudioContextBase",
        "当前时间": "currentTime",
        "音频目节点": "AudioDestinationNode",
        "音频监听器": "AudioListener",
        "引发开始检查": "onstatechange",
        "音频语境": "AudioContext",
        "关闭": "close",
        "创建分析器": "createAnalyser",
        "创建滤波器": "createBiquadFilter",
        "滤波电路结点": "BiquadFilterNode",
        "创建缓冲区": "createBuffer",
        "创建缓冲区源": "createBufferSource",
        "创建通道合并": "createChannelMerger",
        "输入数量": "numberOfInputs",
        "信道合并节点": "ChannelMergerNode",
        "创建信道分流": "createChannelSplitter",
        "数字输出": "numberOfOutputs",
        "渠道分流节点": "ChannelSplitterNode",
        "创建模板": "createConvolver",
        "卷积器节点": "ConvolverNode",
        "创建延迟": "createDelay",
        "最大延迟时间": "maxDelayTime",
        "延迟节点": "DelayNode",
        "创建动态压缩机": "createDynamicsCompressor",
        "动态压缩节点": "DynamicsCompressorNode",
        "创建增益": "createGain",
        "获得节点": "GainNode",
        "创建IIR滤波器": "createIIRFilter",
        "前馈控制": "feedforward",
        "反馈": "feedback",
        "IIR滤波器节点": "IIRFilterNode",
        "创建媒体元素源": "createMediaElementSource",
        "媒体元素": "mediaElement",
        "超文本媒体元素": "HTMLMediaElement",
        "媒体元素音频源节点": "MediaElementAudioSourceNode",
        "创建媒体流源": "createMediaStreamSource",
        "媒体流数据": "mediaStream",
        "媒体流音频源节点": "MediaStreamAudioSourceNode",
        "创建振荡器": "createOscillator",
        "振荡器节点": "OscillatorNode",
        "创建淘金者": "createPanner",
        "淘金者节点": "PannerNode",
        "创造周期波": "createPeriodicWave",
        "真实": "real",
        "图片": "imag",
        "约束": "constraints",
        "周期波类": "PeriodicWave",
        "创建脚本处理器": "createScriptProcessor",
        "缓冲区大小": "bufferSize",
        "输入通道数": "numberOfInputChannels",
        "输出通道数": "numberOfOutputChannels",
        "脚本处理器节点": "ScriptProcessorNode",
        "创建立体声声像": "createStereoPanner",
        "立体声声像节点": "StereoPannerNode",
        "创建波整形器": "createWaveShaper",
        "波整形器节点": "WaveShaperNode",
        "解码音频数据": "decodeAudioData",
        "音频数据": "audioData",
        "成功回调": "successCallback",
        "解码成功回调": "DecodeSuccessCallback",
        "错误回调": "errorCallback",
        "解码错误回调": "DecodeErrorCallback",
        "恢复": "resume",
        "延缓": "suspend",
        "最大通道数": "maxChannelCount",
        "多普勒系数": "dopplerFactor",
        "声音速度": "speedOfSound",
        "置定位": "setOrientation",
        "置位置": "setPosition",
        "设定速度": "setVelocity",
        "通道计数": "channelCount",
        "通道计数模块": "channelCountMode",
        "通道解释": "channelInterpretation",
        "语境": "context",
        "连接": "connect",
        "输出": "output",
        "断开": "disconnect",
        "默认值": "defaultValue",
        "取消预定值": "cancelScheduledValues",
        "开始时间": "startTime",
        "指数上升在时间值": "exponentialRampToValueAtTime",
        "解释时间": "endTime",
        "线性斜坡到间值": "linearRampToValueAtTime",
        "设定时间目标": "setTargetAtTime",
        "时间常数": "timeConstant",
        "置时间设定值": "setValueAtTime",
        "置时间值曲线": "setValueCurveAtTime",
        "音频处理事件类": "AudioProcessingEvent",
        "输入缓冲区": "inputBuffer",
        "输出缓冲区": "outputBuffer",
        "播放时间": "playbackTime",
        "已启用": "enabled",
        "语言文字": "language",
        "源缓冲区": "sourceBuffer",
        "源缓冲区类": "SourceBuffer",
        "音频轨道列表事件映射": "AudioTrackListEventMap",
        "音频曲目列表": "AudioTrackList",
        "引发添加轨道": "onaddtrack",
        "引发改变": "onchange",
        "引发删除轨道": "onremovetrack",
        "取轨道根据ID": "getTrackById",
        "项": "item",
        "属性栏": "BarProp",
        "可见": "visible",
        "卸载之前实际": "BeforeUnloadEvent",
        "返回值": "returnValue",
        "频率": "frequency",
        "取频率响应": "getFrequencyResponse",
        "频率HZ": "frequencyHz",
        "MAG反应": "magResponse",
        "相位响应": "phaseResponse",
        "二进制对象": "Blob",
        "大小": "size",
        "MS关闭": "msClose",
        "MS分离流": "msDetachStream",
        "二进制对象部分": "blobParts",
        "二进制对象属性包": "BlobPropertyBag",
        "CDATA部分": "CDATASection",
        "文本类": "Text",
        "支持": "supports",
        "属性": "property",
        "CSS规则条件": "CSSConditionRule",
        "CSS分组规则": "CSSGroupingRule",
        "条件文本": "conditionText",
        "CSS字体规则": "CSSFontFaceRule",
        "CSS规则": "CSSRule",
        "CSS样式声明": "CSSStyleDeclaration",
        "CSS规则集": "cssRules",
        "CSS规则列表": "CSSRuleList",
        "删除规则": "deleteRule",
        "插入规则": "insertRule",
        "规则": "rule",
        "CSS导入规则": "CSSImportRule",
        "链接目标": "href",
        "媒体": "media",
        "媒体列表": "MediaList",
        "样式表": "styleSheet",
        "CSS样式表": "CSSStyleSheet",
        "CSS关键帧规则": "CSSKeyframeRule",
        "KEY文本": "keyText",
        "CSS关键帧集规则": "CSSKeyframesRule",
        "追加规则": "appendRule",
        "查找规则": "findRule",
        "CSS媒体规则": "CSSMediaRule",
        "CSS名称空间规则": "CSSNamespaceRule",
        "名称空间URI": "namespaceURI",
        "CSS页面规则": "CSSPageRule",
        "伪类": "pseudoClass",
        "选择器": "selector",
        "选择器文本": "selectorText",
        "CSS文本": "cssText",
        "父规则": "parentRule",
        "父样式表": "parentStyleSheet",
        "编码_规则": "CHARSET_RULE",
        "字体_规则": "FONT_FACE_RULE",
        "进口_规则": "IMPORT_RULE",
        "关键帧集_规则": "KEYFRAMES_RULE",
        "关键帧_规则": "KEYFRAME_RULE",
        "媒体_规则": "MEDIA_RULE",
        "名称空间_规则": "NAMESPACE_RULE",
        "页面_规则": "PAGE_RULE",
        "样式_规则": "STYLE_RULE",
        "支持_规则": "SUPPORTS_RULE",
        "未知_规则": "UNKNOWN_RULE",
        "视口_规则": "VIEWPORT_RULE",
        "对齐内容": "alignContent",
        "对齐项目集": "alignItems",
        "对齐自我": "alignSelf",
        "对齐基线": "alignmentBaseline",
        "动画属性": "animation",
        "动画延迟": "animationDelay",
        "动画定位": "animationDirection",
        "动画持续时间": "animationDuration",
        "动画填充模式": "animationFillMode",
        "动画重复计数": "animationIterationCount",
        "动画播放状态": "animationPlayState",
        "动画定时功能": "animationTimingFunction",
        "背面可见性": "backfaceVisibility",
        "背景属性": "background",
        "背景图像是否固定": "backgroundAttachment",
        "背景绘制区域": "backgroundClip",
        "背景颜色": "backgroundColor",
        "背景图像": "backgroundImage",
        "背景原点": "backgroundOrigin",
        "背景位置": "backgroundPosition",
        "背景位置X": "backgroundPositionX",
        "背景位置Y": "backgroundPositionY",
        "背景重复": "backgroundRepeat",
        "背景尺寸": "backgroundSize",
        "允许重新定位": "baselineShift",
        "边框属性": "border",
        "边框下部": "borderBottom",
        "边框下部颜色": "borderBottomColor",
        "边框左下角半径": "borderBottomLeftRadius",
        "边框右下角半径": "borderBottomRightRadius",
        "边框下部样式": "borderBottomStyle",
        "边框下部宽度": "borderBottomWidth",
        "边框合并": "borderCollapse",
        "边框颜色": "borderColor",
        "边框图像": "borderImage",
        "边框图像开始": "borderImageOutset",
        "边框图像重复": "borderImageRepeat",
        "边框图像切片": "borderImageSlice",
        "边框图片来源": "borderImageSource",
        "边框图像宽度": "borderImageWidth",
        "边框左边": "borderLeft",
        "边框左边颜色": "borderLeftColor",
        "边框左边样式": "borderLeftStyle",
        "边框左边宽度": "borderLeftWidth",
        "边框角半径": "borderRadius",
        "边框右边": "borderRight",
        "边框右边颜色": "borderRightColor",
        "边框右边样式": "borderRightStyle",
        "边框右边宽度": "borderRightWidth",
        "边框间距": "borderSpacing",
        "边框样式": "borderStyle",
        "边框上部": "borderTop",
        "边框上部颜色": "borderTopColor",
        "边框左上角半径": "borderTopLeftRadius",
        "边框右上角半径": "borderTopRightRadius",
        "边框上部样式": "borderTopStyle",
        "边框上部宽度": "borderTopWidth",
        "边框宽度": "borderWidth",
        "下边界偏移": "bottom",
        "四周阴影": "boxShadow",
        "设置检索对象盒组成模式": "boxSizing",
        "打破后": "breakAfter",
        "打破前": "breakBefore",
        "打破内": "breakInside",
        "表格标题位置": "captionSide",
        "清除浮动": "clear",
        "剪裁绝对": "clip",
        "剪裁路径": "clipPath",
        "剪辑规则": "clipRule",
        "颜色": "color",
        "颜色插值滤波器": "colorInterpolationFilters",
        "列计数": "columnCount",
        "列填充": "columnFill",
        "列间距": "columnGap",
        "列规则": "columnRule",
        "列规则颜色": "columnRuleColor",
        "列规则样式": "columnRuleStyle",
        "列规则宽度": "columnRuleWidth",
        "列跨度": "columnSpan",
        "列宽度": "columnWidth",
        "列数量": "columns",
        "内容": "content",
        "增量计数器": "counterIncrement",
        "计数器复位": "counterReset",
        "CSS浮动": "cssFloat",
        "光标": "cursor",
        "方向": "direction",
        "显示": "display",
        "主导基线": "dominantBaseline",
        "空单元格": "emptyCells",
        "启用背景": "enableBackground",
        "填充透明度": "fillOpacity",
        "填充规则": "fillRule",
        "弹性布局": "flex",
        "弹性盒伸缩基准值": "flexBasis",
        "主轴方向": "flexDirection",
        "弹性流": "flexFlow",
        "放大比例": "flexGrow",
        "缩小比例": "flexShrink",
        "如何换行": "flexWrap",
        "覆盖颜色": "floodColor",
        "覆盖透明": "floodOpacity",
        "字体": "font",
        "字体系列": "fontFamily",
        "字体启用支持样式集": "fontFeatureSettings",
        "字体尺寸": "fontSize",
        "字体大小调整": "fontSizeAdjust",
        "字体收缩或拉伸": "fontStretch",
        "字体样式": "fontStyle",
        "字体小型大写字母": "fontVariant",
        "字体粗细": "fontWeight",
        "字形定位水平": "glyphOrientationHorizontal",
        "字形定位垂直": "glyphOrientationVertical",
        "输入法模式": "imeMode",
        "分布内容": "justifyContent",
        "字距调整": "kerning",
        "布局网格特性": "layoutGrid",
        "字符网格值": "layoutGridChar",
        "行网格值": "layoutGridLine",
        "布局网络模式": "layoutGridMode",
        "布局网络类型": "layoutGridType",
        "左": "left",
        "字母间距": "letterSpacing",
        "高亮颜色": "lightingColor",
        "换行符": "lineBreak",
        "行高": "lineHeight",
        "列表样式": "listStyle",
        "列表样式图像": "listStyleImage",
        "列表样式位置": "listStylePosition",
        "列表样式类型": "listStyleType",
        "外框": "margin",
        "外框底部": "marginBottom",
        "外框左边": "marginLeft",
        "外框右边": "marginRight",
        "外框上部": "marginTop",
        "标识": "marker",
        "标识结束": "markerEnd",
        "标识中间": "markerMid",
        "标识开始": "markerStart",
        "遮罩": "mask",
        "最大高度": "maxHeight",
        "最大宽度": "maxWidth",
        "最小高度": "minHeight",
        "最小宽度": "minWidth",
        "MS单击缩放限制时发生": "msContentZoomChaining",
        "MS内容缩放限制": "msContentZoomLimit",
        "MS内容缩放限制最大": "msContentZoomLimitMax",
        "MS内容缩放限制最小": "msContentZoomLimitMin",
        "MS缩放如何受捕捉点影响": "msContentZoomSnap",
        "MS内容缩放捕捉点": "msContentZoomSnapPoints",
        "MS内容缩放捕捉点类型": "msContentZoomSnapType",
        "MS内容缩放中": "msContentZooming",
        "MS流动": "msFlowFrom",
        "MS流入": "msFlowInto",
        "MS字体启用支持样式集": "msFontFeatureSettings",
        "MS网格列": "msGridColumn",
        "MS网格列对齐": "msGridColumnAlign",
        "MS网格列跨度": "msGridColumnSpan",
        "MS网格列集": "msGridColumns",
        "MS网格行": "msGridRow",
        "MS网格行对齐": "msGridRowAlign",
        "MS网格行跨度": "msGridRowSpan",
        "MS网络行集": "msGridRows",
        "MS高对比度调整": "msHighContrastAdjust",
        "MS连字符限制字符": "msHyphenateLimitChars",
        "MS连字符限制行": "msHyphenateLimitLines",
        "MS连字符限制区域": "msHyphenateLimitZone",
        "MS连字符": "msHyphens",
        "MSIME元素对齐": "msImeAlign",
        "MS溢出样式": "msOverflowStyle",
        "MS滚动链接": "msScrollChaining",
        "MS滚动限制": "msScrollLimit",
        "MS滚动限制X最大": "msScrollLimitXMax",
        "MS滚动限制X最小": "msScrollLimitXMin",
        "MS滚动限制Y最大": "msScrollLimitYMax",
        "MS滚动限制Y最小": "msScrollLimitYMin",
        "MS滚动轨道": "msScrollRails",
        "MS滚动捕捉点X": "msScrollSnapPointsX",
        "MS滚动捕捉点Y": "msScrollSnapPointsY",
        "MS滚动捕捉类型": "msScrollSnapType",
        "MS滚动捕捉X": "msScrollSnapX",
        "MS滚动捕捉Y": "msScrollSnapY",
        "MS滚动翻译": "msScrollTranslation",
        "MS文本水平组合": "msTextCombineHorizontal",
        "MS文字大小调整": "msTextSizeAdjust",
        "MS触摸动作": "msTouchAction",
        "MS触摸选择": "msTouchSelect",
        "MS用户选择": "msUserSelect",
        "MS包装流程": "msWrapFlow",
        "MS包装外边": "msWrapMargin",
        "MS包装排除": "msWrapThrough",
        "透明度": "opacity",
        "顺序": "order",
        "孤立": "orphans",
        "轮廓": "outline",
        "轮廓颜色": "outlineColor",
        "轮廓偏移": "outlineOffset",
        "轮廓样式": "outlineStyle",
        "轮廓宽度": "outlineWidth",
        "溢出": "overflow",
        "溢出X": "overflowX",
        "溢出Y": "overflowY",
        "内边距": "padding",
        "内边距下部": "paddingBottom",
        "内边距左边": "paddingLeft",
        "内边距右边": "paddingRight",
        "内边距上部": "paddingTop",
        "分页符后": "pageBreakAfter",
        "分页符之前": "pageBreakBefore",
        "分页符里面": "pageBreakInside",
        "透视": "perspective",
        "视角原点": "perspectiveOrigin",
        "指针事件集": "pointerEvents",
        "引号类型": "quotes",
        "右": "right",
        "旋转": "rotate",
        "悬置对齐": "rubyAlign",
        "悬置相邻": "rubyOverhang",
        "悬置位置": "rubyPosition",
        "比例": "scale",
        "停止颜色": "stopColor",
        "停止透明度": "stopOpacity",
        "描边": "stroke",
        "描边虚线": "strokeDasharray",
        "描边动画": "strokeDashoffset",
        "描边端点": "strokeLinecap",
        "描边转角": "strokeLinejoin",
        "描边相交": "strokeMiterlimit",
        "描边透明度": "strokeOpacity",
        "笔画宽度": "strokeWidth",
        "表格布局": "tableLayout",
        "文本对齐": "textAlign",
        "最后一行对齐": "textAlignLast",
        "文本锚": "textAnchor",
        "文本装饰": "textDecoration",
        "文本缩进": "textIndent",
        "文本两端对齐": "textJustify",
        "文本拉伸": "textKashida",
        "文本拉伸范围": "textKashidaSpace",
        "文本溢出": "textOverflow",
        "文本阴影": "textShadow",
        "文本转换": "textTransform",
        "文字下划线位置": "textUnderlinePosition",
        "上部": "top",
        "触摸动作": "touchAction",
        "转换": "transform",
        "转换原点": "transformOrigin",
        "转换样式": "transformStyle",
        "过度": "transition",
        "过度延迟": "transitionDelay",
        "过度时间": "transitionDuration",
        "过度属性": "transitionProperty",
        "过渡效果随时间改变": "transitionTimingFunction",
        "翻译": "translate",
        "置文本方向": "unicodeBidi",
        "垂直对齐": "verticalAlign",
        "可见性": "visibility",
        "WK对齐内容": "webkitAlignContent",
        "WK对齐项目": "webkitAlignItems",
        "WK对齐自我": "webkitAlignSelf",
        "WK动画": "webkitAnimation",
        "WK动画延迟": "webkitAnimationDelay",
        "WK动画方向": "webkitAnimationDirection",
        "WK动画持续时间": "webkitAnimationDuration",
        "WK动画填充模式": "webkitAnimationFillMode",
        "WK动画重复计数": "webkitAnimationIterationCount",
        "WK动画名称": "webkitAnimationName",
        "WK动画播放状态": "webkitAnimationPlayState",
        "WK动画定时功能": "webkitAnimationTimingFunction",
        "WK外观": "webkitAppearance",
        "WK背面可见性": "webkitBackfaceVisibility",
        "WK绘制区域": "webkitBackgroundClip",
        "WK背景原点": "webkitBackgroundOrigin",
        "WK背景尺寸": "webkitBackgroundSize",
        "WK左下角半径": "webkitBorderBottomLeftRadius",
        "WK右下角半径": "webkitBorderBottomRightRadius",
        "WK边框图像": "webkitBorderImage",
        "WK边框半径": "webkitBorderRadius",
        "WK边框左上角半径": "webkitBorderTopLeftRadius",
        "WK边框右上角半径": "webkitBorderTopRightRadius",
        "WK盒对齐": "webkitBoxAlign",
        "WK盒方向": "webkitBoxDirection",
        "WK盒弹性布局": "webkitBoxFlex",
        "WK盒子元素显示顺序": "webkitBoxOrdinalGroup",
        "WK盒排列": "webkitBoxOrient",
        "WK盒包裹": "webkitBoxPack",
        "WK盒尺寸": "webkitBoxSizing",
        "WK设置检索对象后是否换行": "webkitColumnBreakAfter",
        "WK设置检索对象前是否换行": "webkitColumnBreakBefore",
        "WK设置检索对象内是否换行": "webkitColumnBreakInside",
        "WK列数": "webkitColumnCount",
        "WK间距": "webkitColumnGap",
        "WK列规则": "webkitColumnRule",
        "WK列规则颜色": "webkitColumnRuleColor",
        "WK列规则样式": "webkitColumnRuleStyle",
        "WK列规则宽度": "webkitColumnRuleWidth",
        "WK列跨度": "webkitColumnSpan",
        "WK列宽度": "webkitColumnWidth",
        "WK列集": "webkitColumns",
        "WK滤镜": "webkitFilter",
        "WK弹性布局": "webkitFlex",
        "WK弹性分配多余空间": "webkitFlexBasis",
        "WK弹性主轴方向": "webkitFlexDirection",
        "WK弹性流": "webkitFlexFlow",
        "WK弹性放大比例": "webkitFlexGrow",
        "WK弹性缩小比例": "webkitFlexShrink",
        "WK弹性换行": "webkitFlexWrap",
        "WK分布内容": "webkitJustifyContent",
        "WK元素順序": "webkitOrder",
        "WK透视": "webkitPerspective",
        "WK透视原点": "webkitPerspectiveOrigin",
        "WK点击高亮颜色": "webkitTapHighlightColor",
        "WK文本填充颜色": "webkitTextFillColor",
        "WET文字大小调整": "webkitTextSizeAdjust",
        "WK文字笔画": "webkitTextStroke",
        "WK文字笔画颜色": "webkitTextStrokeColor",
        "WK文字笔画宽度": "webkitTextStrokeWidth",
        "WK转换": "webkitTransform",
        "WK转换原点": "webkitTransformOrigin",
        "WK转换样式": "webkitTransformStyle",
        "WK过渡": "webkitTransition",
        "WK过渡延迟": "webkitTransitionDelay",
        "WK过渡时间": "webkitTransitionDuration",
        "WK过渡属性": "webkitTransitionProperty",
        "WK过渡效果随时间改变": "webkitTransitionTimingFunction",
        "WK用户修饰符": "webkitUserModify",
        "WK用户选择": "webkitUserSelect",
        "WK写作模式": "webkitWritingMode",
        "空白": "whiteSpace",
        "顶部保留": "widows",
        "单词换行": "wordBreak",
        "字间距": "wordSpacing",
        "自动换行": "wordWrap",
        "写作模式": "writingMode",
        "Z顺序": "zIndex",
        "缩放": "zoom",
        "调整大小": "resize",
        "用户选择": "userSelect",
        "取优先属性": "getPropertyPriority",
        "取属性值": "getPropertyValue",
        "删除属性": "removeProperty",
        "置属性": "setProperty",
        "CSS样式规则": "CSSStyleRule",
        "只可以读": "readOnly",
        "样式表类": "StyleSheet",
        "入口": "imports",
        "样式表列表": "StyleSheetList",
        "是替代": "isAlternate",
        "是优先替代": "isPrefAlternate",
        "主规则": "ownerRule",
        "持有元素": "owningElement",
        "页集": "pages",
        "样式表页列表": "StyleSheetPageList",
        "规则集": "rules",
        "添加导入": "addImport",
        "该URL": "bstrURL",
        "索引值": "lIndex",
        "添加页面规则": "addPageRule",
        "该选择器": "bstrSelector",
        "该样式": "bstrStyle",
        "添加规则": "addRule",
        "删除导入": "removeImport",
        "移除规则": "removeRule",
        "CSS支持规则": "CSSSupportsRule",
        "缓存类": "Cache",
        "添加": "add",
        "请求": "request",
        "请求信息": "RequestInfo",
        "添加所有": "addAll",
        "请求集": "requests",
        "响应类": "Response",
        "匹配所有": "matchAll",
        "放入": "put",
        "响应": "response",
        "缓存存储类": "CacheStorage",
        "有": "has",
        "打开": "open",
        "画板倾斜": "CanvasGradient",
        "添加颜色停止": "addColorStop",
        "画板模式": "CanvasPattern",
        "置转换": "setTransform",
        "矩阵": "matrix",
        "SVG矩阵": "SVGMatrix",
        "画板渲染2D语境": "CanvasRenderingContext2D",
        "画板路径方法集": "CanvasPathMethods",
        "画板": "canvas",
        "超文本画板元素": "HTMLCanvasElement",
        "填充样式": "fillStyle",
        "全局通道": "globalAlpha",
        "全局复合运算": "globalCompositeOperation",
        "图像平滑功能": "imageSmoothingEnabled",
        "线端": "lineCap",
        "线点偏移": "lineDashOffset",
        "线连接": "lineJoin",
        "线宽度": "lineWidth",
        "尖角限量": "miterLimit",
        "MS填充规则": "msFillRule",
        "阴影模糊": "shadowBlur",
        "阴影颜色": "shadowColor",
        "阴影偏移X": "shadowOffsetX",
        "阴影偏移Y": "shadowOffsetY",
        "笔画风格": "strokeStyle",
        "文本基线": "textBaseline",
        "MOZ图像平滑功能": "mozImageSmoothingEnabled",
        "WK图像平滑功能": "webkitImageSmoothingEnabled",
        "O图像平滑功能": "oImageSmoothingEnabled",
        "开始路径": "beginPath",
        "明确矩形": "clearRect",
        "创建图像数据": "createImageData",
        "图像数据或软件": "imageDataOrSw",
        "图像数据类": "ImageData",
        "创建线性渐变": "createLinearGradient",
        "创建模式": "createPattern",
        "图像": "image",
        "超文本图像元素": "HTMLImageElement",
        "超文本视频元素": "HTMLVideoElement",
        "重复结构": "repetition",
        "创建径向渐变": "createRadialGradient",
        "绘制焦点如果需要": "drawFocusIfNeeded",
        "元素": "element",
        "画图像": "drawImage",
        "偏移X": "offsetX",
        "偏移Y": "offsetY",
        "画板偏移X": "canvasOffsetX",
        "画板偏移Y": "canvasOffsetY",
        "画板图像宽度": "canvasImageWidth",
        "画板图像高度": "canvasImageHeight",
        "填充矩形": "fillRect",
        "填充文本": "fillText",
        "取图像数据": "getImageData",
        "取线数据": "getLineDash",
        "是点在路径": "isPointInPath",
        "测量文本": "measureText",
        "文本度量": "TextMetrics",
        "放入图像数据": "putImageData",
        "图像数据": "imagedata",
        "放置X": "dirtyX",
        "放置Y": "dirtyY",
        "放置宽度": "dirtyWidth",
        "放置高度": "dirtyHeight",
        "还原": "restore",
        "调整角度": "angle",
        "保存": "save",
        "置线破折号": "setLineDash",
        "分段": "segments",
        "路径": "path",
        "路径2D": "Path2D",
        "轮廓范围": "strokeRect",
        "轮廓文本": "strokeText",
        "字符数据类": "CharacterData",
        "子节点": "ChildNode",
        "追加数据": "appendData",
        "删除数据": "deleteData",
        "插入数据": "insertData",
        "替换数据": "replaceData",
        "子字符串数据": "substringData",
        "客户矩形": "ClientRect",
        "客户矩形列表": "ClientRectList",
        "剪贴板事件类": "ClipboardEvent",
        "剪贴板数据": "clipboardData",
        "数据传输类": "DataTransfer",
        "剪贴板事件初始化": "ClipboardEventInit",
        "关闭事件类": "CloseEvent",
        "初始化关闭事件类": "initCloseEvent",
        "是干净参数": "wasCleanArg",
        "编码参数": "codeArg",
        "原因参数": "reasonArg",
        "注释": "Comment",
        "复合事件类": "CompositionEvent",
        "UI事件类": "UIEvent",
        "初始化复合事件类": "initCompositionEvent",
        "视图参数": "viewArg",
        "数据参数": "dataArg",
        "控制台类": "Console",
        "断言": "assert",
        "可选参数": "optionalParams",
        "计数标题": "countTitle",
        "调试程序": "debug",
        "显示XML": "dirxml",
        "例外": "exception",
        "组": "group",
        "组标题": "groupTitle",
        "分组信息": "groupCollapsed",
        "组结束": "groupEnd",
        "信息": "info",
        "MS是独立组成": "msIsIndependentlyComposed",
        "简介": "profile",
        "报告名称": "reportName",
        "简介结束": "profileEnd",
        "选择": "select",
        "表格": "table",
        "定时器名字": "timerName",
        "定时器结束": "timeEnd",
        "追踪": "trace",
        "警告": "warn",
        "恢复正常": "normalize",
        "坐标系": "Coordinates",
        "精确": "accuracy",
        "海拔高度": "altitude",
        "高度准确性": "altitudeAccuracy",
        "题名": "heading",
        "纬度": "latitude",
        "经度": "longitude",
        "速度": "speed",
        "密码类": "Crypto",
        "随机源": "RandomSource",
        "精密": "subtle",
        "精密密码": "SubtleCrypto",
        "密码键": "CryptoKey",
        "提取": "extractable",
        "用法": "usages",
        "加密密钥对": "CryptoKeyPair",
        "私钥": "privateKey",
        "公钥": "publicKey",
        "自定义事件类": "CustomEvent",
        "初始化自定义事件类": "initCustomEvent",
        "详细参数": "detailArg",
        "DOM错误": "DOMError",
        "DOM例外": "DOMException",
        "中断_错误": "ABORT_ERR",
        "数据_复制_错误": "DATA_CLONE_ERR",
        "DOM字符串_大小_错误": "DOMSTRING_SIZE_ERR",
        "层次_要求_错误": "HIERARCHY_REQUEST_ERR",
        "索引_大小_错误": "INDEX_SIZE_ERR",
        "使用_特性_错误": "INUSE_ATTRIBUTE_ERR",
        "无效_访问_错误": "INVALID_ACCESS_ERR",
        "无效_字符_错误": "INVALID_CHARACTER_ERR",
        "无效_修饰符_错误": "INVALID_MODIFICATION_ERR",
        "无效_节点_类型_错误": "INVALID_NODE_TYPE_ERR",
        "无效_状态_错误": "INVALID_STATE_ERR",
        "名称空间_错误": "NAMESPACE_ERR",
        "网络_错误": "NETWORK_ERR",
        "没有_发现_错误": "NOT_FOUND_ERR",
        "没有_支持_错误": "NOT_SUPPORTED_ERR",
        "无_数据_允许_错误": "NO_DATA_ALLOWED_ERR",
        "无_修饰符_允许_错误": "NO_MODIFICATION_ALLOWED_ERR",
        "解析_错误": "PARSE_ERR",
        "超过_配额_错误": "QUOTA_EXCEEDED_ERR",
        "安全_错误": "SECURITY_ERR",
        "序列化_错误": "SERIALIZE_ERR",
        "语法_错误": "SYNTAX_ERR",
        "超时_错误": "TIMEOUT_ERR",
        "类型_不匹配_错误": "TYPE_MISMATCH_ERR",
        "URL_不匹配_错误": "URL_MISMATCH_ERR",
        "验证_错误": "VALIDATION_ERR",
        "错误_文件错误": "WRONG_DOCUMENT_ERR",
        "DOM实现": "DOMImplementation",
        "创建文档": "createDocument",
        "限定名": "qualifiedName",
        "文档类型": "doctype",
        "文档类型类": "DocumentType",
        "文档类": "Document",
        "创建文件类型": "createDocumentType",
        "公共ID": "publicId",
        "系统ID": "systemId",
        "创建超文本文档": "createHTMLDocument",
        "标题": "title",
        "有特征": "hasFeature",
        "DOM解析器": "DOMParser",
        "解析字符串": "parseFromString",
        "MIME类型": "mimeType",
        "DOM可设置令牌列表": "DOMSettableTokenList",
        "DOM令牌列表": "DOMTokenList",
        "DOM字符串列表": "DOMStringList",
        "包含": "contains",
        "字符串": "str",
        "DOM文字映射": "DOMStringMap",
        "令牌": "token",
        "去除": "remove",
        "切换": "toggle",
        "强制": "force",
        "数据提示": "DataCue",
        "文本轨道提示": "TextTrackCue",
        "文本轨道提示事件映射": "TextTrackCueEventMap",
        "目标允许": "dropEffect",
        "效果允许": "effectAllowed",
        "文件集": "files",
        "文件列表": "FileList",
        "数据转移项目列表": "DataTransferItemList",
        "类型集": "types",
        "清除数据": "clearData",
        "取数据": "getData",
        "置数据": "setData",
        "数据迁移项目": "DataTransferItem",
        "取转为文件": "getAsFile",
        "文件类": "File",
        "取转为文字": "getAsString",
        "_回调": "_callback",
        "回调函数字符串": "FunctionStringCallback",
        "WK取转为入口": "webkitGetAsEntry",
        "延期许可请求": "DeferredPermissionRequest",
        "允许": "allow",
        "否认": "deny",
        "延迟时间": "delayTime",
        "设备加速度": "DeviceAcceleration",
        "设备灯光事件类": "DeviceLightEvent",
        "设备运动事件类": "DeviceMotionEvent",
        "设备旋转速度": "DeviceRotationRate",
        "初始化设备动作事件类": "initDeviceMotionEvent",
        "设备定位事件类": "DeviceOrientationEvent",
        "初始化设备定位事件类": "initDeviceOrientationEvent",
        "文档事件映射": "DocumentEventMap",
        "全局事件处理程序事件映射": "GlobalEventHandlersEventMap",
        "可以播放正常": "canplaythrough",
        "指针事件类": "PointerEvent",
        "MS手势事件类": "MSGestureEvent",
        "MS指针事件类": "MSPointerEvent",
        "滚动": "scroll",
        "全球事件处理程序": "GlobalEventHandlers",
        "节点选择器": "NodeSelector",
        "文档事件类": "DocumentEvent",
        "父节点类": "ParentNode",
        "文档或阴影根": "DocumentOrShadowRoot",
        "URL解码": "URLUnencoded",
        "活动元素": "activeElement",
        "超链接颜色": "alinkColor",
        "所有": "all",
        "超文本所有集合": "HTMLAllCollection",
        "锚集": "anchors",
        "超文本集合的": "HTMLCollectionOf",
        "超文本L锚元素": "HTMLAnchorElement",
        "小程序集": "applets",
        "超文本小程序元素": "HTMLAppletElement",
        "背景色": "bgColor",
        "超文本元素": "HTMLElement",
        "编码设置": "characterSet",
        "字符集": "charset",
        "兼容模式": "compatMode",
        "身份储存": "cookie",
        "当前脚本": "currentScript",
        "超文本脚本元素": "HTMLScriptElement",
        "SVG脚本元素": "SVGScriptElement",
        "默认视图": "defaultView",
        "设计模式": "designMode",
        "文档元素": "documentElement",
        "嵌入对象集": "embeds",
        "超文本嵌入元素": "HTMLEmbedElement",
        "前景色": "fgColor",
        "表单集": "forms",
        "超文本表单元素": "HTMLFormElement",
        "全屏幕元素": "fullscreenElement",
        "全屏幕启用": "fullscreenEnabled",
        "文档头": "head",
        "超文本文档头元素": "HTMLHeadElement",
        "隐藏": "hidden",
        "图像集": "images",
        "文档实现": "implementation",
        "输入编码": "inputEncoding",
        "最后修改": "lastModified",
        "链接颜色": "linkColor",
        "链接集": "links",
        "超文本图像映射区域元素": "HTMLAreaElement",
        "本地类": "Location",
        "MS_CSS元素浮点量": "msCSSOMElementFloatMetrics",
        "MS关闭大写锁定警告": "msCapsLockWarningOff",
        "引发终止": "onabort",
        "引发激活": "onactivate",
        "引发激活前": "onbeforeactivate",
        "引发失去焦点之前": "onbeforedeactivate",
        "引发失去焦点": "onblur",
        "引发可以播放": "oncanplay",
        "引发可以正常播放": "oncanplaythrough",
        "引发点击": "onclick",
        "引发语境菜单": "oncontextmenu",
        "引发双击": "ondblclick",
        "引发被激活": "ondeactivate",
        "引发拖拽": "ondrag",
        "引发拖拽结束": "ondragend",
        "引发拖拽确认": "ondragenter",
        "引发拖拽离开": "ondragleave",
        "引发拖拽悬停": "ondragover",
        "引发拖拽开始": "ondragstart",
        "引发拖放": "ondrop",
        "引发时常被改变": "ondurationchange",
        "引发清空": "onemptied",
        "引发获得焦点": "onfocus",
        "引发全屏化": "onfullscreenchange",
        "引发全屏错误": "onfullscreenerror",
        "引发输入": "oninput",
        "引发无效ID": "oninvalid",
        "引发键按下": "onkeydown",
        "引发按键集": "onkeypress",
        "引发键松开": "onkeyup",
        "引发加载": "onload",
        "引发加载数据": "onloadeddata",
        "引发加载元数据": "onloadedmetadata",
        "引发加载启动": "onloadstart",
        "引发鼠标按下": "onmousedown",
        "引发鼠标移动": "onmousemove",
        "引发鼠标移出": "onmouseout",
        "引发鼠标悬停": "onmouseover",
        "引发鼠标松开": "onmouseup",
        "引发鼠标滚轮": "onmousewheel",
        "引发MS内容缩放": "onmscontentzoom",
        "引发MS手势改变": "onmsgesturechange",
        "引发MS手势双击": "onmsgesturedoubletap",
        "引发MS手势结束": "onmsgestureend",
        "引发MS手势保持": "onmsgesturehold",
        "引发MS手势开始": "onmsgesturestart",
        "引发MS手势点击": "onmsgesturetap",
        "引发MS惯性开始": "onmsinertiastart",
        "引发MS操作状态改变": "onmsmanipulationstatechanged",
        "引发MS指针取消": "onmspointercancel",
        "引发MS指针按下": "onmspointerdown",
        "引发MS指针确认": "onmspointerenter",
        "引发MS指针离开": "onmspointerleave",
        "引发MS指针移动": "onmspointermove",
        "引发MS指针移出": "onmspointerout",
        "引发MS指针悬停": "onmspointerover",
        "引发MS指针松开": "onmspointerup",
        "引发MS删除站点模式跳转列表项": "onmssitemodejumplistitemremoved",
        "引发MS点击缩略图": "onmsthumbnailclick",
        "引发暂停": "onpause",
        "引发播放": "onplay",
        "引发播放中": "onplaying",
        "引发指针锁改变": "onpointerlockchange",
        "引发指针锁错误": "onpointerlockerror",
        "引发速率改变": "onratechange",
        "引发就绪状态改变": "onreadystatechange",
        "引发复位": "onreset",
        "引发滚动": "onscroll",
        "引发寻找": "onseeked",
        "引发寻找中": "onseeking",
        "引发选择": "onselect",
        "引发选择改变": "onselectionchange",
        "引发选择开始": "onselectstart",
        "引发停滞": "onstalled",
        "引发停止": "onstop",
        "引发提交": "onsubmit",
        "引发读取终止": "onsuspend",
        "引发播放位置改变": "ontimeupdate",
        "引发触摸取消": "ontouchcancel",
        "引发触摸结束": "ontouchend",
        "引发触摸移动": "ontouchmove",
        "引发触摸开始": "ontouchstart",
        "引发体积变化": "onvolumechange",
        "引发等待": "onwaiting",
        "引发WE全屏化": "onwebkitfullscreenchange",
        "引发WE全屏幕错误": "onwebkitfullscreenerror",
        "插件集": "plugins",
        "指针锁定元素": "pointerLockElement",
        "就绪状态": "readyState",
        "根元素": "rootElement",
        "SVG自身元素": "SVGSVGElement",
        "脚本集": "scripts",
        "滚动元素": "scrollingElement",
        "样式表集": "styleSheets",
        "可见性状态": "visibilityState",
        "访问过颜色": "vlinkColor",
        "WK当前全屏元素": "webkitCurrentFullScreenElement",
        "WK全屏元素": "webkitFullscreenElement",
        "WK全屏启用": "webkitFullscreenEnabled",
        "WK是全屏": "webkitIsFullScreen",
        "XML编码": "xmlEncoding",
        "XML脱机": "xmlStandalone",
        "XML版本": "xmlVersion",
        "收集节点": "adoptNode",
        "捕获事件类": "captureEvents",
        "插入范围从点": "caretRangeFromPoint",
        "范围类": "Range",
        "创建特性": "createAttribute",
        "创建特性NS": "createAttributeNS",
        "创建CDATA节": "createCDATASection",
        "创建注释": "createComment",
        "创建文档片段": "createDocumentFragment",
        "文档片段类": "DocumentFragment",
        "创建元素": "createElement",
        "超文本元素标签名称映射": "HTMLElementTagNameMap",
        "标签名称": "tagName",
        "创建元素NS": "createElementNS",
        "SVG超链接元素": "SVGAElement",
        "SVG圆元素": "SVGCircleElement",
        "SVG剪辑路径元素": "SVGClipPathElement",
        "组件传递函数": "componentTransferFunction",
        "SVG组件传递函数元素": "SVGComponentTransferFunctionElement",
        "SVG被引用元素": "SVGDefsElement",
        "SVG文本描述": "SVGDescElement",
        "椭圆": "ellipse",
        "SVG椭圆元素": "SVGEllipseElement",
        "滤镜合成元素": "feBlend",
        "SVG滤镜合成元素": "SVGFEBlendElement",
        "滤镜颜色矩阵": "feColorMatrix",
        "SVG滤镜颜色矩阵元素": "SVGFEColorMatrixElement",
        "滤镜成分转换": "feComponentTransfer",
        "SVG滤镜成分转换元素": "SVGFEComponentTransferElement",
        "滤镜混合元素": "feComposite",
        "SVG滤镜混合元素": "SVGFECompositeElement",
        "滤镜卷积矩阵": "feConvolveMatrix",
        "SVG滤镜卷积矩阵元素": "SVGFEConvolveMatrixElement",
        "滤镜漫照射灯光": "feDiffuseLighting",
        "SVG滤镜漫照射灯光元素": "SVGFEDiffuseLightingElement",
        "滤镜位移贴图": "feDisplacementMap",
        "SVG滤镜位移贴图元素": "SVGFEDisplacementMapElement",
        "滤镜位移灯光": "feDistantLight",
        "SVG滤镜位移灯光元素": "SVGFEDistantLightElement",
        "滤镜洪水": "feFlood",
        "SVG滤镜洪水元素": "SVGFEFloodElement",
        "滤镜函数A": "feFuncA",
        "SVG滤镜函数A元素": "SVGFEFuncAElement",
        "滤镜函数B": "feFuncB",
        "SVG滤镜函数B元素": "SVGFEFuncBElement",
        "滤镜函数G": "feFuncG",
        "SVG滤镜函数G元素": "SVGFEFuncGElement",
        "滤镜函数R": "feFuncR",
        "SVG滤镜函数R元素": "SVGFEFuncRElement",
        "滤镜高斯模糊": "feGaussianBlur",
        "SVG滤镜高斯模糊元素": "SVGFEGaussianBlurElement",
        "滤镜图像": "feImage",
        "SVG滤镜图像元素": "SVGFEImageElement",
        "滤镜合并": "feMerge",
        "SVG滤镜合并元素": "SVGFEMergeElement",
        "滤镜合并节点": "feMergeNode",
        "SVG滤镜合并节点元素": "SVGFEMergeNodeElement",
        "滤镜形态": "feMorphology",
        "SVG滤镜形态元素": "SVGFEMorphologyElement",
        "滤镜偏移": "feOffset",
        "SVG滤镜偏移元素": "SVGFEOffsetElement",
        "滤镜点光源": "fePointLight",
        "SVG滤镜点光源元素": "SVGFEPointLightElement",
        "滤镜面光灯": "feSpecularLighting",
        "SVG滤镜面光灯元素": "SVGFESpecularLightingElement",
        "滤镜聚光灯": "feSpotLight",
        "SVG滤镜聚光灯元素": "SVGFESpotLightElement",
        "滤镜平铺": "feTile",
        "SVG滤镜平铺元素": "SVGFETileElement",
        "滤镜湍流": "feTurbulence",
        "SVG滤镜湍流元素": "SVGFETurbulenceElement",
        "SVG滤镜元素": "SVGFilterElement",
        "外部对象": "foreignObject",
        "SVG外部对象元素": "SVGForeignObjectElement",
        "SVG组元素": "SVGGElement",
        "SVG图像元素": "SVGImageElement",
        "渐变": "gradient",
        "SVG渐变元素": "SVGGradientElement",
        "SVG线元素": "SVGLineElement",
        "线性渐变": "linearGradient",
        "SVG线性渐变元素": "SVGLinearGradientElement",
        "SVG标志元素": "SVGMarkerElement",
        "SVG遮罩元素": "SVGMaskElement",
        "SVG路径元素": "SVGPathElement",
        "SVG元数据元素": "SVGMetadataElement",
        "SVG模式元素": "SVGPatternElement",
        "SVG多边型元素": "SVGPolygonElement",
        "SVG多段线元素": "SVGPolylineElement",
        "径向": "radialGradient",
        "SVG径向元素": "SVGRadialGradientElement",
        "矩形": "rect",
        "SVG矩形元素": "SVGRectElement",
        "矢量图形": "svg",
        "SVG停止元素": "SVGStopElement",
        "SVG样式元素": "SVGStyleElement",
        "SVG条件元素": "SVGSwitchElement",
        "SVG符号元素": "SVGSymbolElement",
        "SVG文本跨度元素": "SVGTSpanElement",
        "文本内容": "textContent",
        "SVG文本内容元素": "SVGTextContentElement",
        "SVG文本元素": "SVGTextElement",
        "文本路径": "textPath",
        "SVG文本路径元素": "SVGTextPathElement",
        "文本定位": "textPositioning",
        "SVG文本定位元素": "SVGTextPositioningElement",
        "SVG标题元素": "SVGTitleElement",
        "使用": "use",
        "SVG引用元素": "SVGUseElement",
        "SVG视图元素": "SVGViewElement",
        "SVG元素": "SVGElement",
        "创建表达式": "createExpression",
        "表达式": "expression",
        "解析器": "resolver",
        "X路径NS解析器": "XPathNSResolver",
        "X路径表达式": "XPathExpression",
        "创建NS解析式": "createNSResolver",
        "节点解析器": "nodeResolver",
        "创建节点迭代器": "createNodeIterator",
        "如何显示": "whatToShow",
        "节点过滤": "NodeFilter",
        "实体引用扩展": "entityReferenceExpansion",
        "节点迭代器": "NodeIterator",
        "创建处理指令": "createProcessingInstruction",
        "处理指令": "ProcessingInstruction",
        "创建范围": "createRange",
        "创建文本节点": "createTextNode",
        "创建触摸": "createTouch",
        "标识符": "identifier",
        "页面X": "pageX",
        "页面Y": "pageY",
        "触摸类": "Touch",
        "创建触摸列表": "createTouchList",
        "触动": "touches",
        "触摸列表": "TouchList",
        "创建树遍历": "createTreeWalker",
        "树遍历类": "TreeWalker",
        "从点位取元素": "elementFromPoint",
        "求值": "evaluate",
        "语境节点": "contextNode",
        "结果": "result",
        "X路径结果": "XPathResult",
        "执行命令": "execCommand",
        "命令ID": "commandId",
        "显示UI": "showUI",
        "执行命令显示帮助": "execCommandShowHelp",
        "退出全屏": "exitFullscreen",
        "退出指针锁定": "exitPointerLock",
        "取元素根据ID": "getElementById",
        "元素ID": "elementId",
        "取元素根据类名": "getElementsByClassName",
        "类名集": "classNames",
        "取元素根据名称": "getElementsByName",
        "元素名称": "elementName",
        "节点列表": "NodeListOf",
        "取元素根据标签名称": "getElementsByTagName",
        "元素列表标签名称映射": "ElementListTagNameMap",
        "标签名字": "tagname",
        "取元素根据标签名称NS": "getElementsByTagNameNS",
        "本地名称": "localName",
        "取选择": "getSelection",
        "选择类": "Selection",
        "有焦点": "hasFocus",
        "引入节点": "importNode",
        "输入节点": "importedNode",
        "深远": "deep",
        "MS从点位取元素": "msElementsFromPoint",
        "MS从范围取元素": "msElementsFromRect",
        "特征": "features",
        "查询命令启用": "queryCommandEnabled",
        "查询命令是否确定": "queryCommandIndeterm",
        "查询命令状态": "queryCommandState",
        "查询命令支持": "queryCommandSupported",
        "查询命令文本": "queryCommandText",
        "查询命令值": "queryCommandValue",
        "释放事件集": "releaseEvents",
        "更新设置": "updateSettings",
        "WK取消全屏": "webkitCancelFullScreen",
        "WK退出全屏": "webkitExitFullscreen",
        "写": "write",
        "写行": "writeln",
        "实体对象": "entities",
        "名称节点映射类": "NamedNodeMap",
        "内部子集": "internalSubset",
        "批注": "notations",
        "数据传输": "dataTransfer",
        "初始化拖拽事件类": "initDragEvent",
        "屏幕X参数": "screenXArg",
        "屏幕Y参数": "screenYArg",
        "客户C参数": "clientXArg",
        "客户Y参数": "clientYArg",
        "CTRL键参数": "ctrlKeyArg",
        "ALT键参数": "altKeyArg",
        "SHIFT键参数": "shiftKeyArg",
        "META键参数": "metaKeyArg",
        "按钮参数": "buttonArg",
        "相关目标参数": "relatedTargetArg",
        "数据传输参数": "dataTransferArg",
        "MS转换URL": "msConvertURL",
        "文件": "file",
        "目标类型": "targetType",
        "目标URL": "targetURL",
        "攻击": "attack",
        "关节": "knee",
        "系数": "ratio",
        "简化": "reduction",
        "释放": "release",
        "Ext_片段_景深": "EXT_frag_depth",
        "Ext_纹理_过滤_各向_异性": "EXT_texture_filter_anisotropic",
        "最大_纹理_最大_各向_异性_EXT": "MAX_TEXTURE_MAX_ANISOTROPY_EXT",
        "纹理_最大_各向_异性": "TEXTURE_MAX_ANISOTROPY_EXT",
        "元素事件映射": "ElementEventMap",
        "元素遍历类": "ElementTraversal",
        "分类列表": "classList",
        "类名称": "className",
        "客户高度": "clientHeight",
        "客户左边": "clientLeft",
        "客户上部": "clientTop",
        "客户宽度": "clientWidth",
        "内部超文本": "innerHTML",
        "MS内容缩放因子": "msContentZoomFactor",
        "MS区域溢出": "msRegionOverflow",
        "引发ARIA查询": "onariarequest",
        "引发命令": "oncommand",
        "引发有捕获指针": "ongotpointercapture",
        "引发失去了指针捕获": "onlostpointercapture",
        "引发MS有指针捕获": "onmsgotpointercapture",
        "引发MS失去了指针捕获": "onmslostpointercapture",
        "外部超文本": "outerHTML",
        "滚动高度": "scrollHeight",
        "滚动左边": "scrollLeft",
        "滚动上部": "scrollTop",
        "滚动宽度": "scrollWidth",
        "分配插槽": "assignedSlot",
        "超文本插槽元素": "HTMLSlotElement",
        "插槽": "slot",
        "阴影根": "shadowRoot",
        "阴影根类": "ShadowRoot",
        "取特性": "getAttribute",
        "取特性NS": "getAttributeNS",
        "取特性节点": "getAttributeNode",
        "取特性节点NS": "getAttributeNodeNS",
        "取包围客户范围": "getBoundingClientRect",
        "取客户范围集": "getClientRects",
        "有特性": "hasAttribute",
        "有特性NS": "hasAttributeNS",
        "MS获取区域内容": "msGetRegionContent",
        "MS获取区域": "MSRangeCollection",
        "MS取转化界限": "msGetUntransformedBounds",
        "MS匹配选择器": "msMatchesSelector",
        "选择器集": "selectors",
        "MS释放指针捕获": "msReleasePointerCapture",
        "MS置指针捕获": "msSetPointerCapture",
        "MS缩放到": "msZoomTo",
        "释放指针捕获": "releasePointerCapture",
        "删除特性": "removeAttribute",
        "删除特性NS": "removeAttributeNS",
        "删除特性节点": "removeAttributeNode",
        "老特性": "oldAttr",
        "请求全屏": "requestFullscreen",
        "请求指针锁定": "requestPointerLock",
        "置特性": "setAttribute",
        "置特性NS": "setAttributeNS",
        "置特性节点": "setAttributeNode",
        "新特性": "newAttr",
        "置特性节点NS": "setAttributeNodeNS",
        "置指针捕获": "setPointerCapture",
        "WK匹配选择器": "webkitMatchesSelector",
        "WK请求全屏1": "webkitRequestFullScreen",
        "WK请求全屏2": "webkitRequestFullscreen",
        "匹配集": "matches",
        "最近": "closest",
        "滚动到视图": "scrollIntoView",
        "滚动到视图选项集": "ScrollIntoViewOptions",
        "滚动到选项集": "ScrollToOptions",
        "滚动到": "scrollTo",
        "滚动过": "scrollBy",
        "插入相邻元素": "insertAdjacentElement",
        "插入元素": "insertedElement",
        "插入相邻超文本": "insertAdjacentHTML",
        "哪里": "where",
        "超文本": "html",
        "插入相邻文本": "insertAdjacentText",
        "添加阴影": "attachShadow",
        "根阴影初始化词典": "shadowRootInitDict",
        "阴影根初始化": "ShadowRootInit",
        "初始化错误事件类": "initErrorEvent",
        "消息参数": "messageArg",
        "文件名字参数": "filenameArg",
        "线路参数": "linenoArg",
        "错误事件初始化词典": "errorEventInitDict",
        "取消冒泡": "cancelBubble",
        "当前目标": "currentTarget",
        "默认阻止": "defaultPrevented",
        "事件阶段": "eventPhase",
        "是可信": "isTrusted",
        "SRC元素": "srcElement",
        "时间戳": "timeStamp",
        "初始化事件类": "initEvent",
        "事件类型参数": "eventTypeArg",
        "防止默认": "preventDefault",
        "立即停止传播": "stopImmediatePropagation",
        "停止传播": "stopPropagation",
        "深路径": "deepPath",
        "转为_目标": "AT_TARGET",
        "冒泡_阶段": "BUBBLING_PHASE",
        "捕获_阶段": "CAPTURING_PHASE",
        "调度事件类": "dispatchEvent",
        "删除事件侦听器": "removeEventListener",
        "扩展脚本API集": "ExtensionScriptApis",
        "扩展ID到短ID": "extensionIdToShortId",
        "扩展ID": "extensionId",
        "发射扩展API遥测": "fireExtensionApiTelemetry",
        "函数名称": "functionName",
        "是达到": "isSucceeded",
        "是支持": "isSupported",
        "通用函数": "genericFunction",
        "路由器地址": "routerAddress",
        "回调ID": "callbackId",
        "通用同步函数": "genericSynchronousFunction",
        "函数ID": "functionId",
        "取扩展ID": "getExtensionId",
        "注册通用函数回调处理程序": "registerGenericFunctionCallbackHandler",
        "回调处理程序": "callbackHandler",
        "寄存通用持久回调处理程序": "registerGenericPersistentCallbackHandler",
        "外部类": "External",
        "最后修改日期": "lastModifiedDate",
        "WK相对路径": "webkitRelativePath",
        "部分集": "parts",
        "文件属性包": "FilePropertyBag",
        "文件阅读器": "FileReader",
        "MS基文件阅读器": "MSBaseReader",
        "读转为数组缓冲区": "readAsArrayBuffer",
        "二进制": "blob",
        "读转为二进制字符串": "readAsBinaryString",
        "读转为数据URL": "readAsDataURL",
        "读转为文本": "readAsText",
        "编码": "encoding",
        "MS基读事件映射": "MSBaseReaderEventMap",
        "初始化焦点事件类": "initFocusEvent",
        "焦点导航事件类": "FocusNavigationEvent",
        "要求焦点": "requestFocus",
        "表达数据类": "FormData",
        "追加": "append",
        "二进制名称": "blobName",
        "表单": "form",
        "轴": "axes",
        "游戏手柄按钮类": "GamepadButton",
        "有联系": "connected",
        "映射图": "mapping",
        "按下": "pressed",
        "游戏手柄事件类": "GamepadEvent",
        "地理位置类": "Geolocation",
        "清除监控": "clearWatch",
        "监控ID": "watchId",
        "取当前位置": "getCurrentPosition",
        "位置回调": "PositionCallback",
        "位置错误回调": "PositionErrorCallback",
        "监控位置": "watchPosition",
        "名称或索引": "nameOrIndex",
        "超文本集合": "HTMLCollection",
        "指定项目": "namedItem",
        "方法集": "Methods",
        "坐标集": "coords",
        "下载": "download",
        "哈希": "hash",
        "主机": "host",
        "主机名称": "hostname",
        "链接目标语言": "hreflang",
        "名字属性": "nameProp",
        "路径名字": "pathname",
        "长协议": "protocolLong",
        "从源到目标关系": "rel",
        "从目标到源关系": "rev",
        "形状": "shape",
        "超文本元素事件映射": "HTMLElementEventMap",
        "基链接目标": "BaseHref",
        "排列": "align",
        "替代文本": "alt",
        "替代超文本": "altHtml",
        "档案": "archive",
        "代码基": "codeBase",
        "代码类型": "codeType",
        "文档内容": "contentDocument",
        "水平间距": "hspace",
        "备用": "standby",
        "使用映射": "useMap",
        "垂直间距": "vspace",
        "没有链接目标": "noHref",
        "超文本区域集合": "HTMLAreasCollection",
        "超文本集合基": "HTMLCollectionBase",
        "超文本音频元素": "HTMLAudioElement",
        "超文本媒体元素事件映射": "HTMLMediaElementEventMap",
        "超文本BR元素": "HTMLBRElement",
        "超文本基元素": "HTMLBaseElement",
        "超文本基字体元素": "HTMLBaseFontElement",
        "DOM_L2过时颜色属性": "DOML2DeprecatedColorProperty",
        "面向": "face",
        "超文本体元素事件映射": "HTMLBodyElementEventMap",
        "转移状态": "popstate",
        "转移状态事件类": "PopStateEvent",
        "引发打印后": "onafterprint",
        "引发打印之前": "onbeforeprint",
        "引发卸载前": "onbeforeunload",
        "引发哈希改变": "onhashchange",
        "引发有消息": "onmessage",
        "引发离线": "onoffline",
        "引发上线": "ononline",
        "引发定位改变": "onorientationchange",
        "引发页面隐藏": "onpagehide",
        "引发页面显示": "onpageshow",
        "引发转移状态": "onpopstate",
        "引发调整": "onresize",
        "引发储存": "onstorage",
        "引发卸载": "onunload",
        "超文本按钮元素": "HTMLButtonElement",
        "自动对焦": "autofocus",
        "已禁用": "disabled",
        "表单操作": "formAction",
        "表单内容类型": "formEnctype",
        "表单方法": "formMethod",
        "表单没有验证": "formNoValidate",
        "表单目标": "formTarget",
        "验证消息": "validationMessage",
        "有效性": "validity",
        "有效性状态": "ValidityState",
        "要验证": "willValidate",
        "检查有效性": "checkValidity",
        "置自定义有效性": "setCustomValidity",
        "取语境": "getContext",
        "语境ID": "contextId",
        "语境特性": "contextAttributes",
        "画板2D语境特性": "Canvas2DContextAttributes",
        "Web3D绘图标准": "webgl",
        "WEBGL渲染语境": "WebGLRenderingContext",
        "MS转成二进制对象": "msToBlob",
        "转成数据URL": "toDataURL",
        "转成二进制": "toBlob",
        "回调": "callback",
        "超文本D列表元素": "HTMLDListElement",
        "是否减少间隔": "compact",
        "超文本数据元素": "HTMLDataElement",
        "超文本数据列表元素": "HTMLDataListElement",
        "超文本选项元素": "HTMLOptionElement",
        "超文本目录元素": "HTMLDirectoryElement",
        "超文本块元素": "HTMLDivElement",
        "超文本文档": "HTMLDocument",
        "快捷访问键": "accessKey",
        "子集": "children",
        "内容编辑": "contentEditable",
        "数据集": "dataset",
        "可拖动": "draggable",
        "隐藏焦点": "hideFocus",
        "内部文本": "innerText",
        "是内容编辑": "isContentEditable",
        "偏移高度": "offsetHeight",
        "偏移左边": "offsetLeft",
        "偏移父": "offsetParent",
        "偏移上部": "offsetTop",
        "偏移宽度": "offsetWidth",
        "引发复制前": "onbeforecopy",
        "引发剪切前": "onbeforecut",
        "引发粘贴前": "onbeforepaste",
        "引发复制": "oncopy",
        "引发提示改变": "oncuechange",
        "引发剪切": "oncut",
        "引发鼠标确定": "onmouseenter",
        "引发鼠标离开": "onmouseleave",
        "引发粘贴": "onpaste",
        "外部文本": "outerText",
        "拼写检查": "spellcheck",
        "TAB索引": "tabIndex",
        "拖放": "dragDrop",
        "MS取输入语境": "msGetInputContext",
        "MS输入方法语境": "MSInputMethodContext",
        "取SVG文档类": "GetSVGDocument",
        "MS播放到禁用": "msPlayToDisabled",
        "MS播放首选源URI": "msPlayToPreferredSourceUri",
        "MS播放到初选": "msPlayToPrimary",
        "MS播放到源": "msPlayToSource",
        "调色板": "palette",
        "基本插件": "pluginspage",
        "源": "src",
        "单位": "units",
        "超文本字段集元素": "HTMLFieldSetElement",
        "超文本字体元素": "HTMLFontElement",
        "DOM_L2废弃大小属性": "DOML2DeprecatedSizeProperty",
        "超文本表格控件集合": "HTMLFormControlsCollection",
        "接受字符集": "acceptCharset",
        "行动": "action",
        "自动完成": "autocomplete",
        "元素集": "elements",
        "编码方式": "enctype",
        "没有验证": "noValidate",
        "超文本帧元素事件映射": "HTMLFrameElementEventMap",
        "超文本帧元素": "HTMLFrameElement",
        "内容窗口": "contentWindow",
        "框架边框": "frameBorder",
        "框架间距": "frameSpacing",
        "长描述URL": "longDesc",
        "外框高": "marginHeight",
        "外框宽度": "marginWidth",
        "没有调整大小": "noResize",
        "滚动中": "scrolling",
        "超文本框架集元素事件映射": "HTMLFrameSetElementEventMap",
        "超文本框架集元素": "HTMLFrameSetElement",
        "列集": "cols",
        "行集": "rows",
        "超文本横线元素": "HTMLHRElement",
        "无阴影": "noShade",
        "超文本头元素": "HTMLHeadingElement",
        "超文本自身元素": "HTMLHtmlElement",
        "版本": "version",
        "超文本内嵌框架元素事件映射": "HTMLIFrameElementEventMap",
        "超文本内嵌框架元素": "HTMLIFrameElement",
        "允许全屏": "allowFullscreen",
        "允许支付请求": "allowPaymentRequest",
        "沙盒": "sandbox",
        "完成": "complete",
        "跨域": "crossOrigin",
        "当前源": "currentSrc",
        "是映射": "isMap",
        "短源": "lowsrc",
        "自然高度": "naturalHeight",
        "自然宽度": "naturalWidth",
        "响应大小": "sizes",
        "响应源": "srcset",
        "MS取转为源": "msGetAsCastingSource",
        "超文本输入元素": "HTMLInputElement",
        "选中": "checked",
        "默认选中": "defaultChecked",
        "不确定": "indeterminate",
        "列表": "list",
        "最大长度": "maxLength",
        "多重": "multiple",
        "占位符": "placeholder",
        "必须": "required",
        "选择方向": "selectionDirection",
        "选择结束": "selectionEnd",
        "选中开始": "selectionStart",
        "步幅": "step",
        "值转为日期": "valueAsDate",
        "值转为数字": "valueAsNumber",
        "WK目录": "webkitdirectory",
        "最小长度": "minLength",
        "置选择范围": "setSelectionRange",
        "减速": "stepDown",
        "加快": "stepUp",
        "超文本列表元素": "HTMLLIElement",
        "超文本标签元素": "HTMLLabelElement",
        "标签对象": "htmlFor",
        "超文本定义标题元素": "HTMLLegendElement",
        "超文本链接元素": "HTMLLinkElement",
        "链接样式": "LinkStyle",
        "超文本映射元素": "HTMLMapElement",
        "区域": "areas",
        "超文本选取框元素事件映射": "HTMLMarqueeElementEventMap",
        "超文本选取框元素": "HTMLMarqueeElement",
        "行为": "behavior",
        "引发反弹": "onbounce",
        "引发结束后": "onfinish",
        "引发开始": "onstart",
        "滚动量": "scrollAmount",
        "滚动延迟": "scrollDelay",
        "真加速": "trueSpeed",
        "MS媒体需要秘钥事件类": "MSMediaKeyNeededEvent",
        "音频轨道集": "audioTracks",
        "自动播放": "autoplay",
        "缓冲": "buffered",
        "时间范围": "TimeRanges",
        "控制": "controls",
        "默认静音": "defaultMuted",
        "默认播放速率": "defaultPlaybackRate",
        "媒体错误": "MediaError",
        "媒体按键": "mediaKeys",
        "媒体按键类": "MediaKeys",
        "MS音频分类": "msAudioCategory",
        "MS音频设备类型": "msAudioDeviceType",
        "MS图形信任状态": "msGraphicsTrustStatus",
        "MS图形信任": "MSGraphicsTrust",
        "MS键集": "msKeys",
        "MS媒体键集": "MSMediaKeys",
        "MS实时": "msRealTime",
        "静音": "muted",
        "网络工作状态": "networkState",
        "引发加密": "onencrypted",
        "暂停的": "paused",
        "播放": "played",
        "预载": "preload",
        "可寻址": "seekable",
        "源对象": "srcObject",
        "文本轨道": "textTracks",
        "文本轨道列表类": "TextTrackList",
        "视频轨道集": "videoTracks",
        "视频轨道列表类": "VideoTrackList",
        "添加文本轨道": "addTextTrack",
        "可播放类型": "canPlayType",
        "MS清除效果": "msClearEffects",
        "MS插入音频效果": "msInsertAudioEffect",
        "激活类ID": "activatableClassId",
        "效果要求": "effectRequired",
        "配置": "config",
        "MS置媒体秘钥": "msSetMediaKeys",
        "MS置媒体保护管理": "msSetMediaProtectionManager",
        "媒体保护管理": "mediaProtectionManager",
        "置媒体键": "setMediaKeys",
        "有_目前_数据": "HAVE_CURRENT_DATA",
        "有_足够_数据": "HAVE_ENOUGH_DATA",
        "有_未来_数据": "HAVE_FUTURE_DATA",
        "有_元数据": "HAVE_METADATA",
        "都_没有": "HAVE_NOTHING",
        "网络_空": "NETWORK_EMPTY",
        "网络_空闲": "NETWORK_IDLE",
        "网络_加载": "NETWORK_LOADING",
        "网络_无_源": "NETWORK_NO_SOURCE",
        "超文本菜单元素": "HTMLMenuElement",
        "超文本元数据元素": "HTMLMetaElement",
        "超文本传输相等": "httpEquiv",
        "方案": "scheme",
        "超文本仪表元素": "HTMLMeterElement",
        "高": "high",
        "矮": "low",
        "最佳": "optimum",
        "超文本模型元素": "HTMLModElement",
        "举例": "cite",
        "日期时间": "dateTime",
        "超文本O列表元素": "HTMLOListElement",
        "超文本基对象元素": "HTMLObjectElement",
        "超文本选择组元素": "HTMLOptGroupElement",
        "默认选择": "defaultSelected",
        "超文本选项集合": "HTMLOptionsCollection",
        "选择指数": "selectedIndex",
        "之前": "before",
        "超文本输出元素": "HTMLOutputElement",
        "报告有效性": "reportValidity",
        "超文本段落元素": "HTMLParagraphElement",
        "超文本参数元素": "HTMLParamElement",
        "值类型": "valueType",
        "超文本响应式图像元素": "HTMLPictureElement",
        "超文本预格式化元素": "HTMLPreElement",
        "超文本进度条元素": "HTMLProgressElement",
        "超文本引述元素": "HTMLQuoteElement",
        "推迟": "defer",
        "事件": "event",
        "超文本选择元素": "HTMLSelectElement",
        "选择选项集": "selectedOptions",
        "超文本源文件元素": "HTMLSourceElement",
        "MS键系统": "msKeySystem",
        "超文本跨度元素": "HTMLSpanElement",
        "超文本样式元素": "HTMLStyleElement",
        "超文本表格标题元素": "HTMLTableCaptionElement",
        "垂直对齐方式": "vAlign",
        "超文本表格单格元素": "HTMLTableCellElement",
        "超文本表格对齐方式": "HTMLTableAlignment",
        "缩写": "abbr",
        "对称轴": "axis",
        "单元格索引": "cellIndex",
        "列跨": "colSpan",
        "行跨": "rowSpan",
        "超文本表列元素": "HTMLTableColElement",
        "跨度": "span",
        "超文本表数据单元格元素": "HTMLTableDataCellElement",
        "超文本表格元素": "HTMLTableElement",
        "表头": "caption",
        "单元格填充": "cellPadding",
        "单元格间距": "cellSpacing",
        "框架": "frame",
        "超文本表格行元素": "HTMLTableRowElement",
        "摘要": "summary",
        "表表体集": "tBodies",
        "超文本表片段元素": "HTMLTableSectionElement",
        "表底脚": "tFoot",
        "表表头": "tHead",
        "创建表头内容": "createCaption",
        "创建表体": "createTBody",
        "创建表底脚": "createTFoot",
        "创建表表头": "createTHead",
        "删除表头内容": "deleteCaption",
        "删除行": "deleteRow",
        "删除表底脚": "deleteTFoot",
        "删除表表头": "deleteTHead",
        "插入行": "insertRow",
        "超文本表头单元元素": "HTMLTableHeaderCellElement",
        "单元格集": "cells",
        "行索引": "rowIndex",
        "部分行索引": "sectionRowIndex",
        "删除单元格": "deleteCell",
        "插入单元格": "insertCell",
        "超文本模板元素": "HTMLTemplateElement",
        "超文本文本区域元素": "HTMLTextAreaElement",
        "换行": "wrap",
        "超文本时间元素": "HTMLTimeElement",
        "超文本标题元素": "HTMLTitleElement",
        "超文本轨道元素": "HTMLTrackElement",
        "长源": "srclang",
        "错误_": "ERROR",
        "加载_": "LOADED",
        "加载中_": "LOADING",
        "节点_": "NONE",
        "超文本U列表元素": "HTMLUListElement",
        "超文本未知元素": "HTMLUnknownElement",
        "超文本视频元素事件映射": "HTMLVideoElementEventMap",
        "MS水平镜像": "msHorizontalMirror",
        "MS是布局优化回放": "msIsLayoutOptimalForPlayback",
        "MS是立体3D": "msIsStereo3D",
        "MS立体3D包装模式": "msStereo3DPackingMode",
        "MS立体3D渲染模式": "msStereo3DRenderMode",
        "MS缩放": "msZoom",
        "引发MS视频格式改变": "onMSVideoFormatChanged",
        "引发MS视频帧步幅完成": "onMSVideoFrameStepCompleted",
        "引发MS视频优化布局改变": "onMSVideoOptimalLayoutChanged",
        "海报": "poster",
        "视频高度": "videoHeight",
        "视频宽度": "videoWidth",
        "WK全屏显示": "webkitDisplayingFullscreen",
        "WK支持全屏": "webkitSupportsFullscreen",
        "取视频播放质量": "getVideoPlaybackQuality",
        "视频播放质量类": "VideoPlaybackQuality",
        "MS帧步骤": "msFrameStep",
        "向前": "forward",
        "MS插入视频效果": "msInsertVideoEffect",
        "MS置视频矩形": "msSetVideoRectangle",
        "WK进入全屏类": "webkitEnterFullScreen",
        "WK进入全屏": "webkitEnterFullscreen",
        "WK退出全屏类": "webkitExitFullScreen",
        "头部类": "Headers",
        "循环回调": "ForEachCallback",
        "初始": "init",
        "历史类": "History",
        "滚动恢复": "scrollRestoration",
        "滚动恢复类": "ScrollRestoration",
        "回退": "back",
        "去": "go",
        "增量": "delta",
        "推入状态": "pushState",
        "更换状态": "replaceState",
        "IDB光标": "IDBCursor",
        "IDB键范围": "IDBKeyRange",
        "IDB有效键": "IDBValidKey",
        "主键": "primaryKey",
        "IDB对象存储": "IDBObjectStore",
        "IDB索引": "IDBIndex",
        "提前": "advance",
        "持续": "continue",
        "IDB请求": "IDBRequest",
        "下个_": "NEXT",
        "下个_没有_重复": "NEXT_NO_DUPLICATE",
        "事先_": "PREV",
        "事先_没有_重复": "PREV_NO_DUPLICATE",
        "IDB光标与值": "IDBCursorWithValue",
        "IDB数据库事件映射": "IDBDatabaseEventMap",
        "IDB数据库": "IDBDatabase",
        "对象存储名字集": "objectStoreNames",
        "引发版本变化": "onversionchange",
        "IDB版本改变事件类": "IDBVersionChangeEvent",
        "创建对象存储": "createObjectStore",
        "可选参数集": "optionalParameters",
        "删除对象存储": "deleteObjectStore",
        "事务": "transaction",
        "储存名称集": "storeNames",
        "IDB事务": "IDBTransaction",
        "版本改变": "versionchange",
        "IDB工厂": "IDBFactory",
        "压缩": "cmp",
        "删除数据库": "deleteDatabase",
        "IDB打开数据库请求": "IDBOpenDBRequest",
        "对象存储": "objectStore",
        "取键": "getKey",
        "打开光标": "openCursor",
        "范围": "range",
        "打开键光标": "openKeyCursor",
        "下面": "lower",
        "下面打开": "lowerOpen",
        "上面": "upper",
        "上面打开": "upperOpen",
        "界限": "bound",
        "下限": "lowerBound",
        "唯一": "only",
        "上界": "upperBound",
        "索引名称集": "indexNames",
        "创建索引": "createIndex",
        "删除索引": "deleteIndex",
        "索引名称": "indexName",
        "IDB打开数据库请求事件映射": "IDBOpenDBRequestEventMap",
        "IDB请求事件映射": "IDBRequestEventMap",
        "引发成功": "onsuccess",
        "IDB事务事件映射": "IDBTransactionEventMap",
        "数据库": "db",
        "引发完成": "oncomplete",
        "只_读": "READ_ONLY",
        "读_写": "READ_WRITE",
        "版本_变化": "VERSION_CHANGE",
        "新版本": "newVersion",
        "老版本": "oldVersion",
        "交叉观察": "IntersectionObserver",
        "阈值": "thresholds",
        "观察": "observe",
        "要记录": "takeRecords",
        "观察出入口": "IntersectionObserverEntry",
        "联合观察": "unobserve",
        "交叉观察回调": "IntersectionObserverCallback",
        "交叉比率": "intersectionRatio",
        "观察出入口初始化": "intersectionObserverEntryInit",
        "字符": "char",
        "字符代码": "charCode",
        "键代码": "keyCode",
        "哪一个": "which",
        "取修饰符状态": "getModifierState",
        "键参数": "keyArg",
        "初始化键盘事件类": "initKeyboardEvent",
        "定位参数": "locationArg",
        "修饰符列表参数": "modifiersListArg",
        "文档_键_位置_操纵杆": "DOM_KEY_LOCATION_JOYSTICK",
        "文档_键_位置_左": "DOM_KEY_LOCATION_LEFT",
        "文档_键_位置_移动": "DOM_KEY_LOCATION_MOBILE",
        "文档_键_位置_小键盘": "DOM_KEY_LOCATION_NUMPAD",
        "文档_键_位置_右": "DOM_KEY_LOCATION_RIGHT",
        "文档_键_位置_标准": "DOM_KEY_LOCATION_STANDARD",
        "监听状态改变事件类": "ListeningStateChangedEvent",
        "分配": "assign",
        "刷新": "reload",
        "强制刷新": "forcedReload",
        "长运行脚本检测事件类": "LongRunningScriptDetectedEvent",
        "执行时间": "executionTime",
        "停止页面脚本执行": "stopPageScriptExecution",
        "MS应用程序": "MSApp",
        "清除临时WEB数据异步": "clearTemporaryWebDataAsync",
        "MS应用程序异步操作": "MSAppAsyncOperation",
        "创建二进制对象从随机访问流": "createBlobFromRandomAccessStream",
        "探索者": "seeker",
        "创建数据包": "createDataPackage",
        "创建数据包从选择": "createDataPackageFromSelection",
        "创建文件从存储文件": "createFileFromStorageFile",
        "存储文件": "storageFile",
        "创建流从输入流": "createStreamFromInputStream",
        "输入流": "inputStream",
        "MS流": "MSStream",
        "执行异步优先": "execAsyncAtPriority",
        "异步回调函数": "asynchronousCallback",
        "优先级回调函数": "MSExecAtPriorityFunctionCallback",
        "执行优先级": "execAtPriority",
        "同步回调": "synchronousCallback",
        "取当前优先级": "getCurrentPriority",
        "取超文本打印文档源异步": "getHtmlPrintDocumentSourceAsync",
        "_超文本文档": "htmlDoc",
        "取视图ID": "getViewId",
        "是预定任务优先级或更高": "isTaskScheduledAtPriorityOrHigher",
        "页处理所有应用程序激活": "pageHandlesAllApplicationActivations",
        "抑制子下载证书提示": "suppressSubdownloadCredentialPrompts",
        "抑制": "suppress",
        "终止程序": "terminateApp",
        "异常对象": "exceptionObject",
        "当前_": "CURRENT",
        "高_": "HIGH",
        "正常_": "NORMAL",
        "MS应用程序异步操作事件映射": "MSAppAsyncOperationEventMap",
        "完整_": "COMPLETED",
        "起动_": "STARTED",
        "MS断言": "MSAssertion",
        "MS二进制对象生成器": "MSBlobBuilder",
        "结局": "endings",
        "取二进制对象": "getBlob",
        "MS资格证书类": "MSCredentials",
        "取断言": "getAssertion",
        "参数集": "params",
        "使用证书": "makeCredential",
        "帐户信息": "accountInfo",
        "MS_FIDO凭证断言": "MSFIDOCredentialAssertion",
        "证明": "attestation",
        "传输提示": "transportHints",
        "MS_FIDO签名": "MSFIDOSignature",
        "作者数据": "authnrData",
        "客户数据": "clientData",
        "签名": "signature",
        "MS_FIDO签名断言": "MSFIDOSignatureAssertion",
        "MS手势": "MSGesture",
        "添加指针": "addPointer",
        "扩张": "expansion",
        "手势对象": "gestureObject",
        "硬件时间戳": "hwTimestamp",
        "轮转": "rotation",
        "转变X": "translationX",
        "转变Y": "translationY",
        "速度角度": "velocityAngular",
        "速度扩张": "velocityExpansion",
        "速度X": "velocityX",
        "速度Y": "velocityY",
        "初始化手势事件类": "initGestureEvent",
        "偏移X参数": "offsetXArg",
        "偏移Y参数": "offsetYArg",
        "转变X参数": "translationXArg",
        "转变Y参数": "translationYArg",
        "尺度参数": "scaleArg",
        "扩展参数": "expansionArg",
        "旋转参数": "rotationArg",
        "速度X参数": "velocityXArg",
        "速度Y参数": "velocityYArg",
        "速度扩展参数": "velocityExpansionArg",
        "速度角度参数": "velocityAngularArg",
        "硬件时间戳参数": "hwTimestampArg",
        "MS_手势_标志_开始": "MSGESTURE_FLAG_BEGIN",
        "MS_手势_标志_取消": "MSGESTURE_FLAG_CANCEL",
        "MS_手势_标志_结束": "MSGESTURE_FLAG_END",
        "MS_手势_标志_惯性": "MSGESTURE_FLAG_INERTIA",
        "MS_手势_标志_没有": "MSGESTURE_FLAG_NONE",
        "收缩活动": "constrictionActive",
        "MS超文本Web视图元素": "MSHTMLWebViewElement",
        "可以返回": "canGoBack",
        "可以前进": "canGoForward",
        "包含全屏元素": "containsFullScreenElement",
        "文档标题": "documentTitle",
        "设定": "settings",
        "MS_WEB视图设定": "MSWebViewSettings",
        "添加WEB允许对象": "addWebAllowedObject",
        "应用程序对象": "applicationObject",
        "建立本地流URI": "buildLocalStreamUri",
        "内容标识符": "contentIdentifier",
        "相对路径": "relativePath",
        "异步捕获预览到二进制对象": "capturePreviewToBlobAsync",
        "MS_WEB视图异步操作": "MSWebViewAsyncOperation",
        "捕获数据包异步选择内容": "captureSelectedContentToDataPackageAsync",
        "取延迟权限请求根据ID": "getDeferredPermissionRequestById",
        "取延迟许可请求": "getDeferredPermissionRequests",
        "退回": "goBack",
        "前进": "goForward",
        "异步调用脚本": "invokeScriptAsync",
        "脚本名称": "scriptName",
        "导航": "navigate",
        "导航焦点": "navigateFocus",
        "导航到本地流URI": "navigateToLocalStreamUri",
        "流解析": "streamResolver",
        "导航到字符串": "navigateToString",
        "内容集": "contents",
        "导航与超文本传输请求消息": "navigateWithHttpRequestMessage",
        "请求消息": "requestMessage",
        "刷新了": "refresh",
        "MS输入法上下文事件映射": "MSInputMethodContextEventMap",
        "组合结束偏移": "compositionEndOffset",
        "组合开始偏移": "compositionStartOffset",
        "引发候选窗口隐藏": "oncandidatewindowhide",
        "引发候选窗口显示": "oncandidatewindowshow",
        "引发候选窗口更新": "oncandidatewindowupdate",
        "取候选窗口显示区": "getCandidateWindowClientRect",
        "取可供选择组合": "getCompositionAlternatives",
        "有组合": "hasComposition",
        "是候选窗口可见": "isCandidateWindowVisible",
        "当前状态": "currentState",
        "惯性目地X": "inertiaDestinationX",
        "惯性目地Y": "inertiaDestinationY",
        "最后状态": "lastState",
        "初始化MS操作事件类": "initMSManipulationEvent",
        "MS_操作_状态_活性": "MS_MANIPULATION_STATE_ACTIVE",
        "MS_操作_状态_取消": "MS_MANIPULATION_STATE_CANCELLED",
        "MS_操作_状态_保持": "MS_MANIPULATION_STATE_COMMITTED",
        "MS_操作_状态_拖动": "MS_MANIPULATION_STATE_DRAGGING",
        "MS_操作_状态_惯性": "MS_MANIPULATION_STATE_INERTIA",
        "MS_操作_状态_预选": "MS_MANIPULATION_STATE_PRESELECT",
        "MS_操作_状态_选择": "MS_MANIPULATION_STATE_SELECTING",
        "MS_操作_状态_停止": "MS_MANIPULATION_STATE_STOPPED",
        "MS媒体键错误": "MSMediaKeyError",
        "系统代码": "systemCode",
        "MS_媒体_密钥错误_客户端": "MS_MEDIA_KEYERR_CLIENT",
        "MS_媒体_密钥错误_域": "MS_MEDIA_KEYERR_DOMAIN",
        "MS_媒体_密钥错误_硬件变化": "MS_MEDIA_KEYERR_HARDWARECHANGE",
        "MS_媒体_密钥错误_输出": "MS_MEDIA_KEYERR_OUTPUT",
        "MS_媒体_密钥错误_服务": "MS_MEDIA_KEYERR_SERVICE",
        "MS_媒体_密钥错误_未知": "MS_MEDIA_KEYERR_UNKNOWN",
        "MS媒体键消息事件类": "MSMediaKeyMessageEvent",
        "目地URL": "destinationURL",
        "MS媒体键会话": "MSMediaKeySession",
        "键系统": "keySystem",
        "会话ID": "sessionId",
        "创建会话": "createSession",
        "CDM数据": "cdmData",
        "是类型支持": "isTypeSupported",
        "是类型支持功能": "isTypeSupportedWithFeatures",
        "当前点位": "currentPoint",
        "中间点": "intermediatePoints",
        "取当前点位": "getCurrentPoint",
        "取中间点": "getIntermediatePoints",
        "初始化指针事件类": "initPointerEvent",
        "宽度参数": "widthArg",
        "高度参数": "heightArg",
        "指针ID参数": "pointerIdArg",
        "动作URL": "actionURL",
        "按钮ID": "buttonID",
        "MS流阅读器": "MSStreamReader",
        "读转为二进制对象": "readAsBlob",
        "MS_WEB视图异步操作事件映射": "MSWebViewAsyncOperationEventMap",
        "类型_捕获_预览_随机_访问流": "TYPE_CAPTURE_PREVIEW_TO_RANDOM_ACCESS_STREAM",
        "从_选择_创建_数据包": "TYPE_CREATE_DATA_PACKAGE_FROM_SELECTION",
        "类型_调用_脚本": "TYPE_INVOKE_SCRIPT",
        "是启用索引数据库": "isIndexedDBEnabled",
        "是启用JavaScript": "isJavaScriptEnabled",
        "媒体设备信息类": "MediaDeviceInfo",
        "媒体设备事件映射": "MediaDevicesEventMap",
        "媒体设备类": "MediaDevices",
        "引发设备改变": "ondevicechange",
        "枚举设备": "enumerateDevices",
        "取支持约束": "getSupportedConstraints",
        "取用户媒体": "getUserMedia",
        "MS扩展码": "msExtendedCode",
        "媒体_错误_中止": "MEDIA_ERR_ABORTED",
        "媒体_错误_解码": "MEDIA_ERR_DECODE",
        "媒体_错误_网络": "MEDIA_ERR_NETWORK",
        "媒体_错误_源不支持": "MEDIA_ERR_SRC_NOT_SUPPORTED",
        "媒体_错误_加密": "MS_MEDIA_ERR_ENCRYPTED",
        "媒体键消息事件类": "MediaKeyMessageEvent",
        "媒体键会话": "MediaKeySession",
        "已关闭": "closed",
        "到期": "expiration",
        "键地位": "keyStatuses",
        "媒体密钥状态映射": "MediaKeyStatusMap",
        "生成请求": "generateRequest",
        "键ID": "keyId",
        "媒体密钥系统访问": "MediaKeySystemAccess",
        "创建媒体键集": "createMediaKeys",
        "取配置信息": "getConfiguration",
        "会话类型": "sessionType",
        "置服务器证书": "setServerCertificate",
        "服务器证书": "serverCertificate",
        "媒体文本": "mediaText",
        "附加介质": "appendMedium",
        "新媒体": "newMedium",
        "删除介质": "deleteMedium",
        "旧媒体": "oldMedium",
        "媒体查询列表": "MediaQueryList",
        "添加侦听器": "addListener",
        "媒体查询列表监听器": "MediaQueryListListener",
        "删除监听器": "removeListener",
        "媒体源": "MediaSource",
        "有源缓冲区集": "activeSourceBuffers",
        "源缓冲区列表": "SourceBufferList",
        "源缓冲区集": "sourceBuffers",
        "添加源缓冲区": "addSourceBuffer",
        "流结束": "endOfStream",
        "删除源缓冲区": "removeSourceBuffer",
        "媒体流事件映射": "MediaStreamEventMap",
        "媒体流轨道事件类": "MediaStreamTrackEvent",
        "引发行动": "onactive",
        "引发无效": "oninactive",
        "添加轨道": "addTrack",
        "克隆": "clone",
        "取音频轨道": "getAudioTracks",
        "轨道ID": "trackId",
        "取轨道集": "getTracks",
        "取视频轨道集": "getVideoTracks",
        "删除轨道": "removeTrack",
        "流或轨道": "streamOrTracks",
        "约束名称": "constraintName",
        "流媒体事件类": "MediaStreamEvent",
        "媒体流轨道事件映射": "MediaStreamTrackEventMap",
        "引发静音": "onmute",
        "引发过度约束": "onoverconstrained",
        "引发取消静音": "onunmute",
        "应用约束": "applyConstraints",
        "取容量": "getCapabilities",
        "取约束": "getConstraints",
        "取设定": "getSettings",
        "消息改变": "MessageChannel",
        "端口1": "port1",
        "端口2": "port2",
        "初始化消息事件类": "initMessageEvent",
        "起源参数": "originArg",
        "最后一个事件ID参数": "lastEventIdArg",
        "源参数": "sourceArg",
        "消息端口事件映射": "MessagePortEventMap",
        "端口消息": "postMessage",
        "转移": "transfer",
        "MI_ME类型类": "MimeType",
        "描述": "description",
        "启用插件": "enabledPlugin",
        "插件类": "Plugin",
        "后缀": "suffixes",
        "MI_ME类型数组": "MimeTypeArray",
        "从元素": "fromElement",
        "层X": "layerX",
        "层Y": "layerY",
        "运动X": "movementX",
        "运动Y": "movementY",
        "转成元素": "toElement",
        "初始化鼠标事件类": "initMouseEvent",
        "突变事件类": "MutationEvent",
        "特性改变": "attrChange",
        "特性名": "attrName",
        "新值": "newValue",
        "预防值": "prevValue",
        "相关节点": "relatedNode",
        "初始化突变事件类": "initMutationEvent",
        "相关节点参数": "relatedNodeArg",
        "预防值参数": "prevValueArg",
        "新值参数": "newValueArg",
        "特性名称参数": "attrNameArg",
        "特性改变参数": "attrChangeArg",
        "另外_": "ADDITION",
        "修改_": "MODIFICATION",
        "去除_": "REMOVAL",
        "突变观察者": "MutationObserver",
        "突变记录": "MutationRecord",
        "突变回调": "MutationCallback",
        "添加节点集": "addedNodes",
        "节点列表类": "NodeList",
        "特性名称": "attributeName",
        "特性名称空间": "attributeNamespace",
        "下个兄弟": "nextSibling",
        "旧值": "oldValue",
        "以前兄弟": "previousSibling",
        "删除节点集": "removedNodes",
        "取名称项目": "getNamedItem",
        "取名称项目NS": "getNamedItemNS",
        "删除名称项目": "removeNamedItem",
        "删除名称项目NS": "removeNamedItemNS",
        "置名称项目": "setNamedItem",
        "置名称项目NS": "setNamedItemNS",
        "导航完成事件类": "NavigationCompletedEvent",
        "导航事件类": "NavigationEvent",
        "是成功": "isSuccess",
        "WEB错误状态": "webErrorStatus",
        "导航事件与引用": "NavigationEventWithReferrer",
        "参考": "referer",
        "导航类": "Navigator",
        "导航ID": "NavigatorID",
        "导航在行": "NavigatorOnLine",
        "导航内容工具": "NavigatorContentUtils",
        "导航存储工具": "NavigatorStorageUtils",
        "导航定位": "NavigatorGeolocation",
        "MS导航不跟踪": "MSNavigatorDoNotTrack",
        "MS文件保存者": "MSFileSaver",
        "导航信标": "NavigatorBeacon",
        "导航硬件并发": "NavigatorConcurrentHardware",
        "导航用户媒体": "NavigatorUserMedia",
        "认证": "authentication",
        "WEB认证": "WebAuthentication",
        "身份储存启用": "cookieEnabled",
        "游戏手柄输入仿真": "gamepadInputEmulation",
        "最大触摸点": "maxTouchPoints",
        "MI_ME类型集": "mimeTypes",
        "MS启用操作视图": "msManipulationViewsEnabled",
        "MS最大触摸点": "msMaxTouchPoints",
        "MS指针启用": "msPointerEnabled",
        "插件数组": "PluginArray",
        "指针启用": "pointerEnabled",
        "服务平台": "serviceWorker",
        "服务平台容器": "ServiceWorkerContainer",
        "WEB驱动": "webdriver",
        "硬件并发": "hardwareConcurrency",
        "取游戏手柄": "getGamepads",
        "JAVA启用": "javaEnabled",
        "MS启动URI": "msLaunchUri",
        "启动URI回调": "MSLaunchUriCallback",
        "没有处理回调": "noHandlerCallback",
        "请求媒体密钥系统访问": "requestMediaKeySystemAccess",
        "支持配置": "supportedConfigurations",
        "振动": "vibrate",
        "基URI": "baseURI",
        "子节点集": "childNodes",
        "第一个子": "firstChild",
        "最后一个子": "lastChild",
        "节点名字": "nodeName",
        "节点类型": "nodeType",
        "节点值": "nodeValue",
        "主文档": "ownerDocument",
        "父元素": "parentElement",
        "父节点": "parentNode",
        "附加子": "appendChild",
        "新子": "newChild",
        "克隆节点": "cloneNode",
        "比较文件位置": "compareDocumentPosition",
        "其他": "other",
        "子": "child",
        "有特性集": "hasAttributes",
        "有子节点集": "hasChildNodes",
        "之前插入": "insertBefore",
        "参考孩子": "refChild",
        "是默认名称空间": "isDefaultNamespace",
        "是相等节点": "isEqualNode",
        "是同一个节点": "isSameNode",
        "查找命名空间URI": "lookupNamespaceURI",
        "查找前缀": "lookupPrefix",
        "删除子": "removeChild",
        "旧子": "oldChild",
        "代替子": "replaceChild",
        "特性_节点": "ATTRIBUTE_NODE",
        "C_数据_部分_节点": "CDATA_SECTION_NODE",
        "注释_节点": "COMMENT_NODE",
        "文档_片段_节点": "DOCUMENT_FRAGMENT_NODE",
        "文档_节点": "DOCUMENT_NODE",
        "文档_所包含_位置_旁": "DOCUMENT_POSITION_CONTAINED_BY",
        "文档_所包含_位置": "DOCUMENT_POSITION_CONTAINS",
        "文档_位置_断开": "DOCUMENT_POSITION_DISCONNECTED",
        "文档_位置_如下": "DOCUMENT_POSITION_FOLLOWING",
        "文档_位置_具体_实现": "DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC",
        "文档_位置_前": "DOCUMENT_POSITION_PRECEDING",
        "文档_类型_节点": "DOCUMENT_TYPE_NODE",
        "元素_节点": "ELEMENT_NODE",
        "实体_节点": "ENTITY_NODE",
        "实体_引用_节点": "ENTITY_REFERENCE_NODE",
        "标记_节点": "NOTATION_NODE",
        "处理_指令_节点": "PROCESSING_INSTRUCTION_NODE",
        "文本_节点": "TEXT_NODE",
        "接受节点": "acceptNode",
        "过滤器_接受": "FILTER_ACCEPT",
        "过滤器_拒绝": "FILTER_REJECT",
        "过滤器_忽略": "FILTER_SKIP",
        "显示_所有": "SHOW_ALL",
        "显示_特性": "SHOW_ATTRIBUTE",
        "显示_C数据_部分": "SHOW_CDATA_SECTION",
        "显示_评论": "SHOW_COMMENT",
        "显示_文档": "SHOW_DOCUMENT",
        "显示_文档_片段": "SHOW_DOCUMENT_FRAGMENT",
        "显示_文档_类型": "SHOW_DOCUMENT_TYPE",
        "显示_元素": "SHOW_ELEMENT",
        "显示_实体": "SHOW_ENTITY",
        "显示_实体_引用": "SHOW_ENTITY_REFERENCE",
        "显示_符号": "SHOW_NOTATION",
        "显示_处理_指令": "SHOW_PROCESSING_INSTRUCTION",
        "显示_文本": "SHOW_TEXT",
        "扩大实体引用": "expandEntityReferences",
        "分离": "detach",
        "下个节点": "nextNode",
        "以前节点": "previousNode",
        "通知事件映射": "NotificationEventMap",
        "通知": "Notification",
        "引发关闭": "onclose",
        "引发显示": "onshow",
        "许可": "permission",
        "请求许可": "requestPermission",
        "通知许可回调": "NotificationPermissionCallback",
        "OES_元素_索引_单元": "OES_element_index_uint",
        "OES_标准_衍生物": "OES_standard_derivatives",
        "片段_着色器_衍生暗示_OES": "FRAGMENT_SHADER_DERIVATIVE_HINT_OES",
        "OES_纹理_浮点": "OES_texture_float",
        "OES_纹理_浮点_线性": "OES_texture_float_linear",
        "OES_纹理_半球_浮点": "OES_texture_half_float",
        "半球_浮点_OES": "HALF_FLOAT_OES",
        "OES_纹理_半球_浮点_线性": "OES_texture_half_float_linear",
        "脱机完成音频事件类": "OfflineAudioCompletionEvent",
        "渲染缓冲区": "renderedBuffer",
        "脱机音频语境事件映射": "OfflineAudioContextEventMap",
        "脱机音频语境": "OfflineAudioContext",
        "开始渲染": "startRendering",
        "暂停时间": "suspendTime",
        "震动节点事件映射": "OscillatorNodeEventMap",
        "置周期波": "setPeriodicWave",
        "周期波": "periodicWave",
        "溢出事件类": "OverflowEvent",
        "水平溢出": "horizontalOverflow",
        "定位": "orient",
        "垂直溢出": "verticalOverflow",
        "二者_": "BOTH",
        "水平_": "HORIZONTAL",
        "垂直_": "VERTICAL",
        "坚持": "persisted",
        "锥形角内": "coneInnerAngle",
        "锥外倾角": "coneOuterAngle",
        "锥外增益": "coneOuterGain",
        "距离模型": "distanceModel",
        "最大距离": "maxDistance",
        "平移模型": "panningModel",
        "参考距离": "refDistance",
        "衰减因子": "rolloffFactor",
        "付款地址": "PaymentAddress",
        "地址行": "addressLine",
        "城市": "city",
        "国家": "country",
        "相关地方": "dependentLocality",
        "语言代码": "languageCode",
        "组织": "organization",
        "电话": "phone",
        "邮政编码": "postalCode",
        "收件人": "recipient",
        "街区": "region",
        "分类编码": "sortingCode",
        "付款请求事件映射": "PaymentRequestEventMap",
        "送货地址": "shippingAddress",
        "运送选项": "shippingOption",
        "支付响应": "PaymentResponse",
        "方法数据": "methodData",
        "细节集": "details",
        "付款请求更新事件类": "PaymentRequestUpdateEvent",
        "更新": "updateWith",
        "方法名称": "methodName",
        "付款人电子邮件": "payerEmail",
        "付款人名称": "payerName",
        "付款人电话": "payerPhone",
        "性能部件外部": "PerfWidgetExternal",
        "主动网络请求计数": "activeNetworkRequestCount",
        "平均帧时间": "averageFrameTime",
        "平均绘画时间": "averagePaintTime",
        "额外信息功能": "extraInformationEnabled",
        "独立渲染功能": "independentRenderingEnabled",
        "禁用内容字符串": "irDisablingContentString",
        "IR状态可用": "irStatusAvailable",
        "最大CPU速度": "maxCpuSpeed",
        "绘画请求时间": "paintRequestsPerSecond",
        "性能计数器": "performanceCounter",
        "性能计数器频率": "performanceCounterFrequency",
        "事件类型": "eventType",
        "取内存使用": "getMemoryUsage",
        "取进程CPU使用率": "getProcessCpuUsage",
        "取最近CPU使用情况": "getRecentCpuUsage",
        "最后的": "last",
        "取最新帧": "getRecentFrames",
        "取最近内存使用情况": "getRecentMemoryUsage",
        "取最近绘画请求": "getRecentPaintRequests",
        "复位窗口": "repositionWindow",
        "调整窗口大小": "resizeWindow",
        "性能类": "Performance",
        "导航系统": "navigation",
        "性能导航": "PerformanceNavigation",
        "定时": "timing",
        "性能定时": "PerformanceTiming",
        "明确标志": "clearMarks",
        "标志名称": "markName",
        "明确措施": "clearMeasures",
        "措施名称": "measureName",
        "明确资源时间": "clearResourceTimings",
        "取条目集": "getEntries",
        "取条目按名称": "getEntriesByName",
        "条目类型": "entryType",
        "取条目按类型": "getEntriesByType",
        "取标志集": "getMarks",
        "取措施": "getMeasures",
        "标志": "mark",
        "测量": "measure",
        "开始标志名称": "startMarkName",
        "结束标志名称": "endMarkName",
        "置资源定时缓冲区大小": "setResourceTimingBufferSize",
        "最大大小": "maxSize",
        "性能条目": "PerformanceEntry",
        "性能标志": "PerformanceMark",
        "性能测量": "PerformanceMeasure",
        "重定向计数": "redirectCount",
        "类型_返回_向前": "TYPE_BACK_FORWARD",
        "类型_导航": "TYPE_NAVIGATE",
        "类型_重装": "TYPE_RELOAD",
        "类型_保留": "TYPE_RESERVED",
        "导航性能时间": "PerformanceNavigationTiming",
        "连接终端": "connectEnd",
        "连接开始": "connectStart",
        "DOM完成": "domComplete",
        "DOM内容加载事件结束": "domContentLoadedEventEnd",
        "DOM内容加载事件开始": "domContentLoadedEventStart",
        "DOM交互": "domInteractive",
        "DOM加载": "domLoading",
        "域名查找结束": "domainLookupEnd",
        "域名查找开始": "domainLookupStart",
        "获取开始": "fetchStart",
        "加载事件结束": "loadEventEnd",
        "加载事件开始": "loadEventStart",
        "导航开始": "navigationStart",
        "重定向结束": "redirectEnd",
        "重定向开始": "redirectStart",
        "请求开始": "requestStart",
        "请求结束": "responseEnd",
        "响应启动": "responseStart",
        "卸载事件结束": "unloadEventEnd",
        "卸载事件开始": "unloadEventStart",
        "性能资源事件类": "PerformanceResourceTiming",
        "创始人类型": "initiatorType",
        "MS第一各画": "msFirstPaint",
        "安全连接开始": "secureConnectionStart",
        "权限请求类": "PermissionRequest",
        "权限请求事件类": "PermissionRequestedEvent",
        "权限请求": "permissionRequest",
        "初始化弹出状态事件类": "initPopStateEvent",
        "状态参数": "stateArg",
        "位置类": "Position",
        "位置错误": "PositionError",
        "权限_拒绝": "PERMISSION_DENIED",
        "位置_不可用": "POSITION_UNAVAILABLE",
        "超时_": "TIMEOUT",
        "初始化进程事件类": "initProgressEvent",
        "长度计算参数": "lengthComputableArg",
        "加载参数": "loadedArg",
        "总数参数": "totalArg",
        "推入管理": "PushManager",
        "取订阅": "getSubscription",
        "推送订阅": "PushSubscription",
        "权限状态": "permissionState",
        "订阅": "subscribe",
        "端点": "endpoint",
        "推送订阅选项集": "PushSubscriptionOptions",
        "取消订阅": "unsubscribe",
        "RTC_DTMF多音改变事件类": "RTCDTMFToneChangeEvent",
        "RTC_DTLS传输事件映射": "RTCDtlsTransportEventMap",
        "RTC_DTLS传输状态改变事件类": "RTCDtlsTransportStateChangedEvent",
        "RTC_DTLS传输": "RTCDtlsTransport",
        "RTC数据提供商": "RTCStatsProvider",
        "引发DTLS状态改变": "ondtlsstatechange",
        "RTC信令传输": "RTCIceTransport",
        "取本地参数集": "getLocalParameters",
        "取远程证书集": "getRemoteCertificates",
        "取远程参数集": "getRemoteParameters",
        "远程参数集": "remoteParameters",
        "RTC_DTMF发送事件映射": "RTCDtmfSenderEventMap",
        "RTC_DTMF发件人": "RTCDtmfSender",
        "可以接入DTMF": "canInsertDTMF",
        "国际音调差距": "interToneGap",
        "引发音调改变": "ontonechange",
        "发件人": "sender",
        "RTC实时传输发件人": "RTCRtpSender",
        "缓冲音调": "toneBuffer",
        "插入DTMF": "insertDTMF",
        "音调集": "tones",
        "候选初始化词典": "candidateInitDict",
        "RTC信令候选对改变事件类": "RTCIceCandidatePairChangedEvent",
        "一对": "pair",
        "RTC信令采集事件映射": "RTCIceGathererEventMap",
        "RTC信令采集事件类": "RTCIceGathererEvent",
        "RTC信令采集": "RTCIceGatherer",
        "成分": "component",
        "引发当地候选": "onlocalcandidate",
        "创建相关采集": "createAssociatedGatherer",
        "取本地候选": "getLocalCandidates",
        "RTC信令传输事件映射": "RTCIceTransportEventMap",
        "RTC信令传输状态改变事件类": "RTCIceTransportStateChangedEvent",
        "信令采集": "iceGatherer",
        "引发候选对改变": "oncandidatepairchange",
        "引发信令状态改变": "onicestatechange",
        "添加远程候选": "addRemoteCandidate",
        "删除候选": "remoteCandidate",
        "创建相关传输": "createAssociatedTransport",
        "取获得提名候选对": "getNominatedCandidatePair",
        "取远程候选": "getRemoteCandidates",
        "置远程候选": "setRemoteCandidates",
        "远程候选集": "remoteCandidates",
        "收集器": "gatherer",
        "RTC对等连接事件映射": "RTCPeerConnectionEventMap",
        "RTC对等连接": "RTCPeerConnection",
        "可以细流信令候选": "canTrickleIceCandidates",
        "信令连接状态": "iceConnectionState",
        "信令采集状态": "iceGatheringState",
        "局部描述": "localDescription",
        "RTC会话描述": "RTCSessionDescription",
        "引发添加流": "onaddstream",
        "引发信令候选": "onicecandidate",
        "引发信令连接状态变化": "oniceconnectionstatechange",
        "引发信令采集状态改变": "onicegatheringstatechange",
        "引发第一次谈判需要": "onnegotiationneeded",
        "引发删除流": "onremovestream",
        "引发信号状态变化": "onsignalingstatechange",
        "远程描述": "remoteDescription",
        "信号状态": "signalingState",
        "添加信令候选": "addIceCandidate",
        "无值函数": "VoidFunction",
        "失败回调": "failureCallback",
        "RTC连接错误回调": "RTCPeerConnectionErrorCallback",
        "添加流": "addStream",
        "创建应答": "createAnswer",
        "RTC会话描述回调": "RTCSessionDescriptionCallback",
        "创建供应": "createOffer",
        "取本地流集": "getLocalStreams",
        "取远程流集": "getRemoteStreams",
        "取统计": "getStats",
        "RTC统计回调": "RTCStatsCallback",
        "取流根据ID": "getStreamById",
        "流ID": "streamId",
        "删除流": "removeStream",
        "置本地描述": "setLocalDescription",
        "置远程描述": "setRemoteDescription",
        "配置项": "configuration",
        "RTC实时传输接收事件映射": "RTCRtpReceiverEventMap",
        "RTC实时传输接收器": "RTCRtpReceiver",
        "控制协议传输": "rtcpTransport",
        "RTC驱动传输安全": "RTCSrtpSdesTransport",
        "取贡献源": "getContributingSources",
        "接收": "receive",
        "请求发送CSRC": "requestSendCSRC",
        "置传输": "setTransport",
        "RTC实时传输发送事件映射": "RTCRtpSenderEventMap",
        "RTC_SSRC冲突事件类": "RTCSsrcConflictEvent",
        "引发SSRC冲突": "onssrcconflict",
        "发送": "send",
        "置轨道": "setTrack",
        "描述初始化词典": "descriptionInitDict",
        "RTC_SRTP_SDES_传输事件映射": "RTCSrtpSdesTransportEventMap",
        "加密参数": "encryptParameters",
        "解密参数": "decryptParameters",
        "MS取统计": "msGetStats",
        "已塌陷": "collapsed",
        "共同祖先容器": "commonAncestorContainer",
        "最后容器": "endContainer",
        "结束偏移": "endOffset",
        "开始容器": "startContainer",
        "起始偏移": "startOffset",
        "复制内容": "cloneContents",
        "克隆范围": "cloneRange",
        "塌陷": "collapse",
        "转成开始": "toStart",
        "比较边界点": "compareBoundaryPoints",
        "怎样": "how",
        "源范围": "sourceRange",
        "创建上下文片段": "createContextualFragment",
        "片段": "fragment",
        "删除内容": "deleteContents",
        "扩大": "expand",
        "单元": "Unit",
        "提取内容": "extractContents",
        "插入节点": "insertNode",
        "新节点": "newNode",
        "选择节点": "selectNode",
        "参考节点": "refNode",
        "选择节点内容": "selectNodeContents",
        "设定结束": "setEnd",
        "置结束后": "setEndAfter",
        "置结束之前": "setEndBefore",
        "置开始": "setStart",
        "置启动后": "setStartAfter",
        "置开始之前": "setStartBefore",
        "围绕内容": "surroundContents",
        "新父": "newParent",
        "结束_到_结束": "END_TO_END",
        "结束_到_开始": "END_TO_START",
        "开始_到_结束": "START_TO_END",
        "开始_到_开始": "START_TO_START",
        "可读流": "ReadableStream",
        "锁定": "locked",
        "取消": "cancel",
        "取读者": "getReader",
        "可读流阅读器": "ReadableStreamReader",
        "读": "read",
        "释放锁": "releaseLock",
        "请求类": "Request",
        "体类": "Body",
        "SVG图形元素": "SVGGraphicsElement",
        "SVG_URI引用": "SVGURIReference",
        "SVG动画系列": "SVGAnimatedString",
        "SVG元素事件映射": "SVGElementEventMap",
        "SVG角度": "SVGAngle",
        "单位类型": "unitType",
        "值转为文字": "valueAsString",
        "值指定单位": "valueInSpecifiedUnits",
        "转换为指定单位": "convertToSpecifiedUnits",
        "新值指定单位": "newValueSpecifiedUnits",
        "SVG_角类型_度": "SVG_ANGLETYPE_DEG",
        "SVG_角类型_百分比": "SVG_ANGLETYPE_GRAD",
        "SVG_角类型_弧度": "SVG_ANGLETYPE_RAD",
        "SVG_角类型_未知": "SVG_ANGLETYPE_UNKNOWN",
        "SVG_角类型_未指定": "SVG_ANGLETYPE_UNSPECIFIED",
        "SVG动画角": "SVGAnimatedAngle",
        "动画值": "animVal",
        "基置": "baseVal",
        "SVG动画真假": "SVGAnimatedBoolean",
        "SVG动画枚举": "SVGAnimatedEnumeration",
        "SVG动画整数": "SVGAnimatedInteger",
        "SVG动画长度": "SVGAnimatedLength",
        "SVG长度": "SVGLength",
        "SVG动画长度列表": "SVGAnimatedLengthList",
        "SVG长度列表": "SVGLengthList",
        "SVG动画数字": "SVGAnimatedNumber",
        "SVG动画数字列表": "SVGAnimatedNumberList",
        "SVG数字列表": "SVGNumberList",
        "SVG动画保持纵横比": "SVGAnimatedPreserveAspectRatio",
        "SVG保持纵横比": "SVGPreserveAspectRatio",
        "SVG动画矩形": "SVGAnimatedRect",
        "SVG矩形": "SVGRect",
        "SVG动画转换表": "SVGAnimatedTransformList",
        "SVG转换表": "SVGTransformList",
        "SVG单位类型": "SVGUnitTypes",
        "剪辑路径单元": "clipPathUnits",
        "振幅": "amplitude",
        "样品": "exponent",
        "截距": "intercept",
        "斜坡": "slope",
        "表中值": "tableValues",
        "SVG_FE_部分转换_类型_离散": "SVG_FECOMPONENTTRANSFER_TYPE_DISCRETE",
        "SVG_FE_部分转换_类型_GAMMA": "SVG_FECOMPONENTTRANSFER_TYPE_GAMMA",
        "SVG_FE_部分转换_类型_身份": "SVG_FECOMPONENTTRANSFER_TYPE_IDENTITY",
        "SVG_FE_部分转换_类型_线性": "SVG_FECOMPONENTTRANSFER_TYPE_LINEAR",
        "SVG_FE_部分转换_类型_表": "SVG_FECOMPONENTTRANSFER_TYPE_TABLE",
        "SVG_FE_部分转换_类型_未知": "SVG_FECOMPONENTTRANSFER_TYPE_UNKNOWN",
        "引发热点": "onfocusin",
        "引发重点": "onfocusout",
        "SVG主元素": "ownerSVGElement",
        "视口元素": "viewportElement",
        "XML基": "xmlbase",
        "SVG元素实例": "SVGElementInstance",
        "SVG元素实例列表": "SVGElementInstanceList",
        "对应元素": "correspondingElement",
        "使用相应元素": "correspondingUseElement",
        "SVG过滤器特性原始标准": "SVGFilterPrimitiveStandardAttributes",
        "SVG_滤镜_混合模式_颜色": "SVG_FEBLEND_MODE_COLOR",
        "SVG_滤镜_混合模式_颜色_加深": "SVG_FEBLEND_MODE_COLOR_BURN",
        "SVG_滤镜_混合模式_颜色_减淡": "SVG_FEBLEND_MODE_COLOR_DODGE",
        "SVG_滤镜_混合模式_变暗": "SVG_FEBLEND_MODE_DARKEN",
        "SVG_滤镜_混合模式_差异": "SVG_FEBLEND_MODE_DIFFERENCE",
        "SVG_滤镜_混合模式_排除": "SVG_FEBLEND_MODE_EXCLUSION",
        "SVG_滤镜_混合模式_硬光": "SVG_FEBLEND_MODE_HARD_LIGHT",
        "SVG_滤镜_混合模式_色调": "SVG_FEBLEND_MODE_HUE",
        "SVG_滤镜_混合模式_减轻": "SVG_FEBLEND_MODE_LIGHTEN",
        "SVG_滤镜_混合模式_亮度": "SVG_FEBLEND_MODE_LUMINOSITY",
        "SVG_滤镜_混合模式_增加": "SVG_FEBLEND_MODE_MULTIPLY",
        "SVG_滤镜_混合模式_正常": "SVG_FEBLEND_MODE_NORMAL",
        "SVG_滤镜_混合模式_覆盖": "SVG_FEBLEND_MODE_OVERLAY",
        "SVG_滤镜_混合模式_饱和": "SVG_FEBLEND_MODE_SATURATION",
        "SVG_滤镜_混合模式_屏幕": "SVG_FEBLEND_MODE_SCREEN",
        "SVG_滤镜_混合模式_柔和光": "SVG_FEBLEND_MODE_SOFT_LIGHT",
        "SVG_滤镜_混合模式_未知": "SVG_FEBLEND_MODE_UNKNOWN",
        "SVG_滤镜_颜色矩阵型_色相转动": "SVG_FECOLORMATRIX_TYPE_HUEROTATE",
        "SVG_滤镜_颜色矩阵型_亮度阿尔法": "SVG_FECOLORMATRIX_TYPE_LUMINANCETOALPHA",
        "SVG_滤镜_颜色矩阵型_矩阵": "SVG_FECOLORMATRIX_TYPE_MATRIX",
        "SVG_滤镜_颜色矩阵型_浸透": "SVG_FECOLORMATRIX_TYPE_SATURATE",
        "SVG_滤镜_颜色矩阵型_未知": "SVG_FECOLORMATRIX_TYPE_UNKNOWN",
        "操作员": "operator",
        "SVG_滤镜_复合_算法": "SVG_FECOMPOSITE_OPERATOR_ARITHMETIC",
        "SVG_滤镜_复合_特应性": "SVG_FECOMPOSITE_OPERATOR_ATOP",
        "SVG_滤镜_复合_内": "SVG_FECOMPOSITE_OPERATOR_IN",
        "SVG_滤镜_复合_外": "SVG_FECOMPOSITE_OPERATOR_OUT",
        "SVG_滤镜_复合_结束": "SVG_FECOMPOSITE_OPERATOR_OVER",
        "SVG_滤镜_复合_未知": "SVG_FECOMPOSITE_OPERATOR_UNKNOWN",
        "SVG_滤镜_复合_异或": "SVG_FECOMPOSITE_OPERATOR_XOR",
        "偏置": "bias",
        "边缘模式": "edgeMode",
        "核心矩阵": "kernelMatrix",
        "核单位长度X": "kernelUnitLengthX",
        "核单位长度Y": "kernelUnitLengthY",
        "秩序X": "orderX",
        "秩序Y": "orderY",
        "保持阿尔法": "preserveAlpha",
        "目标X": "targetX",
        "目标Y": "targetY",
        "SVG_边缘模式_复制": "SVG_EDGEMODE_DUPLICATE",
        "SVG_边缘模式_无": "SVG_EDGEMODE_NONE",
        "SVG_边缘模式_未知": "SVG_EDGEMODE_UNKNOWN",
        "SVG_边缘模式_包装": "SVG_EDGEMODE_WRAP",
        "扩散常数": "diffuseConstant",
        "表面比例": "surfaceScale",
        "X通道选择器": "xChannelSelector",
        "Y通道选择器": "yChannelSelector",
        "SVG_通道_A": "SVG_CHANNEL_A",
        "SVG_通道_B": "SVG_CHANNEL_B",
        "SVG_通道_G": "SVG_CHANNEL_G",
        "SVG_通道_R": "SVG_CHANNEL_R",
        "SVG_通道_未知": "SVG_CHANNEL_UNKNOWN",
        "方位角": "azimuth",
        "高程": "elevation",
        "标准偏差X": "stdDeviationX",
        "标准偏差Y": "stdDeviationY",
        "置标准偏差": "setStdDeviation",
        "保持纵横比": "preserveAspectRatio",
        "半径X": "radiusX",
        "半径Y": "radiusY",
        "SVG_形态学_算子_扩张": "SVG_MORPHOLOGY_OPERATOR_DILATE",
        "SVG_形态学_算子_侵蚀": "SVG_MORPHOLOGY_OPERATOR_ERODE",
        "SVG_形态学_算子_未知": "SVG_MORPHOLOGY_OPERATOR_UNKNOWN",
        "镜面常数": "specularConstant",
        "镜面反射指数": "specularExponent",
        "限制锥角": "limitingConeAngle",
        "点在X": "pointsAtX",
        "点在Y": "pointsAtY",
        "点在Z": "pointsAtZ",
        "基础频率X": "baseFrequencyX",
        "基础频率Y": "baseFrequencyY",
        "音节数": "numOctaves",
        "种子": "seed",
        "缝合切片": "stitchTiles",
        "SVG_针类型_无痕": "SVG_STITCHTYPE_NOSTITCH",
        "SVG_针类型_缝合": "SVG_STITCHTYPE_STITCH",
        "SVG_针类型_未知": "SVG_STITCHTYPE_UNKNOWN",
        "SVG_湍流_类型_分形噪波": "SVG_TURBULENCE_TYPE_FRACTALNOISE",
        "SVG_湍流_类型_湍流": "SVG_TURBULENCE_TYPE_TURBULENCE",
        "SVG_湍流_类型_未知": "SVG_TURBULENCE_TYPE_UNKNOWN",
        "滤镜调整X": "filterResX",
        "滤镜调整Y": "filterResY",
        "滤镜单位": "filterUnits",
        "原始单位": "primitiveUnits",
        "置滤镜调整": "setFilterRes",
        "梯度转换": "gradientTransform",
        "梯度单位": "gradientUnits",
        "扩散方法": "spreadMethod",
        "SVG_扩散方法_衬板": "SVG_SPREADMETHOD_PAD",
        "SVG_扩散方法_反射": "SVG_SPREADMETHOD_REFLECT",
        "SVG_扩散方法_重复": "SVG_SPREADMETHOD_REPEAT",
        "SVG_扩散方法_未知": "SVG_SPREADMETHOD_UNKNOWN",
        "SVG测试": "SVGTests",
        "最远视口元素": "farthestViewportElement",
        "最近视口元素": "nearestViewportElement",
        "取B盒子": "getBBox",
        "取CTM": "getCTM",
        "取屏幕CTM": "getScreenCTM",
        "取转换到元素": "getTransformToElement",
        "SVG_长度类型_CM": "SVG_LENGTHTYPE_CM",
        "SVG_长度类型_EMS": "SVG_LENGTHTYPE_EMS",
        "SVG_长度类型_EXS": "SVG_LENGTHTYPE_EXS",
        "SVG_长度类型_IN": "SVG_LENGTHTYPE_IN",
        "SVG_长度类型_MM": "SVG_LENGTHTYPE_MM",
        "SVG_长度类型_数": "SVG_LENGTHTYPE_NUMBER",
        "SVG_长度类型_PC": "SVG_LENGTHTYPE_PC",
        "SVG_长度类型_百分比": "SVG_LENGTHTYPE_PERCENTAGE",
        "SVG_长度类型_PT": "SVG_LENGTHTYPE_PT",
        "SVG_长度类型_PX": "SVG_LENGTHTYPE_PX",
        "SVG_长度类型_未知": "SVG_LENGTHTYPE_UNKNOWN",
        "项目数": "numberOfItems",
        "附件项目": "appendItem",
        "新项目": "newItem",
        "取项目": "getItem",
        "初始化": "initialize",
        "引发前插入项目": "insertItemBefore",
        "删除项目": "removeItem",
        "更换项目": "replaceItem",
        "SVG适合视图框": "SVGFitToViewBox",
        "标记高度": "markerHeight",
        "标记单位": "markerUnits",
        "标记宽度": "markerWidth",
        "定位角": "orientAngle",
        "定位类型": "orientType",
        "判定X": "refX",
        "判定Y": "refY",
        "置定位角度": "setOrientToAngle",
        "置定位自动": "setOrientToAuto",
        "SVG_标记单位_笔画宽度": "SVG_MARKERUNITS_STROKEWIDTH",
        "SVG_标记单位_未知": "SVG_MARKERUNITS_UNKNOWN",
        "SVG_标记单位_自定义步幅": "SVG_MARKERUNITS_USERSPACEONUSE",
        "SVG_标记_定位_角度": "SVG_MARKER_ORIENT_ANGLE",
        "SVG_标记_定位_自动": "SVG_MARKER_ORIENT_AUTO",
        "SVG_标记_定位_未知": "SVG_MARKER_ORIENT_UNKNOWN",
        "遮罩内容单位": "maskContentUnits",
        "遮罩单位": "maskUnits",
        "翻转X": "flipX",
        "翻转Y": "flipY",
        "反向": "inverse",
        "乘": "multiply",
        "第二矩阵": "secondMatrix",
        "旋转矢量": "rotateFromVector",
        "比例不均匀": "scaleNonUniform",
        "比例因子X": "scaleFactorX",
        "比例因子Y": "scaleFactorY",
        "斜角X": "skewX",
        "斜角Y": "skewY",
        "SVG数字": "SVGNumber",
        "路径段列表": "pathSegList",
        "SVG路径段列表": "SVGPathSegList",
        "创建SVG路径弧段ABS": "createSVGPathSegArcAbs",
        "大圆弧标志": "largeArcFlag",
        "扫描标记": "sweepFlag",
        "SVG路径弧段ABS": "SVGPathSegArcAbs",
        "创建SVG路径弧段REL": "createSVGPathSegArcRel",
        "SVG路径弧段REL": "SVGPathSegArcRel",
        "创建SVG路径关闭路径": "createSVGPathSegClosePath",
        "SVG路径关闭路径": "SVGPathSegClosePath",
        "创建SVG路径段曲线立方ABS": "createSVGPathSegCurvetoCubicAbs",
        "SVG路径段曲线立方ABS": "SVGPathSegCurvetoCubicAbs",
        "创建SVG路径段曲线立方REL": "createSVGPathSegCurvetoCubicRel",
        "SVG路径段曲线立方REL": "SVGPathSegCurvetoCubicRel",
        "创建SVG路径段曲线立方光滑ABS": "createSVGPathSegCurvetoCubicSmoothAbs",
        "SVG路径段曲线立方光滑ABS": "SVGPathSegCurvetoCubicSmoothAbs",
        "创建SVG路径段曲线立方光滑REL": "createSVGPathSegCurvetoCubicSmoothRel",
        "SVG路径段曲线立方光滑REL": "SVGPathSegCurvetoCubicSmoothRel",
        "创建SVG路径段曲线二次ABS": "createSVGPathSegCurvetoQuadraticAbs",
        "SVG路径段曲线二次ABS": "SVGPathSegCurvetoQuadraticAbs",
        "创建SVG路径段曲线二次REL": "createSVGPathSegCurvetoQuadraticRel",
        "SVG路径段曲线二次REL": "SVGPathSegCurvetoQuadraticRel",
        "创建SVG路径段曲线二次光滑ABS": "createSVGPathSegCurvetoQuadraticSmoothAbs",
        "SVG路径段曲线二次光滑ABS": "SVGPathSegCurvetoQuadraticSmoothAbs",
        "创建SVG路径段曲线二次光滑REL": "createSVGPathSegCurvetoQuadraticSmoothRel",
        "SVG路径段曲线二次光滑REL": "SVGPathSegCurvetoQuadraticSmoothRel",
        "创建SVG路径段线到ABS": "createSVGPathSegLinetoAbs",
        "SVG路径段线到ABS": "SVGPathSegLinetoAbs",
        "创建SVG路径段线到水平ABS": "createSVGPathSegLinetoHorizontalAbs",
        "SVG路径段线到水平ABS": "SVGPathSegLinetoHorizontalAbs",
        "创建SVG路径段线到水平REL": "createSVGPathSegLinetoHorizontalRel",
        "SVG路径段线到水平REL": "SVGPathSegLinetoHorizontalRel",
        "创建SVG路径分割线REL": "createSVGPathSegLinetoRel",
        "SVG路径分割线REL": "SVGPathSegLinetoRel",
        "创建SVG路径段线到垂直ABS": "createSVGPathSegLinetoVerticalAbs",
        "SVG路径段线到垂直ABS": "SVGPathSegLinetoVerticalAbs",
        "创建SVG路径段线到垂直REL": "createSVGPathSegLinetoVerticalRel",
        "SVG路径段线到垂直REL": "SVGPathSegLinetoVerticalRel",
        "创建SVG路径段移动到ABS": "createSVGPathSegMovetoAbs",
        "SVG路径段移动到ABS": "SVGPathSegMovetoAbs",
        "创建SVG路径段移动到REL": "createSVGPathSegMovetoRel",
        "SVG路径段移动到REL": "SVGPathSegMovetoRel",
        "取路径段在长度": "getPathSegAtLength",
        "距离": "distance",
        "取长度点": "getPointAtLength",
        "SVG点": "SVGPoint",
        "取总长度": "getTotalLength",
        "SVG路径段": "SVGPathSeg",
        "路径段类型": "pathSegType",
        "路径段类型转为字面": "pathSegTypeAsLetter",
        "路径段_弧段_ABS": "PATHSEG_ARC_ABS",
        "路径段_弧段_REL": "PATHSEG_ARC_REL",
        "路径段_关闭路径": "PATHSEG_CLOSEPATH",
        "路径段_曲线_立方_ABS": "PATHSEG_CURVETO_CUBIC_ABS",
        "路径段_曲线_立方_REL": "PATHSEG_CURVETO_CUBIC_REL",
        "路径段_曲线_立方_光滑_ABS": "PATHSEG_CURVETO_CUBIC_SMOOTH_ABS",
        "路径段_曲线_立方_光滑_REL": "PATHSEG_CURVETO_CUBIC_SMOOTH_REL",
        "路径段_曲线_二次_ABS": "PATHSEG_CURVETO_QUADRATIC_ABS",
        "路径段_曲线_二次_REL": "PATHSEG_CURVETO_QUADRATIC_REL",
        "路径段_曲线_二次_光滑_ABS": "PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS",
        "路径段_曲线_二次_光滑_REL": "PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL",
        "路径段_直线_ABS": "PATHSEG_LINETO_ABS",
        "路径段_直线_水平_ABS": "PATHSEG_LINETO_HORIZONTAL_ABS",
        "路径段_直线_水平_REL": "PATHSEG_LINETO_HORIZONTAL_REL",
        "路径段_直线_REL": "PATHSEG_LINETO_REL",
        "路径段_直线_垂直_ABS": "PATHSEG_LINETO_VERTICAL_ABS",
        "路径段_直线_垂直_REL": "PATHSEG_LINETO_VERTICAL_REL",
        "路径段_移至_ABS": "PATHSEG_MOVETO_ABS",
        "路径段_移至_REL": "PATHSEG_MOVETO_REL",
        "路径段_未知": "PATHSEG_UNKNOWN",
        "模式内容单位": "patternContentUnits",
        "模式转换": "patternTransform",
        "模式单位": "patternUnits",
        "矩阵转换": "matrixTransform",
        "SVG点列表": "SVGPointList",
        "SVG动画点": "SVGAnimatedPoints",
        "保持或切片": "meetOrSlice",
        "SVG_保持或切片_保持": "SVG_MEETORSLICE_MEET",
        "SVG_保持或切片_切片": "SVG_MEETORSLICE_SLICE",
        "SVG_MEETORSL信令_未知": "SVG_MEETORSLICE_UNKNOWN",
        "SVG_保持纵横比_无": "SVG_PRESERVEASPECTRATIO_NONE",
        "SVG_保持纵横比_未知": "SVG_PRESERVEASPECTRATIO_UNKNOWN",
        "SVG_保持纵横比_X最大Y最大": "SVG_PRESERVEASPECTRATIO_XMAXYMAX",
        "SVG_保持纵横比_X最大Y中间": "SVG_PRESERVEASPECTRATIO_XMAXYMID",
        "SVG_保持纵横比_X最大Y最小": "SVG_PRESERVEASPECTRATIO_XMAXYMIN",
        "SVG_保持纵横比_X中间Y最大": "SVG_PRESERVEASPECTRATIO_XMIDYMAX",
        "SVG_保持纵横比_X中间Y中间": "SVG_PRESERVEASPECTRATIO_XMIDYMID",
        "SVG_保持纵横比_X中间Y最小": "SVG_PRESERVEASPECTRATIO_XMIDYMIN",
        "SVG_保持纵横比_X最小Y最大": "SVG_PRESERVEASPECTRATIO_XMINYMAX",
        "SVG_保持纵横比_X最小Y中间": "SVG_PRESERVEASPECTRATIO_XMINYMID",
        "SVG_保持纵横比_X最小Y最小": "SVG_PRESERVEASPECTRATIO_XMINYMIN",
        "SVG自身元素事件映射": "SVGSVGElementEventMap",
        "SVG中断": "SVGAbort",
        "SVG错误": "SVGError",
        "SVG卸载": "SVGUnload",
        "SVG放缩": "SVGZoom",
        "SVG放缩事件类": "SVGZoomEvent",
        "SVG放缩和平移": "SVGZoomAndPan",
        "内容脚本类型": "contentScriptType",
        "内容样式类型": "contentStyleType",
        "目前比例": "currentScale",
        "当前翻译": "currentTranslate",
        "引发放缩": "onzoom",
        "像素单位到毫米X": "pixelUnitToMillimeterX",
        "像素单位到毫米Y": "pixelUnitToMillimeterY",
        "屏幕像素到毫米X": "screenPixelToMillimeterX",
        "屏幕像素到毫米Y": "screenPixelToMillimeterY",
        "视图点": "viewport",
        "检查附件": "checkEnclosure",
        "检查交点": "checkIntersection",
        "创建SVG角": "createSVGAngle",
        "创建SVG长度": "createSVGLength",
        "创建SVG矩阵": "createSVGMatrix",
        "创建SVG数字": "createSVGNumber",
        "创建SVG点": "createSVGPoint",
        "创建SVG矩形": "createSVGRect",
        "创建SVG变换": "createSVGTransform",
        "SVG变换": "SVGTransform",
        "创建SVG变换从矩阵": "createSVGTransformFromMatrix",
        "取消所有选择": "deselectAll",
        "强制重绘": "forceRedraw",
        "取计算样式": "getComputedStyle",
        "_元素": "elt",
        "伪元素": "pseudoElt",
        "取当前时间": "getCurrentTime",
        "取封闭列表": "getEnclosureList",
        "参考元素": "referenceElement",
        "取交叉列表": "getIntersectionList",
        "暂停动画": "pauseAnimations",
        "置当前时间": "setCurrentTime",
        "停止重绘": "suspendRedraw",
        "最大等待毫秒": "maxWaitMilliseconds",
        "取消暂停动画": "unpauseAnimations",
        "取消停止重绘": "unsuspendRedraw",
        "暂停处理ID": "suspendHandleID",
        "取消暂停全部重画": "unsuspendRedrawAll",
        "SVG文字列表": "SVGStringList",
        "长度调节": "lengthAdjust",
        "文本长度": "textLength",
        "取字符代码在位置": "getCharNumAtPosition",
        "点": "point",
        "取计算文本长度": "getComputedTextLength",
        "取字符结束位置": "getEndPositionOfChar",
        "字符码": "charnum",
        "取字符范围": "getExtentOfChar",
        "取字符数字": "getNumberOfChars",
        "取字符旋转": "getRotationOfChar",
        "取字符开始位置": "getStartPositionOfChar",
        "取子文字长度": "getSubStringLength",
        "下个字符": "nchars",
        "选择子文字": "selectSubString",
        "长度调_节间距": "LENGTHADJUST_SPACING",
        "长度调_节间距_字形": "LENGTHADJUST_SPACINGANDGLYPHS",
        "长度调_节间距_未知": "LENGTHADJUST_UNKNOWN",
        "间距": "spacing",
        "文本路径_方法类型_对齐": "TEXTPATH_METHODTYPE_ALIGN",
        "文本路径_方法类型_拉伸": "TEXTPATH_METHODTYPE_STRETCH",
        "文本路径_方法类型_未知": "TEXTPATH_METHODTYPE_UNKNOWN",
        "文本路径_间隔类型_自动": "TEXTPATH_SPACINGTYPE_AUTO",
        "文本路径_间隔类型_精确": "TEXTPATH_SPACINGTYPE_EXACT",
        "文本路径_间隔类型_未知": "TEXTPATH_SPACINGTYPE_UNKNOWN",
        "置矩阵": "setMatrix",
        "置旋转": "setRotate",
        "置放缩": "setScale",
        "置倾斜X": "setSkewX",
        "置倾斜Y": "setSkewY",
        "置翻译": "setTranslate",
        "SVG_转换_矩阵": "SVG_TRANSFORM_MATRIX",
        "SVG_转换_旋转": "SVG_TRANSFORM_ROTATE",
        "SVG_转换_放缩": "SVG_TRANSFORM_SCALE",
        "SVG_转换_倾斜X": "SVG_TRANSFORM_SKEWX",
        "SVG_转换_倾斜Y": "SVG_TRANSFORM_SKEWY",
        "SVG_转换_变换": "SVG_TRANSFORM_TRANSLATE",
        "SVG_转换_未知": "SVG_TRANSFORM_UNKNOWN",
        "整合": "consolidate",
        "SVG_单元_类型_对象边界框": "SVG_UNIT_TYPE_OBJECTBOUNDINGBOX",
        "SVG_单元_类型_未知": "SVG_UNIT_TYPE_UNKNOWN",
        "SVG_单元_类型_用户自定义": "SVG_UNIT_TYPE_USERSPACEONUSE",
        "动画实例根": "animatedInstanceRoot",
        "实例根": "instanceRoot",
        "视图目标": "viewTarget",
        "放缩和平移": "zoomAndPan",
        "SVG_放缩和平移_禁用": "SVG_ZOOMANDPAN_DISABLE",
        "SVG_放缩和平移_放大": "SVG_ZOOMANDPAN_MAGNIFY",
        "SVG_放缩和平移_未知": "SVG_ZOOMANDPAN_UNKNOWN",
        "新比例": "newScale",
        "新翻译": "newTranslate",
        "以前比例": "previousScale",
        "以前翻译": "previousTranslate",
        "缩放矩形屏幕": "zoomRectScreen",
        "作用域凭据": "ScopedCredential",
        "作用域凭据信息": "ScopedCredentialInfo",
        "屏幕事件映射": "ScreenEventMap",
        "MS定位改变": "MSOrientationChange",
        "屏幕类": "Screen",
        "有效高度": "availHeight",
        "有效宽度": "availWidth",
        "缓冲区景深": "bufferDepth",
        "颜色景深": "colorDepth",
        "设备XDPI": "deviceXDPI",
        "设备YDPI": "deviceYDPI",
        "字体平滑功能": "fontSmoothingEnabled",
        "逻辑XDPI": "logicalXDPI",
        "逻辑YDPI": "logicalYDPI",
        "MS定位": "msOrientation",
        "引发MS定位改变": "onmsorientationchange",
        "像素景深": "pixelDepth",
        "系统XDPI": "systemXDPI",
        "系统YDPI": "systemYDPI",
        "MS锁定定位": "msLockOrientation",
        "定位集": "orientations",
        "MS解锁定位": "msUnlockOrientation",
        "脚本通知事件类": "ScriptNotifyEvent",
        "呼叫URI": "callingUri",
        "脚本处理器节点事件映射": "ScriptProcessorNodeEventMap",
        "引发音频处理": "onaudioprocess",
        "锚节点": "anchorNode",
        "锚偏移": "anchorOffset",
        "基节点": "baseNode",
        "基偏移": "baseOffset",
        "延伸节点": "extentNode",
        "延伸偏移": "extentOffset",
        "中心节点": "focusNode",
        "中心偏移": "focusOffset",
        "是折叠": "isCollapsed",
        "范围计数": "rangeCount",
        "添加范围": "addRange",
        "折叠结束": "collapseToEnd",
        "折叠开始": "collapseToStart",
        "包含节点": "containsNode",
        "节点": "node",
        "部分包含": "partlyContained",
        "从文档删除": "deleteFromDocument",
        "空的": "empty",
        "延伸": "extend",
        "取范围在": "getRangeAt",
        "删除所有范围": "removeAllRanges",
        "删除范围": "removeRange",
        "选择所有子": "selectAllChildren",
        "置基础和延伸": "setBaseAndExtent",
        "服务平台事件映射": "ServiceWorkerEventMap",
        "抽象平台事件映射": "AbstractWorkerEventMap",
        "抽象平台": "AbstractWorker",
        "脚本URL": "scriptURL",
        "服务平台容器事件映射": "ServiceWorkerContainerEventMap",
        "服务平台消息事件类": "ServiceWorkerMessageEvent",
        "控制器": "controller",
        "引发控制器改变": "oncontrollerchange",
        "准备": "ready",
        "服务平台登记处": "ServiceWorkerRegistration",
        "取登记处": "getRegistration",
        "客户端URL": "clientURL",
        "取登记处集": "getRegistrations",
        "登记": "register",
        "服务平台登记处事件映射": "ServiceWorkerRegistrationEventMap",
        "安装": "installing",
        "引发发现更新": "onupdatefound",
        "压入管理者": "pushManager",
        "同步": "sync",
        "图标管理者": "SyncManager",
        "取通知": "getNotifications",
        "显示通知": "showNotification",
        "注销": "unregister",
        "附加窗口结束": "appendWindowEnd",
        "附加窗口开始": "appendWindowStart",
        "时间戳偏移": "timestampOffset",
        "更新中": "updating",
        "附加缓冲区": "appendBuffer",
        "附加流": "appendStream",
        "语音合成事件映射": "SpeechSynthesisEventMap",
        "语音合成类": "SpeechSynthesis",
        "引发声音改变": "onvoiceschanged",
        "讲话中": "speaking",
        "取声音": "getVoices",
        "语音合成声音": "SpeechSynthesisVoice",
        "说话": "speak",
        "语音合成事件类": "SpeechSynthesisEvent",
        "语音合成话语事件映射": "SpeechSynthesisUtteranceEventMap",
        "引发边界": "onboundary",
        "引发结束": "onend",
        "引发标志": "onmark",
        "引发恢复": "onresume",
        "高音": "pitch",
        "比率": "rate",
        "声音": "voice",
        "本地服务": "localService",
        "声音URI": "voiceURI",
        "面板": "pan",
        "储存类": "Storage",
        "置项目": "setItem",
        "存储区": "storageArea",
        "储存数据初始化": "StorageEventInit",
        "媒体样式": "StyleMedia",
        "匹配介质": "matchMedium",
        "介质查询": "mediaquery",
        "主节点": "ownerNode",
        "解密": "decrypt",
        "RSA_OAEP参数集": "RsaOaepParams",
        "AES_CTR参数集": "AesCtrParams",
        "AES_CBC参数集": "AesCbcParams",
        "AES_CMAC参数集": "AesCmacParams",
        "AES_GCM参数集": "AesGcmParams",
        "AES_CFB参数集": "AesCfbParams",
        "缓冲区源": "BufferSource",
        "提取位": "deriveBits",
        "ECDH键提取参数集": "EcdhKeyDeriveParams",
        "DH键提取参数集": "DhKeyDeriveParams",
        "连接参数集": "ConcatParams",
        "HKDF_CTR参数集": "HkdfCtrParams",
        "PBDF2参数集": "Pbkdf2Params",
        "基键": "baseKey",
        "提取键": "deriveKey",
        "提取键类型": "derivedKeyType",
        "AES提取键参数集": "AesDerivedKeyParams",
        "HMAC输入参数集": "HmacImportParams",
        "键用法": "keyUsages",
        "整理": "digest",
        "算法标识符": "AlgorithmIdentifier",
        "出口键": "exportKey",
        "JsonWeb键": "jwk",
        "JSON_WEB键": "JsonWebKey",
        "公开密钥密码标准8": "pkcs8",
        "简单": "spki",
        "生成密钥": "generateKey",
        "RSA哈希键根数集": "RsaHashedKeyGenParams",
        "EC键根参数集": "EcKeyGenParams",
        "DH键根参数集": "DhKeyGenParams",
        "AES键根参数集": "AesKeyGenParams",
        "HMAC键根参数集": "HmacKeyGenParams",
        "输入键": "importKey",
        "键数据": "keyData",
        "RSA哈希输入参数集": "RsaHashedImportParams",
        "EC键输入参数集": "EcKeyImportParams",
        "DH输入键参数集": "DhImportKeyParams",
        "_签名": "sign",
        "RSA_PSS参数集": "RsaPssParams",
        "ECDSA参数集": "EcdsaParams",
        "打开键": "unwrapKey",
        "包装后键": "wrappedKey",
        "展开键": "unwrappingKey",
        "打开算法": "unwrapAlgorithm",
        "打开密钥算法": "unwrappedKeyAlgorithm",
        "核实": "verify",
        "包装键": "wrapKey",
        "包装中键": "wrappingKey",
        "包装算法": "wrapAlgorithm",
        "取标签集": "getTags",
        "整个文本": "wholeText",
        "分割文本": "splitText",
        "文本事件类": "TextEvent",
        "输入法": "inputMethod",
        "初始化文本事件类": "initTextEvent",
        "文档_输入_方法_下降": "DOM_INPUT_METHOD_DROP",
        "文档_输入_方法_笔迹": "DOM_INPUT_METHOD_HANDWRITING",
        "文档_输入_方法_IME": "DOM_INPUT_METHOD_IME",
        "文档_输入_方法_键盘": "DOM_INPUT_METHOD_KEYBOARD",
        "文档_输入_方法_多模式": "DOM_INPUT_METHOD_MULTIMODAL",
        "文档_输入_方法_选项": "DOM_INPUT_METHOD_OPTION",
        "文档_输入_方法_粘贴": "DOM_INPUT_METHOD_PASTE",
        "文档_输入_方法_脚本": "DOM_INPUT_METHOD_SCRIPT",
        "文档_输入_方法_未知": "DOM_INPUT_METHOD_UNKNOWN",
        "文档_输入_方法_声音": "DOM_INPUT_METHOD_VOICE",
        "文本轨道事件映射": "TextTrackEventMap",
        "主动提示": "activeCues",
        "文本轨道提示列表": "TextTrackCueList",
        "提示集": "cues",
        "引发带元数据跟踪调度类型": "inBandMetadataTrackDispatchType",
        "添加提示": "addCue",
        "提示": "cue",
        "删除提示": "removeCue",
        "禁用_": "DISABLED",
        "隐藏_": "HIDDEN",
        "显示_": "SHOWING",
        "引发确认": "onenter",
        "引发退出": "onexit",
        "暂停出口": "pauseOnExit",
        "取提示转为超文本": "getCueAsHTML",
        "取提示根据ID": "getCueById",
        "文本轨道列表事件映射": "TextTrackListEventMap",
        "改变触摸": "changedTouches",
        "目标触摸": "targetTouches",
        "过度事件类": "TransitionEvent",
        "初始化过度事件类": "initTransitionEvent",
        "属性名称参数": "propertyNameArg",
        "当前节点": "currentNode",
        "初始化UI事件类": "initUIEvent",
        "搜索参数": "searchparams",
        "URL搜索参数集": "URLSearchParams",
        "基": "base",
        "创建对象URL": "createObjectURL",
        "撤销对象URL": "revokeObjectURL",
        "无法观看内容识标识符事件类": "UnviewableContentIdentifiedEvent",
        "媒体类型": "mediaType",
        "输入错误": "badInput",
        "自定义错误": "customError",
        "模式不匹配": "patternMismatch",
        "超出范围": "rangeOverflow",
        "范围下溢": "rangeUnderflow",
        "步幅不匹配": "stepMismatch",
        "太长了": "tooLong",
        "类型不匹配": "typeMismatch",
        "有效": "valid",
        "值失踪": "valueMissing",
        "损坏视频帧": "corruptedVideoFrames",
        "创建时间": "creationTime",
        "丢弃视频帧": "droppedVideoFrames",
        "总框架延迟": "totalFrameDelay",
        "总视频帧": "totalVideoFrames",
        "视频轨道列表事件映射": "VideoTrackListEventMap",
        "WEBGL_压缩_纹理_s3tc": "WEBGL_compressed_texture_s3tc",
        "压缩_RGBA_S3TC_DXT1_EXT": "COMPRESSED_RGBA_S3TC_DXT1_EXT",
        "压缩_RGBA_S3TC_DXT3_EXT": "COMPRESSED_RGBA_S3TC_DXT3_EXT",
        "压缩_RGBA_S3TC_DXT5_EXT": "COMPRESSED_RGBA_S3TC_DXT5_EXT",
        "压缩_RGB_S3TC_DXT1_EXT": "COMPRESSED_RGB_S3TC_DXT1_EXT",
        "WEBGL_调试_输出_信息": "WEBGL_debug_renderer_info",
        "揭秘_渲染_WEBGL": "UNMASKED_RENDERER_WEBGL",
        "揭秘_供应商_WEBGL": "UNMASKED_VENDOR_WEBGL",
        "WEBGL_景深_纹理": "WEBGL_depth_texture",
        "无符号_整数_24_8_WEBGL": "UNSIGNED_INT_24_8_WEBGL",
        "曲线": "curve",
        "细分采样": "oversample",
        "断言挑战": "assertionChallenge",
        "WEB认证N断言": "WebAuthnAssertion",
        "帐户查询处": "accountInformation",
        "加密参数集": "cryptoParameters",
        "认证挑战": "attestationChallenge",
        "认证数据": "authenticatorData",
        "WEBGL活动信息": "WebGLActiveInfo",
        "WEBGL缓冲区": "WebGLBuffer",
        "WEBGL对象": "WebGLObject",
        "WEBGL语境事件类": "WebGLContextEvent",
        "WEBGL帧缓冲区": "WebGLFramebuffer",
        "WEBGL程序": "WebGLProgram",
        "WEBGL渲染": "WebGLRenderbuffer",
        "绘图缓冲区高度": "drawingBufferHeight",
        "绘图缓冲区宽度": "drawingBufferWidth",
        "活跃纹理": "activeTexture",
        "纹理": "texture",
        "附上材质": "attachShader",
        "程序": "program",
        "着色器": "shader",
        "WEBGL着色器": "WebGLShader",
        "绑定特性定位": "bindAttribLocation",
        "结合缓冲区": "bindBuffer",
        "结合帧缓冲": "bindFramebuffer",
        "帧缓冲区": "framebuffer",
        "绑定渲染缓存": "bindRenderbuffer",
        "渲染缓存": "renderbuffer",
        "绑定纹理": "bindTexture",
        "WEBGL纹理": "WebGLTexture",
        "混合颜色": "blendColor",
        "红": "red",
        "绿": "green",
        "蓝": "blue",
        "混合方程": "blendEquation",
        "混单独方程": "blendEquationSeparate",
        "模式RGB": "modeRGB",
        "模式通道": "modeAlpha",
        "混合函数": "blendFunc",
        "S因素": "sfactor",
        "D因素": "dfactor",
        "混合函数独立": "blendFuncSeparate",
        "源RGB": "srcRGB",
        "测试RGB": "dstRGB",
        "源通道": "srcAlpha",
        "测试通道": "dstAlpha",
        "缓冲区数据": "bufferData",
        "缓冲区子数据": "bufferSubData",
        "检查帧状态": "checkFramebufferStatus",
        "清除颜色": "clearColor",
        "清除景深": "clearDepth",
        "清除模板": "clearStencil",
        "颜色遮罩": "colorMask",
        "编译着色器": "compileShader",
        "压缩纹理图像2D": "compressedTexImage2D",
        "层": "level",
        "内部格式": "internalformat",
        "压缩纹理子图像2D": "compressedTexSubImage2D",
        "X偏移": "xoffset",
        "Y偏移": "yoffset",
        "复制纹理图像2D": "copyTexImage2D",
        "复制纹理子图像2D": "copyTexSubImage2D",
        "创建帧缓存": "createFramebuffer",
        "创建程序": "createProgram",
        "创建渲染缓冲区": "createRenderbuffer",
        "创建着色器": "createShader",
        "创建纹理": "createTexture",
        "挑选饰面": "cullFace",
        "删除缓冲区": "deleteBuffer",
        "删除帧缓冲": "deleteFramebuffer",
        "删除程序": "deleteProgram",
        "删除渲染缓冲区": "deleteRenderbuffer",
        "删除着色器": "deleteShader",
        "删除纹理": "deleteTexture",
        "景深函数": "depthFunc",
        "_函数": "func",
        "景深遮罩": "depthMask",
        "标记": "flag",
        "景深范围": "depthRange",
        "Z近": "zNear",
        "Z远": "zFar",
        "分离着色器": "detachShader",
        "禁用": "disable",
        "帽": "cap",
        "禁用顶点特性数组": "disableVertexAttribArray",
        "绘制数组集": "drawArrays",
        "绘制元素": "drawElements",
        "启用": "enable",
        "启用顶点特性数组": "enableVertexAttribArray",
        "冲刷": "flush",
        "帧缓冲渲染缓冲区": "framebufferRenderbuffer",
        "附件": "attachment",
        "渲染缓冲区对象": "renderbuffertarget",
        "帧缓冲区纹理2D": "framebufferTexture2D",
        "纹理目标": "textarget",
        "正面": "frontFace",
        "生成纹理映射": "generateMipmap",
        "取活动特性": "getActiveAttrib",
        "取活动均匀": "getActiveUniform",
        "取附加着色器": "getAttachedShaders",
        "取特性定位": "getAttribLocation",
        "取缓冲区参数": "getBufferParameter",
        "参数名称": "pname",
        "取语境特性": "getContextAttributes",
        "取错误": "getError",
        "取延伸": "getExtension",
        "取帧缓冲连接参数": "getFramebufferAttachmentParameter",
        "取参数": "getParameter",
        "取程序信息日志": "getProgramInfoLog",
        "取程序参数": "getProgramParameter",
        "取渲染缓冲参数": "getRenderbufferParameter",
        "取着色器信息日志": "getShaderInfoLog",
        "取着色器参数": "getShaderParameter",
        "取着色器精度格式": "getShaderPrecisionFormat",
        "材质类型": "shadertype",
        "精密类型": "precisiontype",
        "WEBGL着色器精度格式": "WebGLShaderPrecisionFormat",
        "取着色器源": "getShaderSource",
        "取支持扩展": "getSupportedExtensions",
        "取纹理参数": "getTexParameter",
        "取统一": "getUniform",
        "WEBGL统一位置": "WebGLUniformLocation",
        "取统一位置": "getUniformLocation",
        "取顶点特性": "getVertexAttrib",
        "取顶点特性偏移": "getVertexAttribOffset",
        "暗示": "hint",
        "是缓冲区": "isBuffer",
        "是丢失语境": "isContextLost",
        "是启用": "isEnabled",
        "是帧缓冲区": "isFramebuffer",
        "是程序": "isProgram",
        "是渲染缓冲区": "isRenderbuffer",
        "是着色器": "isShader",
        "是纹理": "isTexture",
        "链接程序": "linkProgram",
        "像素商店": "pixelStorei",
        "多边形偏移": "polygonOffset",
        "因素": "factor",
        "读取像素": "readPixels",
        "像素": "pixels",
        "渲染缓冲区储存": "renderbufferStorage",
        "样本覆盖范围": "sampleCoverage",
        "反相器": "invert",
        "剪开": "scissor",
        "着色器源": "shaderSource",
        "模板函数": "stencilFunc",
        "模板函数分离": "stencilFuncSeparate",
        "模板遮罩": "stencilMask",
        "模板遮罩分离": "stencilMaskSeparate",
        "模板运算": "stencilOp",
        "失败": "fail",
        "Z失败": "zfail",
        "Z通过": "zpass",
        "模板运算分离": "stencilOpSeparate",
        "纹理图像2D": "texImage2D",
        "纹理参数F": "texParameterf",
        "纹理参数I": "texParameteri",
        "纹理子图像2D": "texSubImage2D",
        "统一1f": "uniform1f",
        "统一1fv": "uniform1fv",
        "统一1i": "uniform1i",
        "统一1iv": "uniform1iv",
        "统一2f": "uniform2f",
        "统一2fv": "uniform2fv",
        "统一2i": "uniform2i",
        "统一2iv": "uniform2iv",
        "统一3f": "uniform3f",
        "统一3fv": "uniform3fv",
        "统一3i": "uniform3i",
        "统一3iv": "uniform3iv",
        "统一4f": "uniform4f",
        "统一4fv": "uniform4fv",
        "统一4i": "uniform4i",
        "统一4iv": "uniform4iv",
        "统一矩阵2fv": "uniformMatrix2fv",
        "转置": "transpose",
        "统一矩阵3fv": "uniformMatrix3fv",
        "统一矩阵4fv": "uniformMatrix4fv",
        "使用程序": "useProgram",
        "验证程序": "validateProgram",
        "顶点特性1f": "vertexAttrib1f",
        "指数": "indx",
        "顶点特性1fv": "vertexAttrib1fv",
        "顶点特性2f": "vertexAttrib2f",
        "顶点特性2fv": "vertexAttrib2fv",
        "顶点特性3f": "vertexAttrib3f",
        "顶点特性3fv": "vertexAttrib3fv",
        "顶点特性4f": "vertexAttrib4f",
        "顶点特性4fv": "vertexAttrib4fv",
        "顶点特性指针": "vertexAttribPointer",
        "归一化": "normalized",
        "跨越": "stride",
        "活动_特性": "ACTIVE_ATTRIBUTES",
        "活动_纹理": "ACTIVE_TEXTURE",
        "活动_制服": "ACTIVE_UNIFORMS",
        "锯齿_线_宽度_范围": "ALIASED_LINE_WIDTH_RANGE",
        "锯齿_点_大小_范围": "ALIASED_POINT_SIZE_RANGE",
        "透明_": "ALPHA",
        "透明_位集": "ALPHA_BITS",
        "总是_": "ALWAYS",
        "数组_缓冲区": "ARRAY_BUFFER",
        "数组_缓冲区_结合": "ARRAY_BUFFER_BINDING",
        "附加_着色器": "ATTACHED_SHADERS",
        "背面_": "BACK",
        "混合_": "BLEND",
        "混合_颜色": "BLEND_COLOR",
        "混合_DST_透明": "BLEND_DST_ALPHA",
        "混合_DST_RGB": "BLEND_DST_RGB",
        "混合_方程": "BLEND_EQUATION",
        "混合_方程_透明": "BLEND_EQUATION_ALPHA",
        "混合_方程_RGB": "BLEND_EQUATION_RGB",
        "混合_SRC_透明": "BLEND_SRC_ALPHA",
        "混合_SRC_RGB": "BLEND_SRC_RGB",
        "蓝色_位": "BLUE_BITS",
        "布尔_": "BOOL",
        "布尔_VEC2": "BOOL_VEC2",
        "布尔_VEC3": "BOOL_VEC3",
        "布尔_VEC4": "BOOL_VEC4",
        "浏览器_默认_WebGL": "BROWSER_DEFAULT_WEBGL",
        "缓冲区_大小": "BUFFER_SIZE",
        "缓冲区_使用": "BUFFER_USAGE",
        "字节_": "BYTE",
        "锁住_边": "CLAMP_TO_EDGE",
        "色彩_附件0": "COLOR_ATTACHMENT0",
        "颜色_缓冲区_位": "COLOR_BUFFER_BIT",
        "色彩_清晰_价值": "COLOR_CLEAR_VALUE",
        "颜色_写屏蔽": "COLOR_WRITEMASK",
        "编译_状态": "COMPILE_STATUS",
        "压缩_纹理_格式": "COMPRESSED_TEXTURE_FORMATS",
        "常数_透明": "CONSTANT_ALPHA",
        "常数_颜色": "CONSTANT_COLOR",
        "语境_丢失_WEBGL": "CONTEXT_LOST_WEBGL",
        "挑选_饰面": "CULL_FACE",
        "挑选_饰面_模式": "CULL_FACE_MODE",
        "当前_程序": "CURRENT_PROGRAM",
        "当前_顶点_特性": "CURRENT_VERTEX_ATTRIB",
        "减少_": "DECR",
        "减少_包装": "DECR_WRAP",
        "删除_状态": "DELETE_STATUS",
        "景深_附件": "DEPTH_ATTACHMENT",
        "景深_位集": "DEPTH_BITS",
        "景深_缓冲区_位": "DEPTH_BUFFER_BIT",
        "景深_清除_值": "DEPTH_CLEAR_VALUE",
        "景深_组件": "DEPTH_COMPONENT",
        "景深_组件16": "DEPTH_COMPONENT16",
        "景深_函数": "DEPTH_FUNC",
        "景深_范围": "DEPTH_RANGE",
        "景深_模板": "DEPTH_STENCIL",
        "景深_模板_附件": "DEPTH_STENCIL_ATTACHMENT",
        "景深_测试": "DEPTH_TEST",
        "景深_写屏蔽": "DEPTH_WRITEMASK",
        "抖动_": "DITHER",
        "不_照顾": "DONT_CARE",
        "DST_透明": "DST_ALPHA",
        "DST_颜色": "DST_COLOR",
        "动态_绘制": "DYNAMIC_DRAW",
        "元素_数组_缓冲区": "ELEMENT_ARRAY_BUFFER",
        "元素_数组_缓冲区_结合": "ELEMENT_ARRAY_BUFFER_BINDING",
        "相等_": "EQUAL",
        "最快_": "FASTEST",
        "浮点_": "FLOAT",
        "浮点_MAT2": "FLOAT_MAT2",
        "浮点_MAT3": "FLOAT_MAT3",
        "浮点_MAT4": "FLOAT_MAT4",
        "浮点_VEC2": "FLOAT_VEC2",
        "浮点_VEC3": "FLOAT_VEC3",
        "浮点_VEC4": "FLOAT_VEC4",
        "片段_着色器": "FRAGMENT_SHADER",
        "帧缓冲区_": "FRAMEBUFFER",
        "帧缓冲区_附件_对象_名称": "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
        "帧缓冲区_附件_对象_类型": "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
        "帧缓冲区_附件_纹理_立方体_图面": "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
        "帧缓冲区_附件_纹理_水平": "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
        "帧缓冲区_结合": "FRAMEBUFFER_BINDING",
        "帧缓冲区_完成": "FRAMEBUFFER_COMPLETE",
        "帧缓冲区_不完整_附件": "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
        "帧缓冲区_不完整_尺寸": "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
        "帧缓冲区_不完整_失踪_附件": "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
        "帧缓冲区_不支持": "FRAMEBUFFER_UNSUPPORTED",
        "前_": "FRONT",
        "正面_和_背面": "FRONT_AND_BACK",
        "正_面": "FRONT_FACE",
        "函数_添加": "FUNC_ADD",
        "函数_逆减": "FUNC_REVERSE_SUBTRACT",
        "函数_减": "FUNC_SUBTRACT",
        "生成_MIP_映射_提示": "GENERATE_MIPMAP_HINT",
        "G_等于": "GEQUAL",
        "G_大于": "GREATER",
        "绿色位": "GREEN_BITS",
        "高_浮点": "HIGH_FLOAT",
        "高_整数": "HIGH_INT",
        "实现_颜色_读取_格式": "IMPLEMENTATION_COLOR_READ_FORMAT",
        "实现_颜色_读取_类型": "IMPLEMENTATION_COLOR_READ_TYPE",
        "增加_": "INCR",
        "增加_包装": "INCR_WRAP",
        "整数_": "INT",
        "整数_VEC2": "INT_VEC2",
        "整数_VEC3": "INT_VEC3",
        "整数_VEC4": "INT_VEC4",
        "无效_枚举": "INVALID_ENUM",
        "无效_帧缓冲区_操作": "INVALID_FRAMEBUFFER_OPERATION",
        "无效_操作": "INVALID_OPERATION",
        "无效_值": "INVALID_VALUE",
        "使转化_": "INVERT",
        "保持_": "KEEP",
        "L等于_": "LEQUAL",
        "不足_": "LESS",
        "线性_": "LINEAR",
        "线性_MIPMAP_线性": "LINEAR_MIPMAP_LINEAR",
        "线性_MIPMAP_最近": "LINEAR_MIPMAP_NEAREST",
        "线_": "LINES",
        "线_环": "LINE_LOOP",
        "线_带": "LINE_STRIP",
        "线_宽度": "LINE_WIDTH",
        "线_状态": "LINK_STATUS",
        "低_浮点": "LOW_FLOAT",
        "低_整数": "LOW_INT",
        "亮度_": "LUMINANCE",
        "亮度_透明": "LUMINANCE_ALPHA",
        "最大_组合_纹理_图像_单元": "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
        "最大_立方体_贴图_大小": "MAX_CUBE_MAP_TEXTURE_SIZE",
        "最大_片段_一致_向量": "MAX_FRAGMENT_UNIFORM_VECTORS",
        "最大_渲染_缓冲区_大小": "MAX_RENDERBUFFER_SIZE",
        "最大_纹理_图像_单位": "MAX_TEXTURE_IMAGE_UNITS",
        "最大_纹理_大小": "MAX_TEXTURE_SIZE",
        "最大_变化_载体": "MAX_VARYING_VECTORS",
        "最大_顶点_特性": "MAX_VERTEX_ATTRIBS",
        "最大_顶点_纹理_图像_单位": "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
        "最大_顶点_均匀_向量": "MAX_VERTEX_UNIFORM_VECTORS",
        "最大_视口_尺寸": "MAX_VIEWPORT_DIMS",
        "介质_浮点": "MEDIUM_FLOAT",
        "介质_整数": "MEDIUM_INT",
        "镜像_重复": "MIRRORED_REPEAT",
        "最近_": "NEAREST",
        "最近_MIPMAP_线性": "NEAREST_MIPMAP_LINEAR",
        "最近_MIPMAP_最近": "NEAREST_MIPMAP_NEAREST",
        "从未_": "NEVER",
        "最好_": "NICEST",
        "不等_": "NOTEQUAL",
        "没_错_误": "NO_ERROR",
        "一个_": "ONE",
        "一个_负_常数_透明": "ONE_MINUS_CONSTANT_ALPHA",
        "一个_负_常数_色彩": "ONE_MINUS_CONSTANT_COLOR",
        "一个_负_DST_透明": "ONE_MINUS_DST_ALPHA",
        "一个_负_DST_色彩": "ONE_MINUS_DST_COLOR",
        "一个_负_SRT_透明": "ONE_MINUS_SRC_ALPHA",
        "一个_负_SRC_色彩": "ONE_MINUS_SRC_COLOR",
        "内存_不足": "OUT_OF_MEMORY",
        "包_对齐": "PACK_ALIGNMENT",
        "点集_": "POINTS",
        "多边形_偏移_因子": "POLYGON_OFFSET_FACTOR",
        "多边形_偏移_填补": "POLYGON_OFFSET_FILL",
        "多边形_偏移_单位": "POLYGON_OFFSET_UNITS",
        "红色_位": "RED_BITS",
        "渲染_": "RENDERBUFFER",
        "渲染_透明_大小": "RENDERBUFFER_ALPHA_SIZE",
        "渲染_结合": "RENDERBUFFER_BINDING",
        "渲染_蓝色_大小": "RENDERBUFFER_BLUE_SIZE",
        "渲染_景深_大小": "RENDERBUFFER_DEPTH_SIZE",
        "渲染_绿色_大小": "RENDERBUFFER_GREEN_SIZE",
        "渲染_高度": "RENDERBUFFER_HEIGHT",
        "渲染_内部_格式": "RENDERBUFFER_INTERNAL_FORMAT",
        "渲染_红色_大小": "RENDERBUFFER_RED_SIZE",
        "渲染_模板_大小": "RENDERBUFFER_STENCIL_SIZE",
        "渲染_宽度": "RENDERBUFFER_WIDTH",
        "渲染器_": "RENDERER",
        "重复_": "REPEAT",
        "更换_": "REPLACE",
        "采样器_2D": "SAMPLER_2D",
        "采样器_CUBE": "SAMPLER_CUBE",
        "样品集_": "SAMPLES",
        "样品_透明_到_覆盖": "SAMPLE_ALPHA_TO_COVERAGE",
        "样品_缓冲区": "SAMPLE_BUFFERS",
        "样品_覆盖": "SAMPLE_COVERAGE",
        "样品_覆盖_使转化": "SAMPLE_COVERAGE_INVERT",
        "样品_覆盖_价值": "SAMPLE_COVERAGE_VALUE",
        "剪刀_盒子": "SCISSOR_BOX",
        "剪刀R_测试": "SCISSOR_TEST",
        "着色器_类型": "SHADER_TYPE",
        "着色器_语言_版本": "SHADING_LANGUAGE_VERSION",
        "短期_": "SHORT",
        "源_透明": "SRC_ALPHA",
        "源_透明_浸透": "SRC_ALPHA_SATURATE",
        "源_颜色": "SRC_COLOR",
        "静态_画笔": "STATIC_DRAW",
        "静态_ATTACHMENT": "STENCIL_ATTACHMENT",
        "静态_后面_失败": "STENCIL_BACK_FAIL",
        "静态_后面_函数": "STENCIL_BACK_FUNC",
        "静态_后面_通过_深度_失败": "STENCIL_BACK_PASS_DEPTH_FAIL",
        "静态_后面_通过_深度_通过": "STENCIL_BACK_PASS_DEPTH_PASS",
        "静态_后面_REF": "STENCIL_BACK_REF",
        "静态_后面_值_遮罩": "STENCIL_BACK_VALUE_MASK",
        "静态_后面_写遮罩": "STENCIL_BACK_WRITEMASK",
        "静态_位": "STENCIL_BITS",
        "静态_缓冲区_位": "STENCIL_BUFFER_BIT",
        "静态_明确_值": "STENCIL_CLEAR_VALUE",
        "静态_失败": "STENCIL_FAIL",
        "静态_函数": "STENCIL_FUNC",
        "静态_指数": "STENCIL_INDEX",
        "静态_指数8": "STENCIL_INDEX8",
        "静态_通过_深度_失败": "STENCIL_PASS_DEPTH_FAIL",
        "静态_通过_深度_通过": "STENCIL_PASS_DEPTH_PASS",
        "静态_REF": "STENCIL_REF",
        "静态_测试": "STENCIL_TEST",
        "模板_值_遮罩": "STENCIL_VALUE_MASK",
        "模板_写遮罩": "STENCIL_WRITEMASK",
        "流_画笔": "STREAM_DRAW",
        "亚像素_位": "SUBPIXEL_BITS",
        "纹理_": "TEXTURE",
        "纹理_0": "TEXTURE0",
        "纹理_1": "TEXTURE1",
        "纹理_10": "TEXTURE10",
        "纹理_11": "TEXTURE11",
        "纹理_12": "TEXTURE12",
        "纹理_13": "TEXTURE13",
        "纹理_14": "TEXTURE14",
        "纹理_15": "TEXTURE15",
        "纹理_16": "TEXTURE16",
        "纹理_17": "TEXTURE17",
        "纹理_18": "TEXTURE18",
        "纹理_19": "TEXTURE19",
        "纹理_2": "TEXTURE2",
        "纹理_20": "TEXTURE20",
        "纹理_21": "TEXTURE21",
        "纹理_22": "TEXTURE22",
        "纹理_23": "TEXTURE23",
        "纹理_24": "TEXTURE24",
        "纹理_25": "TEXTURE25",
        "纹理_26": "TEXTURE26",
        "纹理_27": "TEXTURE27",
        "纹理_28": "TEXTURE28",
        "纹理_29": "TEXTURE29",
        "纹理_3": "TEXTURE3",
        "纹理_30": "TEXTURE30",
        "纹理_31": "TEXTURE31",
        "纹理_4": "TEXTURE4",
        "纹理_5": "TEXTURE5",
        "纹理_6": "TEXTURE6",
        "纹理_7": "TEXTURE7",
        "纹理_8": "TEXTURE8",
        "纹理_9": "TEXTURE9",
        "纹理_2D": "TEXTURE_2D",
        "纹理_结合_2D": "TEXTURE_BINDING_2D",
        "纹理_结合_立方体_贴图": "TEXTURE_BINDING_CUBE_MAP",
        "纹理_立方体_贴图": "TEXTURE_CUBE_MAP",
        "纹理_立方体_贴图_负_X": "TEXTURE_CUBE_MAP_NEGATIVE_X",
        "纹理_立方体_贴图_负_Y": "TEXTURE_CUBE_MAP_NEGATIVE_Y",
        "纹理_立方体_贴图_负_Z": "TEXTURE_CUBE_MAP_NEGATIVE_Z",
        "纹理_立方体_贴图_正_X": "TEXTURE_CUBE_MAP_POSITIVE_X",
        "纹理_立方体_贴图_正_Y": "TEXTURE_CUBE_MAP_POSITIVE_Y",
        "纹理_立方体_贴图_正_Z": "TEXTURE_CUBE_MAP_POSITIVE_Z",
        "纹理_贴图_滤波器": "TEXTURE_MAG_FILTER",
        "纹理_最小_滤波器": "TEXTURE_MIN_FILTER",
        "纹理_包围_S": "TEXTURE_WRAP_S",
        "纹理_包围_T": "TEXTURE_WRAP_T",
        "三角形_": "TRIANGLES",
        "三角形_FAN": "TRIANGLE_FAN",
        "三角形_带": "TRIANGLE_STRIP",
        "打开_对齐": "UNPACK_ALIGNMENT",
        "打开_色彩_空间_转换_WebGL": "UNPACK_COLORSPACE_CONVERSION_WEBGL",
        "打开_翻转Y_WEBGL": "UNPACK_FLIP_Y_WEBGL",
        "打开_自左乘_透明_WEBGL": "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
        "无符号_位": "UNSIGNED_BYTE",
        "无符号_整数": "UNSIGNED_INT",
        "无符号_短整数": "UNSIGNED_SHORT",
        "无符号_短整数_4_4_4_4": "UNSIGNED_SHORT_4_4_4_4",
        "无符号_短整数_5_5_5_1": "UNSIGNED_SHORT_5_5_5_1",
        "无符号_短整数_5_6_5": "UNSIGNED_SHORT_5_6_5",
        "验证_状态": "VALIDATE_STATUS",
        "小贩_": "VENDOR",
        "版本_": "VERSION",
        "定点_特性_数组_缓冲区_结合": "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
        "定点_特性_数组_启用": "VERTEX_ATTRIB_ARRAY_ENABLED",
        "定点_特性_数组_归一化": "VERTEX_ATTRIB_ARRAY_NORMALIZED",
        "定点_特性_数组_指针": "VERTEX_ATTRIB_ARRAY_POINTER",
        "定点_特性_数组_大小": "VERTEX_ATTRIB_ARRAY_SIZE",
        "定点_特性_数组_步幅": "VERTEX_ATTRIB_ARRAY_STRIDE",
        "定点_特性_数组_类型": "VERTEX_ATTRIB_ARRAY_TYPE",
        "顶点_着色器": "VERTEX_SHADER",
        "视口_": "VIEWPORT",
        "零_": "ZERO",
        "范围最大": "rangeMax",
        "范围最小": "rangeMin",
        "WE_CSS矩阵": "WebKitCSSMatrix",
        "角X": "angleX",
        "角Y": "angleY",
        "角Z": "angleZ",
        "旋转轴角": "rotateAxisAngle",
        "比例X": "scaleX",
        "比例Y": "scaleY",
        "比例Z": "scaleZ",
        "置矩阵值": "setMatrixValue",
        "WK目录条目": "WebKitDirectoryEntry",
        "WK条目": "WebKitEntry",
        "创建读者": "createReader",
        "WK目录阅读器": "WebKitDirectoryReader",
        "阅读条目": "readEntries",
        "文件系统": "filesystem",
        "WK文件系统": "WebKitFileSystem",
        "完整路径": "fullPath",
        "是目录": "isDirectory",
        "是文件": "isFile",
        "WK文件条目": "WebKitFileEntry",
        "WK点": "WebKitPoint",
        "网络套接字事件映射": "WebSocketEventMap",
        "网络套接字": "WebSocket",
        "二进制类型": "binaryType",
        "缓冲数量": "bufferedAmount",
        "引发打开": "onopen",
        "关闭_": "CLOSED",
        "关闭中_": "CLOSING",
        "连接中_": "CONNECTING",
        "打开_": "OPEN",
        "通信协议": "protocols",
        "滚轮组合值": "wheelDelta",
        "滚轮组合值X": "wheelDeltaX",
        "滚轮组合值Y": "wheelDeltaY",
        "初始化滚轮事件类": "initWheelEvent",
        "组合值X参数": "deltaXArg",
        "组合值Y参数": "deltaYArg",
        "组合值Z参数": "deltaZArg",
        "文档_组合值_行": "DOM_DELTA_LINE",
        "文档_组合值_页": "DOM_DELTA_PAGE",
        "文档_组合值_像素": "DOM_DELTA_PIXEL",
        "窗口事件映射": "WindowEventMap",
        "窗口定时器集": "WindowTimers",
        "窗口会话存储": "WindowSessionStorage",
        "窗口本地存储": "WindowLocalStorage",
        "窗口控制台": "WindowConsole",
        "IDB环境": "IDBEnvironment",
        "窗口基64编码": "WindowBase64",
        "全球销售": "GlobalFetch",
        "应用程序缓存": "applicationCache",
        "高速缓存集": "caches",
        "客户信息": "clientInformation",
        "默认状态": "defaultStatus",
        "设备像素比": "devicePixelRatio",
        "不跟踪": "doNotTrack",
        "文档": "document",
        "外部": "external",
        "框架单元": "frameElement",
        "框架集": "frames",
        "历史": "history",
        "内部高": "innerHeight",
        "内宽": "innerWidth",
        "是安全环境": "isSecureContext",
        "浏览器地址栏": "locationbar",
        "菜单栏": "menubar",
        "MS内容脚本": "msContentScript",
        "MS资格证书": "msCredentials",
        "领航员": "navigator",
        "屏幕缓冲": "offscreenBuffering",
        "引发罗盘需要校准": "oncompassneedscalibration",
        "引发设备灯光": "ondevicelight",
        "引发设备运动": "ondevicemotion",
        "引发设备定位": "ondeviceorientation",
        "错误事件处理": "ErrorEventHandler",
        "开启者": "opener",
        "排列方向": "orientation",
        "外部高度": "outerHeight",
        "外部宽度": "outerWidth",
        "页面X偏移": "pageXOffset",
        "页面Y偏移": "pageYOffset",
        "父": "parent",
        "性能": "performance",
        "个人栏": "personalbar",
        "屏幕": "screen",
        "屏幕左边": "screenLeft",
        "屏幕上部": "screenTop",
        "卷轴X": "scrollX",
        "卷轴Y": "scrollY",
        "滚动条": "scrollbars",
        "自身": "self",
        "语音合成": "speechSynthesis",
        "状态栏": "statusbar",
        "样式媒体": "styleMedia",
        "工具条": "toolbar",
        "自定义元素": "customElements",
        "自定义元素注册表": "CustomElementRegistry",
        "警觉": "alert",
        "取消动画帧": "cancelAnimationFrame",
        "处理": "handle",
        "证实": "confirm",
        "离开焦点": "departFocus",
        "取匹配CSS规则": "getMatchedCSSRules",
        "匹配媒体": "matchMedia",
        "媒体查询": "mediaQuery",
        "移动": "moveBy",
        "移动到": "moveTo",
        "MS写入分析器遮罩": "msWriteProfilerMark",
        "分析器遮罩名称": "profilerMarkName",
        "目标来源": "targetOrigin",
        "打印": "print",
        "促使": "prompt",
        "_默认": "_default",
        "需求动画框帧": "requestAnimationFrame",
        "帧请求回调": "FrameRequestCallback",
        "调整大小过": "resizeBy",
        "调整大小到": "resizeTo",
        "WK取消动画帧": "webkitCancelAnimationFrame",
        "WK转换点从节点到页面": "webkitConvertPointFromNodeToPage",
        "WK转换点从页面到节点": "webkitConvertPointFromPageToNode",
        "WK要求动画帧": "webkitRequestAnimationFrame",
        "平台事件映射": "WorkerEventMap",
        "平台类": "Worker",
        "终止": "terminate",
        "文字URL": "stringUrl",
        "XML文档类": "XMLDocument",
        "XML超文本传输请求事件映射": "XMLHttpRequestEventMap",
        "XML超文本传输请求事件目标事件映射": "XMLHttpRequestEventTargetEventMap",
        "XML超文本传输请求": "XMLHttpRequest",
        "XML超文本传输请求事件目标": "XMLHttpRequestEventTarget",
        "响应文本": "responseText",
        "响应类型": "responseType",
        "响应文本URL": "responseURL",
        "响应文本XML": "responseXML",
        "上传": "upload",
        "XML超文本传输请求上传": "XMLHttpRequestUpload",
        "有凭据": "withCredentials",
        "MS缓存中": "msCaching",
        "取所有响应头": "getAllResponseHeaders",
        "取响应头": "getResponseHeader",
        "头部": "header",
        "MS启用缓存": "msCachingEnabled",
        "用户": "user",
        "重写MIME类型": "overrideMimeType",
        "文件扩展名类型": "mime",
        "置请求报头": "setRequestHeader",
        "完成_": "DONE",
        "头部_收到": "HEADERS_RECEIVED",
        "打开了_": "OPENED",
        "未发送_": "UNSENT",
        "XML序列化程序": "XMLSerializer",
        "序列化为文字": "serializeToString",
        "X路径计算": "XPathEvaluator",
        "真假值": "booleanValue",
        "无效迭代器状态": "invalidIteratorState",
        "数字值": "numberValue",
        "结果类型": "resultType",
        "单节点值": "singleNodeValue",
        "快照长度": "snapshotLength",
        "字符串值": "stringValue",
        "迭代下个": "iterateNext",
        "快照项目": "snapshotItem",
        "任何_类型": "ANY_TYPE",
        "任何_无序_节点_类型": "ANY_UNORDERED_NODE_TYPE",
        "真假_类型": "BOOLEAN_TYPE",
        "第一序_节点_类型": "FIRST_ORDERED_NODE_TYPE",
        "数字_类型": "NUMBER_TYPE",
        "有序节点_迭代器_类型": "ORDERED_NODE_ITERATOR_TYPE",
        "有序节点_快照_类型": "ORDERED_NODE_SNAPSHOT_TYPE",
        "字符串_类型": "STRING_TYPE",
        "无序节点_迭代器_类型": "UNORDERED_NODE_ITERATOR_TYPE",
        "无序节点_快照_类型": "UNORDERED_NODE_SNAPSHOT_TYPE",
        "XSLT处理器": "XSLTProcessor",
        "清晰参数": "clearParameters",
        "导入样式表": "importStylesheet",
        "移除参数": "removeParameter",
        "置参数": "setParameter",
        "转换到文档": "transformToDocument",
        "转换到片段": "transformToFragment",
        "WE_RTC对等连接": "webkitRTCPeerConnection",
        "体使用": "bodyUsed",
        "数组标识符": "arrayBuffer",
        "弧": "arc",
        "半径": "radius",
        "起始角": "startAngle",
        "结束角": "endAngle",
        "逆时针方向": "anticlockwise",
        "弧到": "arcTo",
        "Bezier曲线到": "bezierCurveTo",
        "闭合路径": "closePath",
        "线到": "lineTo",
        "二次曲线到": "quadraticCurveTo",
        "创建事件类": "createEvent",
        "事件接口": "eventInterface",
        "事件集类": "Events",
        "鼠标事件集": "MouseEvents",
        "突变事件集": "MutationEvents",
        "SVG放缩事件集": "SVGZoomEvents",
        "UI事件集": "UIEvents",
        "子元素计数": "childElementCount",
        "第一个子元素": "firstElementChild",
        "最后一个子元素": "lastElementChild",
        "下一个兄弟姐妹元素": "nextElementSibling",
        "前一个兄弟姐妹元素": "previousElementSibling",
        "取SVG文档": "getSVGDocument",
        "引发指针取消": "onpointercancel",
        "引发指针按下": "onpointerdown",
        "引发指针确认": "onpointerenter",
        "引发指针离开": "onpointerleave",
        "引发指针移动": "onpointermove",
        "引发指针移出": "onpointerout",
        "引发指针悬停": "onpointerover",
        "引发指针松开": "onpointerup",
        "引发滚轮": "onwheel",
        "获取": "fetch",
        "CH离开": "chOff",
        "索引数据库": "indexedDB",
        "表": "sheet",
        "引发加载完成": "onloadend",
        "空的_": "EMPTY",
        "MS保存二进制对象": "msSaveBlob",
        "默认名称": "defaultName",
        "MS保存或打开二进制对象": "msSaveOrOpenBlob",
        "确认站点特定跟踪异常": "confirmSiteSpecificTrackingException",
        "确认网络范围跟踪异常": "confirmWebWideTrackingException",
        "移除站点特定跟踪异常": "removeSiteSpecificTrackingException",
        "移除网络范围跟踪异常": "removeWebWideTrackingException",
        "存储站点特定跟踪异常": "storeSiteSpecificTrackingException",
        "存储网络跟踪异常": "storeWebWideTrackingException",
        "发送信标": "sendBeacon",
        "体初始化": "BodyInit",
        "地理位置": "geolocation",
        "应用代码名称": "appCodeName",
        "应用名称": "appName",
        "应用版本": "appVersion",
        "平台": "platform",
        "产品": "product",
        "产品细分": "productSub",
        "用户代理": "userAgent",
        "供应商": "vendor",
        "供应商细分": "vendorSub",
        "引发行": "onLine",
        "媒体设备": "mediaDevices",
        "导航用户媒体成功回调": "NavigatorUserMediaSuccessCallback",
        "用户媒体错误回调": "NavigatorUserMediaErrorCallback",
        "查询选择器": "querySelector",
        "元素标签名称映射": "ElementTagNameMap",
        "查询选择所有": "querySelectorAll",
        "取随机值": "getRandomValues",
        "动画点集": "animatedPoints",
        "点集": "points",
        "视图框": "viewBox",
        "需要扩展": "requiredExtensions",
        "要求特性": "requiredFeatures",
        "系统语言": "systemLanguage",
        "有延伸": "hasExtension",
        "扩展名": "extension",
        "解码基64": "atob",
        "编码字符串": "encodedString",
        "编码基64": "btoa",
        "原始字符串": "rawString",
        "控制台": "console",
        "本地存储": "localStorage",
        "会话存储": "sessionStorage",
        "窗口定时器扩展": "WindowTimersExtension",
        "清除间隔": "clearInterval",
        "清除超时": "clearTimeout",
        "置间隔": "setInterval",
        "处理程序": "handler",
        "置超时": "setTimeout",
        "清除立刻访问": "clearImmediate",
        "置立刻访问": "setImmediate",
        "引发超时": "ontimeout",
        "所在列": "conlno",
        "要经常阅读": "willReadFrequently",
        "特性": "attribute",
        "取所有": "getAll",
        "T节点": "TNode",
        "事件监听者对象": "EventListenerObject",
        "处理事件": "handleEvent",
        "滚动选项集": "ScrollOptions",
        "滚动行为": "ScrollBehavior",
        "块": "block",
        "滚动逻辑位置": "ScrollLogicalPosition",
        "在行里": "inline",
        "数据类型": "dataType",
        "IDB数组键": "IDBArrayKey",
        "RSA键段参数集": "RsaKeyGenParams",
        "模数长度": "modulusLength",
        "公开指数": "publicExponent",
        "RSA键算法": "RsaKeyAlgorithm",
        "RSA键哈希算法": "RsaHashedKeyAlgorithm",
        "盐长度": "saltLength",
        "命名曲线": "namedCurve",
        "EC键算法": "EcKeyAlgorithm",
        "类型曲线": "typedCurve",
        "计数器": "counter",
        "AES键算法": "AesKeyAlgorithm",
        "附加数据": "additionalData",
        "标签长度": "tagLength",
        "HMAC键算法": "HmacKeyAlgorithm",
        "首要": "prime",
        "发动机": "generator",
        "DH键算法": "DhKeyAlgorithm",
        "算法ID": "algorithmId",
        "当事人U信息": "partyUInfo",
        "当事人V信息": "partyVInfo",
        "公开信息": "publicInfo",
        "私有信息": "privateInfo",
        "盐": "salt",
        "迭代集": "iterations",
        "RSA其他素数信息": "RsaOtherPrimesInfo",
        "键_选项集": "key_ops",
        "引述": "q",
        "_样式表": "stylesheets",
        "元素从点": "elementsFromPoint",
        "代表们焦点": "delegatesFocus",
        "指定节点": "assignedNodes",
        "指定节点选项集": "AssignedNodesOptions",
        "扁平化": "flatten",
        "元素定义选项集": "ElementDefinitionOptions",
        "定义": "define",
        "当定义": "whenDefined",
        "预设拒绝事件类": "PromiseRejectionEvent",
        "预设": "promise",
        "预设拒绝事件初始化": "PromiseRejectionEventInit",
        "_媒体查询列表": "mql",
        "MS不安全函数回调": "MSUnsafeFunctionCallback",
        "突变": "mutations",
        "观察者": "observer",
        "解码后数据": "decodedData",
        "报告": "report",
        "条目集": "entries",
        "小程序": "applet",
        "音频标签": "Audio",
        "图像标签": "Image",
        "选项标签": "Option",
        "字节文字": "ByteString",
        "约束真假": "ConstrainBoolean",
        "约束DOM文字": "ConstrainDOMString",
        "约束双精度": "ConstrainDouble",
        "约束长度": "ConstrainLong",
        "数据加密操作": "CryptoOperationData",
        "GL比特组": "GLbitfield",
        "GL真假": "GLboolean",
        "GL字节": "GLbyte",
        "GL精度浮点": "GLclampf",
        "GL枚举": "GLenum",
        "GL浮点": "GLfloat",
        "GL整数": "GLint",
        "GL整数指针": "GLintptr",
        "GL短整数": "GLshort",
        "GL大小": "GLsizei",
        "GL大小指针": "GLsizeiptr",
        "GL无符号字节": "GLubyte",
        "GL无符号整数": "GLuint",
        "GL无符号短整数": "GLushort",
        "头文件初始化": "HeadersInit",
        "键格式化": "KeyFormat",
        "键类型": "KeyType",
        "键用房": "KeyUsage",
        "MS入站有效负载": "MSInboundPayload",
        "MS客户端事件类": "MSLocalClientEvent",
        "MS出站有效载荷": "MSOutboundPayload",
        "RTC信令收集候选人": "RTCIceGatherCandidate",
        "RTC传输": "RTCTransport",
        "载荷类型": "payloadtype",
        "自动": "auto",
        "瞬间": "instant",
        "光滑": "smooth",
        "最近的": "nearest",
        "鼠标滚轮事件类": "MouseWheelEvent",
        "手册": "manual",
        "导入脚本": "importScripts",
        "自动控件对象": "ActiveXObject",
        "I文本书写器": "ITextWriter",
        "写类": "Write",
        "写行类": "WriteLine",
        "关闭类": "Close",
        "文本流基": "TextStreamBase",
        "列数": "Column",
        "行数": "Line",
        "文本流书写器": "TextStreamWriter",
        "写空白行": "WriteBlankLines",
        "插入行数": "intLines",
        "文本流读取器": "TextStreamReader",
        "读类": "Read",
        "字符数": "characters",
        "读全部": "ReadAll",
        "读行类": "ReadLine",
        "跳过": "Skip",
        "跳过行": "SkipLine",
        "位于行结束": "AtEndOfLine",
        "位于流结束": "AtEndOfStream",
        "脚本宿主": "WScript",
        "发射": "Echo",
        "输出错误": "StdErr",
        "标准输出": "StdOut",
        "增强参数集类": "Arguments",
        "项目": "Item",
        "脚背全名": "ScriptFullName",
        "退出类": "Quit",
        "退出代码": "exitCode",
        "构建版本": "BuildVersion",
        "全名": "FullName",
        "交互": "Interactive",
        "名称": "Name",
        "路径名": "Path",
        "脚本名": "ScriptName",
        "只读输入": "StdIn",
        "版本号": "Version",
        "连接基对象": "ConnectObject",
        "对象事件源": "objEventSource",
        "文本前缀": "strPrefix",
        "创建基对象": "CreateObject",
        "文本程序ID": "strProgID",
        "断开连接对象": "DisconnectObject",
        "取基对象": "GetObject",
        "文本参数": "strPathname",
        "睡眠": "Sleep",
        "初始时间": "intTime",
        "枚举器": "Enumerator",
        "位于结束位置": "atEnd",
        "首先移动": "moveFirst",
        "移动下个": "moveNext",
        "枚举器构造函数": "EnumeratorConstructor",
        "采集": "collection",
        "VB数组": "VBArray",
        "维度集": "dimensions",
        "唯度1索引": "dimension1Index",
        "唯度N索引集": "dimensionNIndexes",
        "下界限": "lbound",
        "唯度": "dimension",
        "上界限": "ubound",
        "转成数组": "toArray",
        "VB数组构造器": "VBArrayConstructor",
        "安全数组": "safeArray",
        "自动日期": "VarDate",
        "取自动日期": "getVarDate",
        "Node环境": "NodeJS",
        "暂停": "pause",
        "退出": "exit",
        "复制": "copy",
        "地址": "address",
        "元数据": "meta",
        "行": "line",
        "命令": "command",
        "联系": "link",
        "将译成密码": "encrypted",
        "流类": "Stream",
        "回车": "enter",
        "成就": "success",
        "脚本": "script",
    });

    export const 编译选项别名对照表 = createMapFromTemplate({
        "编译选项": "compilerOptions",
        "保存时编译": "compileOnSave",
        "帮助": "help",
        "CompileToCts": "转译Cts",
        "ChineseKeywords": "中文关键字",
        "CompileToTs": "转译Ts",
        "CompileToDcts": "转译声明",
        "EmitNoDictionaryIdentifiers": "输出无词典标识符",
        "DictionaryOnFileEnd": "词典在文件尾",
        "DictionaryNoRepeat": "词典不重复输出",
        "所有": "all",
        "版本": "version",
        "初始化": "init",
        "项目": "project",
        "错误样式": "pretty",
        "监控": "watch",
        "目标": "target",
        "模块": "module",
        "支持库": "lib",
        "允许JS": "allowJs",
        "检查JS": "checkJs",
        "输出声明文件": "declaration",
        "源码映射": "sourceMap",
        "输出文件": "outFile",
        "输出目录": "outDir",
        "根目录": "rootDir",
        "删除注释": "removeComments",
        "不输出": "noEmit",
        "引入帮助": "importHelpers",
        "低级迭代": "downlevelIteration",
        "是隔离模块": "isolatedModules",
        "严格": "strict",
        "有隐性通用型不输出": "noImplicitAny",
        "严格空检查": "strictNullChecks",
        "有隐性本对象不输出": "noImplicitThis",
        "严格模式": "alwaysStrict",
        "不允许未使用变量": "noUnusedLocals",
        "不允许未使用参数": "noUnusedParameters",
        "不允许无返回": "noImplicitReturns",
        "不允许贯穿": "noFallthroughCasesInSwitch",
        "模块解析": "moduleResolution",
        "基URL": "baseUrl",
        "路径集": "paths",
        "根目录集": "rootDirs",
        "类型根集": "typeRoots",
        "类型集": "types",
        "允许从未设置默认导出模块默认导入": "allowSyntheticDefaultImports",
        "源码根": "sourceRoot",
        "映射根": "mapRoot",
        "内联源映射": "inlineSourceMap",
        "内联源": "inlineSources",
        "试验装饰器": "experimentalDecorators",
        "试验装饰器元数据": "emitDecoratorMetadata",
        "JSX工厂": "jsxFactory",
        "诊断": "diagnostics",
        "详细诊断": "extendedDiagnostics",
        "生成模块解析日志": "traceResolution",
        "打印列表": "listFiles",
        "打印发射文件列表": "listEmittedFiles",
        "输出": "out",
        "REACT名称空间": "reactNamespace",
        "忽略默认库类型检查": "skipDefaultLibCheck",
        "设置编码": "charset",
        "输出BOM": "emitBOM",
        "本地化": "locale",
        "换行符": "newLine",
        "有错误截断": "noErrorTruncation",
        "不包含默认库": "noLib",
        "不包含引用": "noResolve",
        "不生成内部标签": "stripInternal",
        "禁用大小限制": "disableSizeLimit",
        "不隐式严格模式": "noImplicitUseStrict",
        "不输出助手": "noEmitHelpers",
        "有错误不输出": "noEmitOnError",
        "保留常量及枚举": "preserveConstEnums",
        "声明目录": "declarationDir",
        "忽略库类型检查": "skipLibCheck",
        "允许检测不到": "allowUnusedLabels",
        "允许未使用": "allowUnreachableCode",
        "阻止过度属性错误检查": "suppressExcessPropertyErrors",
        "阻止隐性通用型索引错误检查": "suppressImplicitAnyIndexErrors",
        "不允许不一致引用": "forceConsistentCasingInFileNames",
        "依赖最大深度": "maxNodeModuleJsDepth",
        "不使用严格通用检查": "noStrictGenericChecks",
        "插件": "plugins",
        "启用自动发现": "enableAutoDiscovery",
        "启用": "enable",
        "包含": "include",
        "排除": "exclude",
        "分类选项": "typingOptions",
        "类型收集": "typeAcquisition",
        "外部扩展": "extends",
        "文件集": "files"
    })
}
